var n = {
    EventType: {
      IDLE: "idle",
      CHANGED: "changed",
      IMPORTED: "imported",
      EXPORTED: "exported",
      CONVERTED: "converted",
      RENDERED: "rendered",
      LOADED: "loaded",
      UNDO: "undo",
      REDO: "redo",
      CLEAR: "clear",
      IMPORT: "import",
      SUPPORTED_IMPORT_MIMETYPES: "supportedImportMimeTypes",
      EXPORT: "export",
      CONVERT: "convert",
      ERROR: "error"
    },
    RecognitionType: {
      TEXT: "TEXT",
      MATH: "MATH",
      DIAGRAM: "DIAGRAM",
      RAWCONTENT: "Raw Content"
    },
    Protocol: {
      WEBSOCKET: "WEBSOCKET",
      REST: "REST"
    },
    ModelState: {
      INITIALIZING: "INITIALIZING",
      INITIALIZED: "INITIALIZED",
      EXPORTING: "EXPORTING",
      EXPORTED: "EXPORTED",
      PENDING: "PENDING",
      MODIFIED: "MODIFIED",
      ERROR: "ERROR"
    },
    Trigger: {
      QUIET_PERIOD: "QUIET_PERIOD",
      POINTER_UP: "POINTER_UP",
      DEMAND: "DEMAND"
    },
    Logger: {
      EDITOR: "editor",
      MODEL: "model",
      GRABBER: "grabber",
      RENDERER: "renderer",
      RECOGNIZER: "recognizer",
      EVENT: "event",
      UTIL: "util",
      SMARTGUIDE: "smartguide"
    },
    LogLevel: {
      TRACE: "TRACE",
      DEBUG: "DEBUG",
      INFO: "INFO",
      WARN: "WARN",
      ERROR: "ERROR"
    },
    Languages: {
      zh_CN: "Noto Sans CJK tc",
      zh_HK: "Noto Sans CJK tc",
      zh_TW: "Noto Sans CJK tc",
      ko_KR: "Noto Sans CJK kr",
      ja_JP: "Noto Sans CJK jp",
      default: "Open Sans"
    },
    Error: {
      NOT_REACHABLE: "MyScript recognition server is not reachable. Please reload once you are connected.",
      WRONG_CREDENTIALS: "Application credentials are invalid. Please check or regenerate your application key and hmackey.",
      TOO_OLD: "Session is too old. Max Session Duration Reached."
    },
    Exports: {
      JIIX: "application/vnd.myscript.jiix"
    }
  },
  i = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function unwrapExports(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function createCommonjsModule(n, i) {
  return n(i = {
    exports: {}
  }, i.exports), i.exports;
}
var a = (0, createCommonjsModule(function (n) {
    !function (i, a) {
      n.exports ? n.exports = a() : i.log = a();
    }(i, function () {
      var noop = function () {},
        n = "undefined",
        i = typeof window !== n && typeof window.navigator !== n && /Trident\/|MSIE /.test(window.navigator.userAgent),
        a = ["trace", "debug", "info", "warn", "error"];
      function bindMethod(n, i) {
        var a = n[i];
        if ("function" == typeof a.bind) return a.bind(n);
        try {
          return Function.prototype.bind.call(a, n);
        } catch (i) {
          return function () {
            return Function.prototype.apply.apply(a, [n, arguments]);
          };
        }
      }
      function traceForIE() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function realMethod(a) {
        return "debug" === a && (a = "log"), typeof console !== n && ("trace" === a && i ? traceForIE : void 0 !== console[a] ? bindMethod(console, a) : void 0 !== console.log ? bindMethod(console, "log") : noop);
      }
      function replaceLoggingMethods(n, i) {
        for (var s = 0; s < a.length; s++) {
          var c = a[s];
          this[c] = s < n ? noop : this.methodFactory(c, n, i);
        }
        this.log = this.debug;
      }
      function enableLoggingWhenConsoleArrives(i, a, s) {
        return function () {
          typeof console !== n && (replaceLoggingMethods.call(this, a, s), this[i].apply(this, arguments));
        };
      }
      function defaultMethodFactory(n, i, a) {
        return realMethod(n) || enableLoggingWhenConsoleArrives.apply(this, arguments);
      }
      function Logger(i, s, c) {
        var l,
          u = this,
          d = "loglevel";
        function getPersistedLevel() {
          var i;
          if (typeof window !== n) {
            try {
              i = window.localStorage[d];
            } catch (n) {}
            if (typeof i === n) try {
              var a = window.document.cookie,
                s = a.indexOf(encodeURIComponent(d) + "=");
              -1 !== s && (i = /^([^;]+)/.exec(a.slice(s))[1]);
            } catch (n) {}
            return void 0 === u.levels[i] && (i = void 0), i;
          }
        }
        i && (d += ":" + i), u.name = i, u.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, u.methodFactory = c || defaultMethodFactory, u.getLevel = function () {
          return l;
        }, u.setLevel = function (s, c) {
          if ("string" == typeof s && void 0 !== u.levels[s.toUpperCase()] && (s = u.levels[s.toUpperCase()]), !("number" == typeof s && s >= 0 && s <= u.levels.SILENT)) throw "log.setLevel() called with invalid level: " + s;
          if (l = s, !1 !== c && function persistLevelIfPossible(i) {
            var s = (a[i] || "silent").toUpperCase();
            if (typeof window !== n) {
              try {
                return void (window.localStorage[d] = s);
              } catch (n) {}
              try {
                window.document.cookie = encodeURIComponent(d) + "=" + s + ";";
              } catch (n) {}
            }
          }(s), replaceLoggingMethods.call(u, s, i), typeof console === n && s < u.levels.SILENT) return "No console available for logging";
        }, u.setDefaultLevel = function (n) {
          getPersistedLevel() || u.setLevel(n, !1);
        }, u.enableAll = function (n) {
          u.setLevel(u.levels.TRACE, n);
        }, u.disableAll = function (n) {
          u.setLevel(u.levels.SILENT, n);
        };
        var p = getPersistedLevel();
        null == p && (p = null == s ? "WARN" : s), u.setLevel(p, !1);
      }
      var s = new Logger(),
        c = {};
      s.getLogger = function getLogger(n) {
        if ("string" != typeof n || "" === n) throw new TypeError("You must supply a name when creating a logger.");
        var i = c[n];
        return i || (i = c[n] = new Logger(n, s.getLevel(), s.methodFactory)), i;
      };
      var l = typeof window !== n ? window.log : void 0;
      return s.noConflict = function () {
        return typeof window !== n && window.log === s && (window.log = l), s;
      }, s.getLoggers = function getLoggers() {
        return c;
      }, s;
    });
  }).noConflict)(),
  s = a.getLogger(n.Logger.EDITOR);
s.setDefaultLevel(n.LogLevel.ERROR);
a.getLogger(n.Logger.SMARTGUIDE);
s.setDefaultLevel(n.LogLevel.ERROR);
var c = a.getLogger(n.Logger.MODEL);
c.setDefaultLevel(n.LogLevel.ERROR);
var l = a.getLogger(n.Logger.GRABBER);
l.setDefaultLevel(n.LogLevel.ERROR);
var u = a.getLogger(n.Logger.RENDERER);
u.setDefaultLevel(n.LogLevel.ERROR);
var d = a.getLogger(n.Logger.RECOGNIZER);
d.setDefaultLevel(n.LogLevel.ERROR);
var p = a.getLogger(n.Logger.EVENT);
p.setDefaultLevel(n.LogLevel.ERROR), a.getLogger(n.Logger.UTIL).setDefaultLevel(n.LogLevel.ERROR), a.getLogger("test").setDefaultLevel(n.LogLevel.ERROR);
var h = createCommonjsModule(function (n) {
    function _typeof(i) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? n.exports = _typeof = function _typeof(n) {
        return typeof n;
      } : n.exports = _typeof = function _typeof(n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof(i);
    }
    n.exports = _typeof;
  }),
  f = createCommonjsModule(function (n, a) {
    var s = "__lodash_hash_undefined__",
      c = 9007199254740991,
      l = "[object Arguments]",
      u = "[object Function]",
      d = "[object Object]",
      p = /^\[object .+?Constructor\]$/,
      h = /^(?:0|[1-9]\d*)$/,
      f = {};
    f["[object Float32Array]"] = f["[object Float64Array]"] = f["[object Int8Array]"] = f["[object Int16Array]"] = f["[object Int32Array]"] = f["[object Uint8Array]"] = f["[object Uint8ClampedArray]"] = f["[object Uint16Array]"] = f["[object Uint32Array]"] = !0, f[l] = f["[object Array]"] = f["[object ArrayBuffer]"] = f["[object Boolean]"] = f["[object DataView]"] = f["[object Date]"] = f["[object Error]"] = f[u] = f["[object Map]"] = f["[object Number]"] = f[d] = f["[object RegExp]"] = f["[object Set]"] = f["[object String]"] = f["[object WeakMap]"] = !1;
    var g = "object" == typeof i && i && i.Object === Object && i,
      m = "object" == typeof self && self && self.Object === Object && self,
      v = g || m || Function("return this")(),
      y = a && !a.nodeType && a,
      b = y && n && !n.nodeType && n,
      x = b && b.exports === y,
      w = x && g.process,
      _ = function () {
        try {
          var n = b && b.require && b.require("util").types;
          return n || w && w.binding && w.binding("util");
        } catch (n) {}
      }(),
      S = _ && _.isTypedArray;
    function apply(n, i, a) {
      switch (a.length) {
        case 0:
          return n.call(i);
        case 1:
          return n.call(i, a[0]);
        case 2:
          return n.call(i, a[0], a[1]);
        case 3:
          return n.call(i, a[0], a[1], a[2]);
      }
      return n.apply(i, a);
    }
    var k,
      C = Array.prototype,
      P = Function.prototype,
      I = Object.prototype,
      T = v["__core-js_shared__"],
      M = P.toString,
      R = I.hasOwnProperty,
      L = (k = /[^.]+$/.exec(T && T.keys && T.keys.IE_PROTO || "")) ? "Symbol(src)_1." + k : "",
      A = I.toString,
      D = M.call(Object),
      j = RegExp("^" + M.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
      U = x ? v.Buffer : void 0,
      O = v.Symbol,
      z = v.Uint8Array,
      N = U ? U.allocUnsafe : void 0,
      W = function overArg(n, i) {
        return function (a) {
          return n(i(a));
        };
      }(Object.getPrototypeOf, Object),
      X = Object.create,
      H = I.propertyIsEnumerable,
      B = C.splice,
      G = O ? O.toStringTag : void 0,
      Y = function () {
        try {
          var n = getNative(Object, "defineProperty");
          return n({}, "", {}), n;
        } catch (n) {}
      }(),
      $ = U ? U.isBuffer : void 0,
      V = Math.max,
      K = Date.now,
      J = getNative(v, "Map"),
      q = getNative(Object, "create"),
      Z = function () {
        function object() {}
        return function (n) {
          if (!isObject(n)) return {};
          if (X) return X(n);
          object.prototype = n;
          var i = new object();
          return object.prototype = void 0, i;
        };
      }();
    function Hash(n) {
      var i = -1,
        a = null == n ? 0 : n.length;
      for (this.clear(); ++i < a;) {
        var s = n[i];
        this.set(s[0], s[1]);
      }
    }
    function ListCache(n) {
      var i = -1,
        a = null == n ? 0 : n.length;
      for (this.clear(); ++i < a;) {
        var s = n[i];
        this.set(s[0], s[1]);
      }
    }
    function MapCache(n) {
      var i = -1,
        a = null == n ? 0 : n.length;
      for (this.clear(); ++i < a;) {
        var s = n[i];
        this.set(s[0], s[1]);
      }
    }
    function Stack(n) {
      var i = this.__data__ = new ListCache(n);
      this.size = i.size;
    }
    function arrayLikeKeys(n, i) {
      var a = ne(n),
        s = !a && te(n),
        c = !a && !s && re(n),
        l = !a && !s && !c && oe(n),
        u = a || s || c || l,
        d = u ? function baseTimes(n, i) {
          for (var a = -1, s = Array(n); ++a < n;) s[a] = i(a);
          return s;
        }(n.length, String) : [],
        p = d.length;
      for (var h in n) !i && !R.call(n, h) || u && ("length" == h || c && ("offset" == h || "parent" == h) || l && ("buffer" == h || "byteLength" == h || "byteOffset" == h) || isIndex(h, p)) || d.push(h);
      return d;
    }
    function assignMergeValue(n, i, a) {
      (void 0 !== a && !eq(n[i], a) || void 0 === a && !(i in n)) && baseAssignValue(n, i, a);
    }
    function assignValue(n, i, a) {
      var s = n[i];
      R.call(n, i) && eq(s, a) && (void 0 !== a || i in n) || baseAssignValue(n, i, a);
    }
    function assocIndexOf(n, i) {
      for (var a = n.length; a--;) if (eq(n[a][0], i)) return a;
      return -1;
    }
    function baseAssignValue(n, i, a) {
      "__proto__" == i && Y ? Y(n, i, {
        configurable: !0,
        enumerable: !0,
        value: a,
        writable: !0
      }) : n[i] = a;
    }
    Hash.prototype.clear = function hashClear() {
      this.__data__ = q ? q(null) : {}, this.size = 0;
    }, Hash.prototype.delete = function hashDelete(n) {
      var i = this.has(n) && delete this.__data__[n];
      return this.size -= i ? 1 : 0, i;
    }, Hash.prototype.get = function hashGet(n) {
      var i = this.__data__;
      if (q) {
        var a = i[n];
        return a === s ? void 0 : a;
      }
      return R.call(i, n) ? i[n] : void 0;
    }, Hash.prototype.has = function hashHas(n) {
      var i = this.__data__;
      return q ? void 0 !== i[n] : R.call(i, n);
    }, Hash.prototype.set = function hashSet(n, i) {
      var a = this.__data__;
      return this.size += this.has(n) ? 0 : 1, a[n] = q && void 0 === i ? s : i, this;
    }, ListCache.prototype.clear = function listCacheClear() {
      this.__data__ = [], this.size = 0;
    }, ListCache.prototype.delete = function listCacheDelete(n) {
      var i = this.__data__,
        a = assocIndexOf(i, n);
      return !(a < 0) && (a == i.length - 1 ? i.pop() : B.call(i, a, 1), --this.size, !0);
    }, ListCache.prototype.get = function listCacheGet(n) {
      var i = this.__data__,
        a = assocIndexOf(i, n);
      return a < 0 ? void 0 : i[a][1];
    }, ListCache.prototype.has = function listCacheHas(n) {
      return assocIndexOf(this.__data__, n) > -1;
    }, ListCache.prototype.set = function listCacheSet(n, i) {
      var a = this.__data__,
        s = assocIndexOf(a, n);
      return s < 0 ? (++this.size, a.push([n, i])) : a[s][1] = i, this;
    }, MapCache.prototype.clear = function mapCacheClear() {
      this.size = 0, this.__data__ = {
        hash: new Hash(),
        map: new (J || ListCache)(),
        string: new Hash()
      };
    }, MapCache.prototype.delete = function mapCacheDelete(n) {
      var i = getMapData(this, n).delete(n);
      return this.size -= i ? 1 : 0, i;
    }, MapCache.prototype.get = function mapCacheGet(n) {
      return getMapData(this, n).get(n);
    }, MapCache.prototype.has = function mapCacheHas(n) {
      return getMapData(this, n).has(n);
    }, MapCache.prototype.set = function mapCacheSet(n, i) {
      var a = getMapData(this, n),
        s = a.size;
      return a.set(n, i), this.size += a.size == s ? 0 : 1, this;
    }, Stack.prototype.clear = function stackClear() {
      this.__data__ = new ListCache(), this.size = 0;
    }, Stack.prototype.delete = function stackDelete(n) {
      var i = this.__data__,
        a = i.delete(n);
      return this.size = i.size, a;
    }, Stack.prototype.get = function stackGet(n) {
      return this.__data__.get(n);
    }, Stack.prototype.has = function stackHas(n) {
      return this.__data__.has(n);
    }, Stack.prototype.set = function stackSet(n, i) {
      var a = this.__data__;
      if (a instanceof ListCache) {
        var s = a.__data__;
        if (!J || s.length < 199) return s.push([n, i]), this.size = ++a.size, this;
        a = this.__data__ = new MapCache(s);
      }
      return a.set(n, i), this.size = a.size, this;
    };
    var Q = function createBaseFor(n) {
      return function (i, a, s) {
        for (var c = -1, l = Object(i), u = s(i), d = u.length; d--;) {
          var p = u[n ? d : ++c];
          if (!1 === a(l[p], p, l)) break;
        }
        return i;
      };
    }();
    function baseGetTag(n) {
      return null == n ? void 0 === n ? "[object Undefined]" : "[object Null]" : G && G in Object(n) ? function getRawTag(n) {
        var i = R.call(n, G),
          a = n[G];
        try {
          n[G] = void 0;
          var s = !0;
        } catch (n) {}
        var c = A.call(n);
        s && (i ? n[G] = a : delete n[G]);
        return c;
      }(n) : function objectToString(n) {
        return A.call(n);
      }(n);
    }
    function baseIsArguments(n) {
      return isObjectLike(n) && baseGetTag(n) == l;
    }
    function baseIsNative(n) {
      return !(!isObject(n) || function isMasked(n) {
        return !!L && L in n;
      }(n)) && (isFunction(n) ? j : p).test(function toSource(n) {
        if (null != n) {
          try {
            return M.call(n);
          } catch (n) {}
          try {
            return n + "";
          } catch (n) {}
        }
        return "";
      }(n));
    }
    function baseKeysIn(n) {
      if (!isObject(n)) return function nativeKeysIn(n) {
        var i = [];
        if (null != n) for (var a in Object(n)) i.push(a);
        return i;
      }(n);
      var i = isPrototype(n),
        a = [];
      for (var s in n) ("constructor" != s || !i && R.call(n, s)) && a.push(s);
      return a;
    }
    function baseMerge(n, i, a, s, c) {
      n !== i && Q(i, function (l, u) {
        if (c || (c = new Stack()), isObject(l)) !function baseMergeDeep(n, i, a, s, c, l, u) {
          var p = safeGet(n, a),
            h = safeGet(i, a),
            f = u.get(h);
          if (f) return void assignMergeValue(n, a, f);
          var g = l ? l(p, h, a + "", n, i, u) : void 0,
            m = void 0 === g;
          if (m) {
            var v = ne(h),
              y = !v && re(h),
              b = !v && !y && oe(h);
            g = h, v || y || b ? ne(p) ? g = p : !function isArrayLikeObject(n) {
              return isObjectLike(n) && isArrayLike(n);
            }(p) ? y ? (m = !1, g = function cloneBuffer(n, i) {
              if (i) return n.slice();
              var a = n.length,
                s = N ? N(a) : new n.constructor(a);
              return n.copy(s), s;
            }(h, !0)) : b ? (m = !1, g = function cloneTypedArray(n, i) {
              var a = i ? function cloneArrayBuffer(n) {
                var i = new n.constructor(n.byteLength);
                return new z(i).set(new z(n)), i;
              }(n.buffer) : n.buffer;
              return new n.constructor(a, n.byteOffset, n.length);
            }(h, !0)) : g = [] : g = function copyArray(n, i) {
              var a = -1,
                s = n.length;
              i || (i = Array(s));
              for (; ++a < s;) i[a] = n[a];
              return i;
            }(p) : function isPlainObject(n) {
              if (!isObjectLike(n) || baseGetTag(n) != d) return !1;
              var i = W(n);
              if (null === i) return !0;
              var a = R.call(i, "constructor") && i.constructor;
              return "function" == typeof a && a instanceof a && M.call(a) == D;
            }(h) || te(h) ? (g = p, te(p) ? g = function toPlainObject(n) {
              return function copyObject(n, i, a, s) {
                var c = !a;
                a || (a = {});
                var l = -1,
                  u = i.length;
                for (; ++l < u;) {
                  var d = i[l],
                    p = s ? s(a[d], n[d], d, a, n) : void 0;
                  void 0 === p && (p = n[d]), c ? baseAssignValue(a, d, p) : assignValue(a, d, p);
                }
                return a;
              }(n, keysIn(n));
            }(p) : isObject(p) && !isFunction(p) || (g = function initCloneObject(n) {
              return "function" != typeof n.constructor || isPrototype(n) ? {} : Z(W(n));
            }(h))) : m = !1;
          }
          m && (u.set(h, g), c(g, h, s, l, u), u.delete(h));
          assignMergeValue(n, a, g);
        }(n, i, u, a, baseMerge, s, c);else {
          var p = s ? s(safeGet(n, u), l, u + "", n, i, c) : void 0;
          void 0 === p && (p = l), assignMergeValue(n, u, p);
        }
      }, keysIn);
    }
    function baseRest(n, i) {
      return ee(function overRest(n, i, a) {
        return i = V(void 0 === i ? n.length - 1 : i, 0), function () {
          for (var s = arguments, c = -1, l = V(s.length - i, 0), u = Array(l); ++c < l;) u[c] = s[i + c];
          c = -1;
          for (var d = Array(i + 1); ++c < i;) d[c] = s[c];
          return d[i] = a(u), apply(n, this, d);
        };
      }(n, i, identity), n + "");
    }
    function getMapData(n, i) {
      var a = n.__data__;
      return function isKeyable(n) {
        var i = typeof n;
        return "string" == i || "number" == i || "symbol" == i || "boolean" == i ? "__proto__" !== n : null === n;
      }(i) ? a["string" == typeof i ? "string" : "hash"] : a.map;
    }
    function getNative(n, i) {
      var a = function getValue(n, i) {
        return null == n ? void 0 : n[i];
      }(n, i);
      return baseIsNative(a) ? a : void 0;
    }
    function isIndex(n, i) {
      var a = typeof n;
      return !!(i = null == i ? c : i) && ("number" == a || "symbol" != a && h.test(n)) && n > -1 && n % 1 == 0 && n < i;
    }
    function isPrototype(n) {
      var i = n && n.constructor;
      return n === ("function" == typeof i && i.prototype || I);
    }
    function safeGet(n, i) {
      if (("constructor" !== i || "function" != typeof n[i]) && "__proto__" != i) return n[i];
    }
    var ee = function shortOut(n) {
      var i = 0,
        a = 0;
      return function () {
        var s = K(),
          c = 16 - (s - a);
        if (a = s, c > 0) {
          if (++i >= 800) return arguments[0];
        } else i = 0;
        return n.apply(void 0, arguments);
      };
    }(Y ? function (n, i) {
      return Y(n, "toString", {
        configurable: !0,
        enumerable: !1,
        value: (a = i, function () {
          return a;
        }),
        writable: !0
      });
      var a;
    } : identity);
    function eq(n, i) {
      return n === i || n != n && i != i;
    }
    var te = baseIsArguments(function () {
        return arguments;
      }()) ? baseIsArguments : function (n) {
        return isObjectLike(n) && R.call(n, "callee") && !H.call(n, "callee");
      },
      ne = Array.isArray;
    function isArrayLike(n) {
      return null != n && isLength(n.length) && !isFunction(n);
    }
    var re = $ || function stubFalse() {
      return !1;
    };
    function isFunction(n) {
      if (!isObject(n)) return !1;
      var i = baseGetTag(n);
      return i == u || "[object GeneratorFunction]" == i || "[object AsyncFunction]" == i || "[object Proxy]" == i;
    }
    function isLength(n) {
      return "number" == typeof n && n > -1 && n % 1 == 0 && n <= c;
    }
    function isObject(n) {
      var i = typeof n;
      return null != n && ("object" == i || "function" == i);
    }
    function isObjectLike(n) {
      return null != n && "object" == typeof n;
    }
    var oe = S ? function baseUnary(n) {
      return function (i) {
        return n(i);
      };
    }(S) : function baseIsTypedArray(n) {
      return isObjectLike(n) && isLength(n.length) && !!f[baseGetTag(n)];
    };
    function keysIn(n) {
      return isArrayLike(n) ? arrayLikeKeys(n, !0) : baseKeysIn(n);
    }
    var ie = function createAssigner(n) {
      return baseRest(function (i, a) {
        var s = -1,
          c = a.length,
          l = c > 1 ? a[c - 1] : void 0,
          u = c > 2 ? a[2] : void 0;
        for (l = n.length > 3 && "function" == typeof l ? (c--, l) : void 0, u && function isIterateeCall(n, i, a) {
          if (!isObject(a)) return !1;
          var s = typeof i;
          if ("number" == s ? isArrayLike(a) && isIndex(i, a.length) : "string" == s && (i in a)) return eq(a[i], n);
          return !1;
        }(a[0], a[1], u) && (l = c < 3 ? void 0 : l, c = 1), i = Object(i); ++s < c;) {
          var d = a[s];
          d && n(i, d, s, l);
        }
        return i;
      });
    }(function (n, i, a) {
      baseMerge(n, i, a);
    });
    function identity(n) {
      return n;
    }
    n.exports = ie;
  }),
  g = {
    recognitionParams: {
      type: "TEXT",
      protocol: "WEBSOCKET",
      server: {
        scheme: "https",
        host: "cloud.myscript.com",
        applicationKey: void 0,
        hmacKey: void 0,
        useWindowLocation: !1,
        websocket: {
          pingEnabled: !0,
          pingDelay: 3e4,
          maxPingLostCount: 10,
          autoReconnect: !0,
          maxRetryCount: 2,
          fileChunkSize: 3e5
        }
      },
      iink: {
        alwaysConnected: !0,
        lang: "en_US",
        export: {
          "image-resolution": 300,
          jiix: {
            "bounding-box": !1,
            strokes: !1,
            text: {
              chars: !1,
              words: !0
            }
          }
        },
        renderer: {
          debug: {
            "draw-text-boxes": !1,
            "draw-image-boxes": !1
          }
        },
        math: {
          mimeTypes: ["application/x-latex", "application/mathml+xml"],
          solver: {
            enable: !0,
            "fractional-part-digits": 3,
            "decimal-separator": ".",
            "rounding-mode": "half up",
            "angle-unit": "deg"
          },
          margin: {
            bottom: 10,
            left: 15,
            right: 15,
            top: 10
          }
        },
        text: {
          guides: {
            enable: !0
          },
          smartGuide: !0,
          smartGuideFadeOut: {
            enable: !1,
            duration: 1e4
          },
          mimeTypes: ["text/plain", "application/vnd.myscript.jiix"],
          margin: {
            top: 20,
            left: 10,
            right: 10
          }
        },
        diagram: {
          mimeTypes: ["application/vnd.myscript.jiix"],
          margin: {
            bottom: 10,
            left: 15,
            right: 15,
            top: 10
          }
        },
        "raw-content": {
          recognition: {
            text: !1,
            shape: !1
          }
        }
      }
    },
    listenerOptions: {
      capture: !1,
      passive: !0
    },
    undoRedoMaxStackSize: 20,
    xyFloatPrecision: 0,
    timestampFloatPrecision: 0,
    triggerDelay: 2e3,
    processDelay: 0,
    resizeTriggerDelay: 200,
    triggers: {
      exportContent: "POINTER_UP",
      addStrokes: "POINTER_UP"
    },
    restConversionState: "",
    renderingParams: {
      stroker: "quadratic",
      minHeight: 100,
      minWidth: 100
    }
  },
  m = Symbol("isProxy");
var v = createCommonjsModule(function (n, i) {
    n.exports = function (n) {
      function e(a) {
        if (i[a]) return i[a].exports;
        var s = i[a] = {
          i: a,
          l: !1,
          exports: {}
        };
        return n[a].call(s.exports, s, s.exports, e), s.l = !0, s.exports;
      }
      var i = {};
      return e.m = n, e.c = i, e.i = function (n) {
        return n;
      }, e.d = function (n, i, a) {
        e.o(n, i) || Object.defineProperty(n, i, {
          configurable: !1,
          enumerable: !0,
          get: a
        });
      }, e.n = function (n) {
        var i = n && n.__esModule ? function () {
          return n.default;
        } : function () {
          return n;
        };
        return e.d(i, "a", i), i;
      }, e.o = function (n, i) {
        return Object.prototype.hasOwnProperty.call(n, i);
      }, e.p = "", e(e.s = 1);
    }([function (n, i, a) {
      function o(n, i) {
        if (!(n instanceof i)) throw new TypeError("Cannot call a class as a function");
      }
      Object.defineProperty(i, "__esModule", {
        value: !0
      });
      var s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
          return typeof n;
        } : function (n) {
          return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
        },
        c = function t(n) {
          var i = this;
          o(this, t), this.toJSON = function (n) {
            if ("string" != typeof n) return console.error("Need a CSS string but given ", void 0 === n ? "undefined" : s(n), n), "Not a valid CSS..!";
            var a = {},
              c = void 0,
              l = void 0,
              u = void 0;
            try {
              n.split("{").forEach(function (n) {
                if (l = n.trim()) if (-1 === l.indexOf("}")) a[l] = {}, c = l;else {
                  l.substring(0, l.indexOf("}")).split(";").forEach(function (n) {
                    (u = n.split(":")) && 2 === u.length && (a[c][u[0].trim().replace(/^\"|\"$/g, "")] = i._trimSemiColon(u[1].trim().replace(/^\"|\"$/g, "")));
                  });
                  try {
                    (c = l.split("}")[1].trim()) && (a[c] = {});
                  } catch (n) {}
                }
              });
            } catch (n) {
              return "Not a valid CSS..!";
            }
            return a;
          }, this.toCSS = function (n) {
            if ("object" !== (void 0 === n ? "undefined" : s(n))) return console.error("Need a JSON object but given ", void 0 === n ? "undefined" : s(n), n), "Not a valid JSON..!";
            var i = "";
            try {
              for (var a in n) if (n.hasOwnProperty(a)) {
                for (var c in i += a + " {\n", n[a]) n[a].hasOwnProperty(c) && (i += c + ": " + n[a][c] + ";\n");
                i += "}\n";
              }
            } catch (n) {
              return "Not a valid JSON..!";
            }
            return i;
          }, this._trimSemiColon = function (n) {
            return ";" === n.slice(-1) ? n.slice(0, i.length - 1) : n;
          };
        };
      i.default = c;
    }, function (n, i, a) {
      n.exports = a(0).default;
    }]);
  }),
  y = unwrapExports(v),
  b = (v.JsonCSS, void 0),
  x = new y();
function toCSS(n) {
  var i = x.toCSS({
    css: n
  });
  return i.substring(6, i.length - 3);
}
var w = {
    ink: {
      color: "#000000",
      "-myscript-pen-width": 1,
      "-myscript-pen-fill-style": "none",
      "-myscript-pen-fill-color": "#FFFFFF00"
    },
    ".math": {
      "font-family": "STIXGeneral"
    },
    ".math-solved": {
      "font-family": "STIXGeneral",
      color: "#A8A8A8FF"
    },
    ".text": {
      "font-family": "Open Sans",
      "font-size": 10
    }
  },
  _ = new y();
function toCSS$1(n) {
  return _.toCSS(n);
}
var S = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9];
function roundFloat(n, i) {
  var a;
  return i || 0 === i ? (a = i > 10 ? S[10] : S[i], Math.round(n * a) / a) : n;
}
function extractPoint(n, i, a) {
  var s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
    c = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
    l = n;
  l.changedTouches && (l = l.changedTouches[0]);
  var u = i.getBoundingClientRect();
  return {
    x: roundFloat(l.clientX - u.left - i.clientLeft - c, a.xyFloatPrecision),
    y: roundFloat(l.clientY - u.top - i.clientTop - s, a.xyFloatPrecision),
    t: roundFloat(Date.now(), a.timestampFloatPrecision)
  };
}
var k = function prevent(n) {
  return n.preventDefault();
};
var C = Object.freeze({
  __proto__: null,
  attach: function attach(n, i) {
    var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
      s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
      c = 0;
    function unfocus() {
      "None" !== window.getSelection().type && window.getSelection().removeAllRanges();
    }
    function hideMenu(n) {
      var i = document.querySelector(".more-menu");
      return !(n.target.classList.contains("ellipsis") || n.target.classList.contains("more-menu") || n.target.classList.contains("options-label-button") || !i || "none" === i.style.display) && (i.style.display = "none", !0);
    }
    function hideCandidates(n) {
      var i = document.querySelector(".candidates");
      return !(n.target.classList.contains("candidates") || "SPAN" === n.target.tagName || !i || "none" === i.style.display) && (i.style.display = "none", !0);
    }
    function pointerDownHandler(c) {
      var u = c.target.id === i.domElement.id || c.target.classList.contains("ms-canvas");
      if (void 0 !== this.activePointerId) this.activePointerId === c.pointerId && l.trace("".concat(c.type, " event with the same id without any pointer up"), c.pointerId);else if (2 !== c.button && 2 !== c.buttons && u) {
        if (!hideMenu(c) && !hideCandidates(c)) {
          this.activePointerId = c.pointerId;
          var d = c.pointerId > 2147483647 ? -1 : c.pointerId;
          unfocus(), c.stopPropagation(), i.pointerDown(extractPoint(c, n, i.configuration, a, s), c.pointerType, d);
        }
      } else c.target.classList.contains("ellipsis") || c.target.classList.contains("tag-icon") ? (hideMenu(c), hideCandidates(c)) : (hideMenu(c), hideCandidates(c), this.smartGuidePointerDown = !0, this.downSmartGuidePoint = extractPoint(c, n, i.configuration));
    }
    function pointerMoveHandler(u) {
      if (void 0 !== this.activePointerId && this.activePointerId === u.pointerId) unfocus(), i.pointerMove(extractPoint(u, n, i.configuration, a, s));else if (this.smartGuidePointerDown) {
        var d = extractPoint(u, n, i.configuration, a, s),
          p = Math.abs(this.downSmartGuidePoint.x - d.x),
          h = Math.abs(this.downSmartGuidePoint.y - d.y);
        if (c = Math.max(p, c), p < 5 && h > 5 && c < 15 || p > 5 && h > 5 && c < 15) {
          this.activePointerId = u.pointerId;
          var f = u.pointerId > 2147483647 ? -1 : u.pointerId;
          unfocus(), i.pointerDown(this.downSmartGuidePoint, u.pointerType, f);
        }
      } else l.trace("".concat(u.type, " event from another pointerid (").concat(u.pointerId, ")"), this.activePointerId);
    }
    function pointerUpHandler(u) {
      c = 0, this.smartGuidePointerDown = !1;
      var d = ["smartguide", "prompter-text-container", "prompter-text", "tag-icon", "ellipsis"],
        p = ["ps__rail-x", "ps__thumb-x"],
        h = u.relatedTarget && (d.includes(u.relatedTarget.className) || p.includes(u.relatedTarget.className)),
        f = u.relatedTarget && u.target && (d.includes(u.target.className) || p.includes(u.target.className)),
        g = u.relatedTarget && u.target && ("SPAN" === u.target.tagName || "SPAN" === u.relatedTarget.tagName);
      h || f || g ? u.stopPropagation() : void 0 !== this.activePointerId && this.activePointerId === u.pointerId ? (this.activePointerId = void 0, u.stopPropagation(), i.pointerUp(extractPoint(u, n, i.configuration, a, s))) : l.trace("".concat(u.type, " event from another pointerid (").concat(u.pointerId, ")"), this.activePointerId);
    }
    var u = {
      options: i.configuration.listenerOptions,
      listeners: [{
        types: ["pointerdown"],
        listener: pointerDownHandler
      }, {
        types: ["pointermove"],
        listener: pointerMoveHandler
      }, {
        types: ["pointerup", "pointerout", "pointerleave", "pointercancel"],
        listener: pointerUpHandler
      }]
    };
    return l.debug("attaching listeners", u), u.listeners.forEach(function (i) {
      i.types.forEach(function (a) {
        return n.addEventListener(a, i.listener, u.options);
      });
    }), n.addEventListener("touchmove", k), document.documentElement.addEventListener("pointerdown", function () {}), u;
  },
  detach: function detach(n, i) {
    l.debug("detaching listeners", i), i.listeners.forEach(function (a) {
      a.types.forEach(function (s) {
        return n.removeEventListener(s, a.listener, i.options);
      });
    }), n.removeEventListener("touchmove", k), document.documentElement.removeEventListener("pointerdown", function () {});
  }
});
var P = function _arrayLikeToArray(n, i) {
  (null == i || i > n.length) && (i = n.length);
  for (var a = 0, s = new Array(i); a < i; a++) s[a] = n[a];
  return s;
};
var I = function _arrayWithoutHoles(n) {
  if (Array.isArray(n)) return P(n);
};
var T = function _iterableToArray(n) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(n)) return Array.from(n);
};
var M = function _unsupportedIterableToArray(n, i) {
  if (n) {
    if ("string" == typeof n) return P(n, i);
    var a = Object.prototype.toString.call(n).slice(8, -1);
    return "Object" === a && n.constructor && (a = n.constructor.name), "Map" === a || "Set" === a ? Array.from(a) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? P(n, i) : void 0;
  }
};
var R = function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var L = function _toConsumableArray(n) {
  return I(n) || T(n) || M(n) || R();
};
function drawStroke(n, i, a) {
  a && a.drawStroke(n, i);
}
var A = {
  table: "table",
  shape: "shape",
  recognizedShape: "recognizedShape",
  ellipse: "ellipse",
  line: "line"
};
function phi(n) {
  var i = (n + Math.PI) % (2 * Math.PI) - Math.PI;
  return i < -Math.PI && (i += 2 * Math.PI), i;
}
function drawArrowHead(n, i, a, s) {
  var c = phi(a + Math.PI * (7 / 8)),
    l = phi(a - Math.PI * (7 / 8)),
    u = n;
  u.save();
  try {
    u.fillStyle = u.strokeStyle, u.moveTo(i.x, i.y), u.beginPath(), u.lineTo(i.x + s * Math.cos(c), i.y + s * Math.sin(c)), u.lineTo(i.x + s * Math.cos(l), i.y + s * Math.sin(l)), u.lineTo(i.x, i.y), u.fill();
  } finally {
    u.restore();
  }
}
function drawShapeEllipse(n, i) {
  var a = function drawEllipseArc(n, i, a, s, c, l, u) {
    var d = Math.cos(c),
      p = Math.sin(c),
      h = d,
      f = p;
    d *= a, h *= s, p *= a, f *= s;
    var g = Math.floor(Math.abs(u) / .02),
      m = [];
    n.save();
    try {
      n.beginPath();
      for (var v = 0; v <= g; v++) {
        var y = l + v / g * u,
          b = Math.atan2(Math.sin(y) / s, Math.cos(y) / a),
          x = Math.cos(b),
          w = Math.sin(b),
          _ = i.x + d * x - f * w,
          S = i.y + h * w + p * x;
        0 === v ? n.moveTo(_, S) : n.lineTo(_, S), 0 !== v && v !== g || m.push({
          x: _,
          y: S
        });
      }
      n.stroke();
    } finally {
      n.restore();
    }
    return m;
  }(n, i.center, i.maxRadius, i.minRadius, i.orientation, i.startAngle, i.sweepAngle);
  i.beginDecoration && "ARROW_HEAD" === i.beginDecoration && drawArrowHead(n, a[0], i.beginTangentAngle, 12), i.endDecoration && "ARROW_HEAD" === i.endDecoration && drawArrowHead(n, a[1], i.endTangentAngle, 12);
}
function drawLine(n, i, a) {
  n.save();
  try {
    n.beginPath(), n.moveTo(i.x, i.y), n.lineTo(a.x, a.y), n.stroke();
  } finally {
    n.restore();
  }
}
function drawShapeSymbol(n, i) {
  u.debug("draw ".concat(i.type, " symbol"));
  var a = n;
  a.save();
  try {
    if (a.lineWidth = i.width, a.strokeStyle = i.color, i.elementType) switch (i.elementType) {
      case A.shape:
        drawShapeSymbol(a, i.candidates[i.selectedCandidateIndex]);
        break;
      case A.table:
        i.lines.forEach(function (n) {
          return drawShapeSymbol(a, n);
        });
        break;
      case A.line:
        drawLine(a, i.data.p1, i.data.p2);
        break;
      default:
        u.error("".concat(i.elementType, " not implemented"));
    } else switch (i.type) {
      case A.ellipse:
        drawShapeEllipse(a, i);
        break;
      case A.line:
        !function drawShapeLine(n, i) {
          drawLine(n, i.firstPoint, i.lastPoint), "ARROW_HEAD" === i.beginDecoration && drawArrowHead(n, i.firstPoint, i.beginTangentAngle, 12), "ARROW_HEAD" === i.endDecoration && drawArrowHead(n, i.lastPoint, i.endTangentAngle, 12);
        }(a, i);
        break;
      case A.recognizedShape:
        i.primitives.forEach(function (n) {
          return drawShapeSymbol(a, n);
        });
        break;
      default:
        u.error("".concat(i.type, " not implemented"));
    }
  } finally {
    a.restore();
  }
}
var D = {
  inputCharacter: "inputCharacter",
  char: "char",
  string: "string",
  textLine: "textLine"
};
function drawTextLine(n, i) {
  !function drawText(n, i, a) {
    var s = n;
    s.save();
    try {
      s.font = "".concat(a.textHeight, "px serif"), s.textAlign = "CENTER" === a.justificationType ? "center" : "left", s.textBaseline = "bottom", s.fillStyle = s.strokeStyle, s.fillText(i, a.topLeftPoint.x, a.topLeftPoint.y + a.height);
    } finally {
      s.restore();
    }
  }(n, i.label, i.data), i.underlineList.forEach(function (a) {
    !function drawUnderline(n, i, a, s) {
      var c = s.width / a.length;
      drawLine(n, {
        x: s.topLeftPoint.x + i.data.firstCharacter * c,
        y: s.topLeftPoint.y + s.height
      }, {
        x: s.topLeftPoint.x + i.data.lastCharacter * c,
        y: s.topLeftPoint.y + s.height
      });
    }(n, a, i.label, i.data);
  });
}
function computeDistance(n, i, a, s, c) {
  var l = Math.sqrt(Math.pow(i - s[c - 1], 2) + Math.pow(n - a[c - 1], 2));
  return isNaN(l) ? 0 : l;
}
function computeLength(n, i, a, s, c, l) {
  var u = c[l - 1] + computeDistance(n, i, a, s, l);
  return isNaN(u) ? 0 : u;
}
function createStrokeComponent(n) {
  return Object.assign({}, {
    type: "stroke",
    x: [],
    y: [],
    t: [],
    p: [],
    l: [],
    width: 0
  }, n);
}
function addPoint(n, i) {
  var a = n;
  return !function filterPointByAcquisitionDelta(n, i, a, s, c) {
    var l = 2 + c / 4,
      u = !1;
    return (0 === a.length || 0 === s.length || Math.abs(a[a.length - 1] - n) >= l || Math.abs(s[s.length - 1] - i) >= l) && (u = !0), u;
  }(i.x, i.y, a.x, a.y, a.width) ? c.trace("ignore filtered point", i) : (a.x.push(i.x), a.y.push(i.y), a.t.push(i.t), a.p.push(function computePressure(n, i, a, s, c, l) {
    var u = 1,
      d = computeDistance(n, i, a, s, l),
      p = computeLength(n, i, a, s, c, l);
    0 === p ? u = .5 : d === p ? u = 1 : d < 10 ? u = .2 + Math.pow(.1 * d, .4) : d > p - 10 && (u = .2 + Math.pow(.1 * (p - d), .4));
    var h = u * Math.max(.1, 1 - .1 * Math.sqrt(d));
    return isNaN(parseFloat(h)) ? .5 : h;
  }(i.x, i.y, a.x, a.y, a.l, a.x.length - 1)), a.l.push(computeLength(i.x, i.y, a.x, a.y, a.l, a.x.length - 1))), a;
}
function slice(n) {
  for (var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : n.x.length, s = createStrokeComponent({
      color: n.color,
      width: n.width
    }), c = i; c < a; c++) addPoint(s, {
    x: n.x[c],
    y: n.y[c],
    t: n.t[c]
  });
  return s;
}
function getPointByIndex(n, i) {
  var a;
  return void 0 !== i && i >= 0 && i < n.x.length && (a = {
    x: n.x[i],
    y: n.y[i],
    t: n.t[i],
    p: n.p[i],
    l: n.l[i]
  }), a;
}
function mergeBounds(n, i) {
  return {
    minX: Math.min(n.minX, i.minX),
    maxX: Math.max(n.maxX, i.maxX),
    minY: Math.min(n.minY, i.minY),
    maxY: Math.max(n.maxY, i.maxY)
  };
}
function getLineBounds(n) {
  return {
    minX: Math.min(n.firstPoint.x, n.lastPoint.x),
    maxX: Math.max(n.firstPoint.x, n.lastPoint.x),
    minY: Math.min(n.firstPoint.y, n.lastPoint.y),
    maxY: Math.max(n.firstPoint.y, n.lastPoint.y)
  };
}
function getEllipseBounds(n) {
  var i = Math.cos(n.orientation),
    a = Math.sin(n.orientation),
    s = i,
    c = a;
  i *= n.maxRadius, s *= n.minRadius, a *= n.maxRadius, c *= n.minRadius;
  for (var l = Math.abs(n.sweepAngle) / .02, u = [], d = [], p = 0; p <= l; p++) {
    var h = n.startAngle + p / l * n.sweepAngle,
      f = Math.atan2(Math.sin(h) / n.minRadius, Math.cos(h) / n.maxRadius),
      g = Math.cos(f),
      m = Math.sin(f);
    u.push(n.center.x + (i * g - c * m)), d.push(n.center.y + (s * m + a * g));
  }
  return {
    minX: Math.min.apply(Math, u),
    maxX: Math.max.apply(Math, u),
    minY: Math.min.apply(Math, d),
    maxY: Math.max.apply(Math, d)
  };
}
function getTextLineBounds(n) {
  return {
    minX: n.data.topLeftPoint.x,
    maxX: n.data.topLeftPoint.x + n.data.width,
    minY: n.data.topLeftPoint.y,
    maxY: n.data.topLeftPoint.y + n.data.height
  };
}
function getClefBounds(n) {
  return {
    minX: n.boundingBox.x,
    maxX: n.boundingBox.x + n.boundingBox.width,
    minY: n.boundingBox.y,
    maxY: n.boundingBox.y + n.boundingBox.height
  };
}
function getStrokeBounds(n) {
  return {
    minX: Math.min.apply(Math, L(n.x)),
    maxX: Math.max.apply(Math, L(n.x)),
    minY: Math.min.apply(Math, L(n.y)),
    maxY: Math.max.apply(Math, L(n.y))
  };
}
function getSymbolsBounds(n) {
  var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
      minX: Number.MAX_VALUE,
      maxX: Number.MIN_VALUE,
      minY: Number.MAX_VALUE,
      maxY: Number.MIN_VALUE
    },
    a = i;
  return a = n.filter(function (n) {
    return "stroke" === n.type;
  }).map(getStrokeBounds).reduce(mergeBounds, a), a = n.filter(function (n) {
    return "clef" === n.type;
  }).map(getClefBounds).reduce(mergeBounds, a), a = n.filter(function (n) {
    return "line" === n.type;
  }).map(getLineBounds).reduce(mergeBounds, a), a = n.filter(function (n) {
    return "ellipse" === n.type;
  }).map(getEllipseBounds).reduce(mergeBounds, a), a = n.filter(function (n) {
    return "textLine" === n.type;
  }).map(getTextLineBounds).reduce(mergeBounds, a);
}
function createModel(n) {
  return {
    currentStroke: void 0,
    rawStrokes: [],
    strokeGroups: [],
    lastPositions: {
      lastSentPosition: -1,
      lastReceivedPosition: -1,
      lastRenderedPosition: -1
    },
    defaultSymbols: [],
    recognizedSymbols: void 0,
    exports: void 0,
    rawResults: {
      convert: void 0,
      exports: void 0
    },
    creationTime: new Date().getTime(),
    modificationTime: void 0
  };
}
function clearModel(n) {
  var i = n;
  return i.currentStroke = void 0, i.rawStrokes = [], i.strokeGroups = [], i.lastPositions.lastSentPosition = -1, i.lastPositions.lastReceivedPosition = -1, i.lastPositions.lastRenderedPosition = -1, i.recognizedSymbols = void 0, i.exports = void 0, i.rawResults.convert = void 0, i.rawResults.exports = void 0, i;
}
function needRedraw(n) {
  return !!n.recognizedSymbols && n.rawStrokes.length !== n.recognizedSymbols.filter(function (n) {
    return "stroke" === n.type;
  }).length;
}
function addStroke(n, i) {
  var a = n;
  return c.debug("addStroke", i), a.rawStrokes.push(i), a;
}
function addStrokeToGroup(n, i, a) {
  var s = n;
  c.debug("addStroke", i);
  var l = s.strokeGroups.length - 1;
  if (s.strokeGroups[l] && s.strokeGroups[l].penStyle === a) s.strokeGroups[l].strokes.push(i);else {
    var u = {
        penStyle: a,
        strokes: []
      },
      d = {};
    Object.assign(d, i), u.strokes.push(d), s.strokeGroups.push(u);
  }
  return s;
}
function extractPendingStrokes(n) {
  var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.lastPositions.lastReceivedPosition + 1;
  return n.rawStrokes.slice(i);
}
function initPendingStroke(n, i, a) {
  var s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 96;
  if (a && a["-myscript-pen-width"]) {
    var l = a["-myscript-pen-width"] * s / 25.4;
    Object.assign(a, {
      width: l / 2
    });
  }
  var u = n;
  return c.trace("initPendingStroke", i), u.currentStroke = createStrokeComponent(a), u.currentStroke = addPoint(u.currentStroke, i), u;
}
function appendToPendingStroke(n, i) {
  var a = n;
  return a.currentStroke && (c.trace("appendToPendingStroke", i), a.currentStroke = addPoint(a.currentStroke, i)), a;
}
function endPendingStroke(n, i, a) {
  var s = n;
  if (s.currentStroke) {
    c.trace("endPendingStroke", i);
    var l = addPoint(s.currentStroke, i);
    addStroke(s, l), addStrokeToGroup(s, l, a), delete s.currentStroke;
  }
  return s;
}
function getBorderCoordinates(n) {
  var i = {
    minX: Number.MAX_VALUE,
    maxX: Number.MIN_VALUE,
    minY: Number.MAX_VALUE,
    maxY: Number.MIN_VALUE
  };
  return n.defaultSymbols && n.defaultSymbols.length > 0 && (i = getSymbolsBounds(n.defaultSymbols, i)), n.recognizedSymbols && n.recognizedSymbols.length > 0 ? (i = getSymbolsBounds(n.recognizedSymbols, i), i = getSymbolsBounds(extractPendingStrokes(n), i)) : i = getSymbolsBounds(n.rawStrokes, i), i;
}
function updateModelSentPosition(n) {
  var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.rawStrokes.length - 1,
    a = n;
  return a.lastPositions.lastSentPosition = i, a;
}
function updateModelReceivedPosition(n) {
  var i = n;
  return i.lastPositions.lastReceivedPosition = i.lastPositions.lastSentPosition, i;
}
function resetModelPositions(n) {
  var i = n;
  return i.lastPositions.lastSentPosition = -1, i.lastPositions.lastReceivedPosition = -1, i;
}
function updateModelRenderedPosition(n) {
  var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.recognizedSymbols ? n.recognizedSymbols.length - 1 : -1,
    a = n;
  return a.lastPositions.lastRenderedPosition = i, a;
}
function extractPendingRecognizedSymbols(n) {
  var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n.lastPositions.lastRenderedPosition + 1;
  return n.recognizedSymbols ? n.recognizedSymbols.slice(i) : [];
}
function cloneModel(n) {
  var i = Object.assign({}, n);
  return i.defaultSymbols = L(n.defaultSymbols), i.currentStroke = n.currentStroke ? Object.assign({}, n.currentStroke) : void 0, i.rawStrokes = L(n.rawStrokes), i.strokeGroups = JSON.parse(JSON.stringify(n.strokeGroups)), i.lastPositions = Object.assign({}, n.lastPositions), i.exports = n.exports ? Object.assign({}, n.exports) : void 0, i.rawResults = Object.assign({}, n.rawResults), i.recognizedSymbols = n.recognizedSymbols ? L(n.recognizedSymbols) : void 0, i;
}
function mergeModels() {
  for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++) i[a] = arguments[a];
  return i.reduce(function (n, i) {
    var a = n;
    return a.recognizedSymbols = i.recognizedSymbols, a.lastPositions.lastSentPosition = i.lastPositions.lastSentPosition, a.lastPositions.lastReceivedPosition = i.lastPositions.lastReceivedPosition, a.lastPositions.lastRenderedPosition = i.lastPositions.lastRenderedPosition, a.rawResults = i.rawResults, a.exports = i.exports, a;
  });
}
var j = Object.freeze({
  __proto__: null,
  createModel: createModel,
  clearModel: clearModel,
  needRedraw: needRedraw,
  addStroke: addStroke,
  addStrokeToGroup: addStrokeToGroup,
  extractPendingStrokes: extractPendingStrokes,
  initPendingStroke: initPendingStroke,
  appendToPendingStroke: appendToPendingStroke,
  endPendingStroke: endPendingStroke,
  getBorderCoordinates: getBorderCoordinates,
  extractStrokesFromInkRange: function extractStrokesFromInkRange(n, i, a, s, c) {
    return n.rawStrokes.slice(i, a + 1).map(function (n, i, a) {
      return a.length < 2 ? slice(n, s, c + 1) : 0 === i ? slice(n, s) : i === a.length - 1 ? slice(n, 0, c + 1) : n;
    });
  },
  updateModelSentPosition: updateModelSentPosition,
  updateModelReceivedPosition: updateModelReceivedPosition,
  resetModelPositions: resetModelPositions,
  resetModelRendererPosition: function resetModelRendererPosition(n) {
    var i = n;
    return i.lastPositions.lastRenderedPosition = -1, i;
  },
  updateModelRenderedPosition: updateModelRenderedPosition,
  extractPendingRecognizedSymbols: extractPendingRecognizedSymbols,
  cloneModel: cloneModel,
  mergeModels: mergeModels
});
function detectPixelRatio(n) {
  return function getPixelRatio(n) {
    if (n) {
      var i = n.getContext("2d");
      return (window.devicePixelRatio || 1) / (i.webkitBackingStorePixelRatio || i.mozBackingStorePixelRatio || i.msBackingStorePixelRatio || i.oBackingStorePixelRatio || i.backingStorePixelRatio || 1);
    }
    return 1;
  }(document.createElement("canvas"));
}
function createCanvas(n, i) {
  var a = document.createElement("canvas");
  return a.classList.add(i), a.classList.add("ms-canvas"), n.appendChild(a), u.debug("canvas created", a), a;
}
function resizeContent(n) {
  return [n.renderingCanvas, n.capturingCanvas].forEach(function (i) {
    var a = i.parentNode,
      s = a.clientWidth < n.minWidth ? n.minWidth : a.clientWidth,
      c = a.clientHeight < n.minHeight ? n.minHeight : a.clientHeight;
    i.width = s * n.pixelRatio, i.height = c * n.pixelRatio, i.style.width = "".concat(s, "px"), i.style.height = "".concat(c, "px"), i.getContext("2d").scale(n.pixelRatio, n.pixelRatio), u.debug("canvas size changed", i);
  }), n;
}
function drawSymbol(n, i, a) {
  var s = i.elementType ? i.elementType : i.type;
  u.trace("attempting to draw ".concat(s, " symbol")), "stroke" === s ? drawStroke(n, i, a) : D[s] ? function drawTextSymbol(n, i) {
    u.debug("draw ".concat(i.type, " symbol"));
    var a = n;
    a.save();
    try {
      if (a.lineWidth = i.width, a.strokeStyle = i.color, i.elementType) switch (i.elementType) {
        case D.textLine:
          drawTextLine(a, i);
          break;
        default:
          u.error("".concat(i.elementType, " not implemented"));
      } else switch (i.type) {
        case D.textLine:
          drawTextLine(a, i);
          break;
        default:
          u.error("".concat(i.type, " not implemented"));
      }
    } finally {
      a.restore();
    }
  }(n, i) : A[s] ? drawShapeSymbol(n, i) : u.warn("impossible to draw ".concat(s, " symbol"));
}
function drawModel(n, i, a) {
  n.renderingCanvasContext.clearRect(0, 0, n.renderingCanvas.width, n.renderingCanvas.height);
  var s = L(i.defaultSymbols);
  return i.recognizedSymbols ? (s.push.apply(s, L(i.recognizedSymbols)), s.push.apply(s, L(extractPendingStrokes(i)))) : s.push.apply(s, L(i.rawStrokes)), s.forEach(function (i) {
    return drawSymbol(n.renderingCanvasContext, i, a);
  }), n.capturingCanvasContext.clearRect(0, 0, n.capturingCanvas.width, n.capturingCanvas.height), i;
}
var U = Object.freeze({
  __proto__: null,
  getInfo: function getInfo() {
    return {
      type: "canvas"
    };
  },
  attach: function attach$1(n) {
    var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
      a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
    u.debug("attach renderer", n);
    var s = detectPixelRatio(),
      c = createCanvas(n, "ms-rendering-canvas"),
      l = createCanvas(n, "ms-capture-canvas"),
      d = {
        pixelRatio: s,
        minHeight: i,
        minWidth: a,
        renderingCanvas: c,
        renderingCanvasContext: c.getContext("2d"),
        capturingCanvas: l,
        capturingCanvasContext: l.getContext("2d")
      };
    return resizeContent(d);
  },
  detach: function detach$1(n, i) {
    u.debug("detach renderer", n), n.removeChild(i.renderingCanvas), n.removeChild(i.capturingCanvas);
  },
  resize: function resize(n, i, a) {
    return this.drawModel(resizeContent(n), i, a);
  },
  drawCurrentStroke: function drawCurrentStroke(n, i, a) {
    return n.capturingCanvasContext.clearRect(0, 0, n.capturingCanvas.width, n.capturingCanvas.height), u.trace("drawing current stroke ", i.currentStroke), drawStroke(n.capturingCanvasContext, i.currentStroke, a), i;
  },
  drawModel: drawModel
});
function computeLinksPoints(n, i, a) {
  var s = n.p * a;
  return [{
    x: n.x - Math.sin(i) * s,
    y: n.y + Math.cos(i) * s
  }, {
    x: n.x + Math.sin(i) * s,
    y: n.y - Math.cos(i) * s
  }];
}
function computeMiddlePoint(n, i) {
  return {
    x: (i.x + n.x) / 2,
    y: (i.y + n.y) / 2,
    p: (i.p + n.p) / 2
  };
}
function computeAxeAngle(n, i) {
  return Math.atan2(i.y - n.y, i.x - n.x);
}
function renderArc(n, i, a) {
  n.arc(i.x, i.y, a, 0, 2 * Math.PI, !0);
}
function renderLine(n, i, a, s) {
  var c = computeLinksPoints(i, computeAxeAngle(i, a), s),
    l = computeLinksPoints(a, computeAxeAngle(i, a), s);
  n.moveTo(c[0].x, c[0].y), n.lineTo(l[0].x, l[0].y), n.lineTo(l[1].x, l[1].y), n.lineTo(c[1].x, c[1].y);
}
function renderQuadratic(n, i, a, s, c) {
  var l = computeLinksPoints(i, computeAxeAngle(i, s), c),
    u = computeLinksPoints(a, computeAxeAngle(s, a), c),
    d = computeLinksPoints(s, computeAxeAngle(i, a), c);
  n.moveTo(l[0].x, l[0].y), n.quadraticCurveTo(d[0].x, d[0].y, u[0].x, u[0].y), n.lineTo(u[1].x, u[1].y), n.quadraticCurveTo(d[1].x, d[1].y, l[1].x, l[1].y);
}
var O = Object.freeze({
    __proto__: null,
    getInfo: function getInfo$1() {
      return {
        type: "canvas",
        name: "quadratic"
      };
    },
    drawStroke: function drawStroke$1(n, i) {
      var a = n,
        s = i.x.length,
        c = i.width > 0 ? i.width : a.lineWidth,
        l = i.color ? i.color : a.strokeStyle,
        u = getPointByIndex(i, 0),
        d = s - 2;
      a.save();
      try {
        if (a.beginPath(), s < 3) renderArc(a, u, .6 * c);else {
          renderArc(a, u, c * u.p), renderLine(a, u, computeMiddlePoint(u, getPointByIndex(i, 1)), c);
          for (var p = 0; p < d; p++) renderQuadratic(a, computeMiddlePoint(getPointByIndex(i, p), getPointByIndex(i, p + 1)), computeMiddlePoint(getPointByIndex(i, p + 1), getPointByIndex(i, p + 2)), getPointByIndex(i, p + 1), c);
          renderLine(a, computeMiddlePoint(getPointByIndex(i, s - 2), getPointByIndex(i, s - 1)), getPointByIndex(i, s - 1), c), function renderFinal(n, i, a, s) {
            var c = computeAxeAngle(i, a),
              l = computeLinksPoints(a, c, s);
            n.moveTo(l[0].x, l[0].y);
            for (var u = 1; u <= 6; u++) {
              var d = c - u * Math.PI / 6;
              n.lineTo(a.x - a.p * s * Math.sin(d), a.y + a.p * s * Math.cos(d));
            }
          }(a, getPointByIndex(i, s - 2), getPointByIndex(i, s - 1), c);
        }
        a.closePath(), void 0 !== l && (a.fillStyle = l, a.fill());
      } finally {
        a.restore();
      }
    }
  }),
  z = "http://www.w3.org/1999/xhtml",
  N = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: z,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
function namespace(n) {
  var i = n += "",
    a = i.indexOf(":");
  return a >= 0 && "xmlns" !== (i = n.slice(0, a)) && (n = n.slice(a + 1)), N.hasOwnProperty(i) ? {
    space: N[i],
    local: n
  } : n;
}
function creatorInherit(n) {
  return function () {
    var i = this.ownerDocument,
      a = this.namespaceURI;
    return a === z && i.documentElement.namespaceURI === z ? i.createElement(n) : i.createElementNS(a, n);
  };
}
function creatorFixed(n) {
  return function () {
    return this.ownerDocument.createElementNS(n.space, n.local);
  };
}
function creator(n) {
  var i = namespace(n);
  return (i.local ? creatorFixed : creatorInherit)(i);
}
function none() {}
function selector(n) {
  return null == n ? none : function () {
    return this.querySelector(n);
  };
}
function empty() {
  return [];
}
function sparse(n) {
  return new Array(n.length);
}
function EnterNode(n, i) {
  this.ownerDocument = n.ownerDocument, this.namespaceURI = n.namespaceURI, this._next = null, this._parent = n, this.__data__ = i;
}
EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function (n) {
    return this._parent.insertBefore(n, this._next);
  },
  insertBefore: function (n, i) {
    return this._parent.insertBefore(n, i);
  },
  querySelector: function (n) {
    return this._parent.querySelector(n);
  },
  querySelectorAll: function (n) {
    return this._parent.querySelectorAll(n);
  }
};
function bindIndex(n, i, a, s, c, l) {
  for (var u, d = 0, p = i.length, h = l.length; d < h; ++d) (u = i[d]) ? (u.__data__ = l[d], s[d] = u) : a[d] = new EnterNode(n, l[d]);
  for (; d < p; ++d) (u = i[d]) && (c[d] = u);
}
function bindKey(n, i, a, s, c, l, u) {
  var d,
    p,
    h,
    f = {},
    g = i.length,
    m = l.length,
    v = new Array(g);
  for (d = 0; d < g; ++d) (p = i[d]) && (v[d] = h = "$" + u.call(p, p.__data__, d, i), h in f ? c[d] = p : f[h] = p);
  for (d = 0; d < m; ++d) (p = f[h = "$" + u.call(n, l[d], d, l)]) ? (s[d] = p, p.__data__ = l[d], f[h] = null) : a[d] = new EnterNode(n, l[d]);
  for (d = 0; d < g; ++d) (p = i[d]) && f[v[d]] === p && (c[d] = p);
}
function ascending(n, i) {
  return n < i ? -1 : n > i ? 1 : n >= i ? 0 : NaN;
}
function attrRemove(n) {
  return function () {
    this.removeAttribute(n);
  };
}
function attrRemoveNS(n) {
  return function () {
    this.removeAttributeNS(n.space, n.local);
  };
}
function attrConstant(n, i) {
  return function () {
    this.setAttribute(n, i);
  };
}
function attrConstantNS(n, i) {
  return function () {
    this.setAttributeNS(n.space, n.local, i);
  };
}
function attrFunction(n, i) {
  return function () {
    var a = i.apply(this, arguments);
    null == a ? this.removeAttribute(n) : this.setAttribute(n, a);
  };
}
function attrFunctionNS(n, i) {
  return function () {
    var a = i.apply(this, arguments);
    null == a ? this.removeAttributeNS(n.space, n.local) : this.setAttributeNS(n.space, n.local, a);
  };
}
function defaultView(n) {
  return n.ownerDocument && n.ownerDocument.defaultView || n.document && n || n.defaultView;
}
function styleRemove(n) {
  return function () {
    this.style.removeProperty(n);
  };
}
function styleConstant(n, i, a) {
  return function () {
    this.style.setProperty(n, i, a);
  };
}
function styleFunction(n, i, a) {
  return function () {
    var s = i.apply(this, arguments);
    null == s ? this.style.removeProperty(n) : this.style.setProperty(n, s, a);
  };
}
function styleValue(n, i) {
  return n.style.getPropertyValue(i) || defaultView(n).getComputedStyle(n, null).getPropertyValue(i);
}
function propertyRemove(n) {
  return function () {
    delete this[n];
  };
}
function propertyConstant(n, i) {
  return function () {
    this[n] = i;
  };
}
function propertyFunction(n, i) {
  return function () {
    var a = i.apply(this, arguments);
    null == a ? delete this[n] : this[n] = a;
  };
}
function classArray(n) {
  return n.trim().split(/^|\s+/);
}
function classList(n) {
  return n.classList || new ClassList(n);
}
function ClassList(n) {
  this._node = n, this._names = classArray(n.getAttribute("class") || "");
}
function classedAdd(n, i) {
  for (var a = classList(n), s = -1, c = i.length; ++s < c;) a.add(i[s]);
}
function classedRemove(n, i) {
  for (var a = classList(n), s = -1, c = i.length; ++s < c;) a.remove(i[s]);
}
function classedTrue(n) {
  return function () {
    classedAdd(this, n);
  };
}
function classedFalse(n) {
  return function () {
    classedRemove(this, n);
  };
}
function classedFunction(n, i) {
  return function () {
    (i.apply(this, arguments) ? classedAdd : classedRemove)(this, n);
  };
}
function textRemove() {
  this.textContent = "";
}
function textConstant(n) {
  return function () {
    this.textContent = n;
  };
}
function textFunction(n) {
  return function () {
    var i = n.apply(this, arguments);
    this.textContent = null == i ? "" : i;
  };
}
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(n) {
  return function () {
    this.innerHTML = n;
  };
}
function htmlFunction(n) {
  return function () {
    var i = n.apply(this, arguments);
    this.innerHTML = null == i ? "" : i;
  };
}
function raise() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function lower() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function constantNull() {
  return null;
}
function remove() {
  var n = this.parentNode;
  n && n.removeChild(this);
}
function selection_cloneShallow() {
  var n = this.cloneNode(!1),
    i = this.parentNode;
  return i ? i.insertBefore(n, this.nextSibling) : n;
}
function selection_cloneDeep() {
  var n = this.cloneNode(!0),
    i = this.parentNode;
  return i ? i.insertBefore(n, this.nextSibling) : n;
}
ClassList.prototype = {
  add: function (n) {
    this._names.indexOf(n) < 0 && (this._names.push(n), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function (n) {
    var i = this._names.indexOf(n);
    i >= 0 && (this._names.splice(i, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function (n) {
    return this._names.indexOf(n) >= 0;
  }
};
var W = {};
"undefined" != typeof document && ("onmouseenter" in document.documentElement || (W = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
}));
function filterContextListener(n, i, a) {
  return n = contextListener(n, i, a), function (i) {
    var a = i.relatedTarget;
    a && (a === this || 8 & a.compareDocumentPosition(this)) || n.call(this, i);
  };
}
function contextListener(n, i, a) {
  return function (s) {
    try {
      n.call(this, this.__data__, i, a);
    } finally {}
  };
}
function parseTypenames(n) {
  return n.trim().split(/^|\s+/).map(function (n) {
    var i = "",
      a = n.indexOf(".");
    return a >= 0 && (i = n.slice(a + 1), n = n.slice(0, a)), {
      type: n,
      name: i
    };
  });
}
function onRemove(n) {
  return function () {
    var i = this.__on;
    if (i) {
      for (var a, s = 0, c = -1, l = i.length; s < l; ++s) a = i[s], n.type && a.type !== n.type || a.name !== n.name ? i[++c] = a : this.removeEventListener(a.type, a.listener, a.capture);
      ++c ? i.length = c : delete this.__on;
    }
  };
}
function onAdd(n, i, a) {
  var s = W.hasOwnProperty(n.type) ? filterContextListener : contextListener;
  return function (c, l, u) {
    var d,
      p = this.__on,
      h = s(i, l, u);
    if (p) for (var f = 0, g = p.length; f < g; ++f) if ((d = p[f]).type === n.type && d.name === n.name) return this.removeEventListener(d.type, d.listener, d.capture), this.addEventListener(d.type, d.listener = h, d.capture = a), void (d.value = i);
    this.addEventListener(n.type, h, a), d = {
      type: n.type,
      name: n.name,
      value: i,
      listener: h,
      capture: a
    }, p ? p.push(d) : this.__on = [d];
  };
}
function dispatchEvent(n, i, a) {
  var s = defaultView(n),
    c = s.CustomEvent;
  "function" == typeof c ? c = new c(i, a) : (c = s.document.createEvent("Event"), a ? (c.initEvent(i, a.bubbles, a.cancelable), c.detail = a.detail) : c.initEvent(i, !1, !1)), n.dispatchEvent(c);
}
function dispatchConstant(n, i) {
  return function () {
    return dispatchEvent(this, n, i);
  };
}
function dispatchFunction(n, i) {
  return function () {
    return dispatchEvent(this, n, i.apply(this, arguments));
  };
}
var X = [null];
function Selection(n, i) {
  this._groups = n, this._parents = i;
}
function drawStroke$2(n, i, a) {
  a && a.drawStroke(n, i);
}
function insertAdjacentSVG(n, i, a) {
  var s = n.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "_");
  switch (s.innerHTML = a, i.toLowerCase()) {
    case "beforebegin":
      n.parentNode.insertBefore(s.firstChild, n);
      break;
    case "afterbegin":
      n.insertBefore(s.lastChild, n.firstChild);
      break;
    case "beforeend":
      n.appendChild(s.firstChild);
      break;
    case "afterend":
      n.parentNode.insertBefore(s.lastChild, n.nextSibling);
      break;
    default:
      u.warn("Invalid insertAdjacentHTML position");
  }
}
Selection.prototype = function selection() {
  return new Selection([[document.documentElement]], X);
}.prototype = {
  constructor: Selection,
  select: function selection_select(n) {
    "function" != typeof n && (n = selector(n));
    for (var i = this._groups, a = i.length, s = new Array(a), c = 0; c < a; ++c) for (var l, u, d = i[c], p = d.length, h = s[c] = new Array(p), f = 0; f < p; ++f) (l = d[f]) && (u = n.call(l, l.__data__, f, d)) && ("__data__" in l && (u.__data__ = l.__data__), h[f] = u);
    return new Selection(s, this._parents);
  },
  selectAll: function selection_selectAll(n) {
    "function" != typeof n && (n = function selectorAll(n) {
      return null == n ? empty : function () {
        return this.querySelectorAll(n);
      };
    }(n));
    for (var i = this._groups, a = i.length, s = [], c = [], l = 0; l < a; ++l) for (var u, d = i[l], p = d.length, h = 0; h < p; ++h) (u = d[h]) && (s.push(n.call(u, u.__data__, h, d)), c.push(u));
    return new Selection(s, c);
  },
  filter: function selection_filter(n) {
    "function" != typeof n && (n = function matcher(n) {
      return function () {
        return this.matches(n);
      };
    }(n));
    for (var i = this._groups, a = i.length, s = new Array(a), c = 0; c < a; ++c) for (var l, u = i[c], d = u.length, p = s[c] = [], h = 0; h < d; ++h) (l = u[h]) && n.call(l, l.__data__, h, u) && p.push(l);
    return new Selection(s, this._parents);
  },
  data: function selection_data(n, i) {
    if (!n) return v = new Array(this.size()), h = -1, this.each(function (n) {
      v[++h] = n;
    }), v;
    var a = i ? bindKey : bindIndex,
      s = this._parents,
      c = this._groups;
    "function" != typeof n && (n = function constant(n) {
      return function () {
        return n;
      };
    }(n));
    for (var l = c.length, u = new Array(l), d = new Array(l), p = new Array(l), h = 0; h < l; ++h) {
      var f = s[h],
        g = c[h],
        m = g.length,
        v = n.call(f, f && f.__data__, h, s),
        y = v.length,
        b = d[h] = new Array(y),
        x = u[h] = new Array(y);
      a(f, g, b, x, p[h] = new Array(m), v, i);
      for (var w, _, S = 0, k = 0; S < y; ++S) if (w = b[S]) {
        for (S >= k && (k = S + 1); !(_ = x[k]) && ++k < y;);
        w._next = _ || null;
      }
    }
    return (u = new Selection(u, s))._enter = d, u._exit = p, u;
  },
  enter: function selection_enter() {
    return new Selection(this._enter || this._groups.map(sparse), this._parents);
  },
  exit: function selection_exit() {
    return new Selection(this._exit || this._groups.map(sparse), this._parents);
  },
  join: function selection_join(n, i, a) {
    var s = this.enter(),
      c = this,
      l = this.exit();
    return s = "function" == typeof n ? n(s) : s.append(n + ""), null != i && (c = i(c)), null == a ? l.remove() : a(l), s && c ? s.merge(c).order() : c;
  },
  merge: function selection_merge(n) {
    for (var i = this._groups, a = n._groups, s = i.length, c = a.length, l = Math.min(s, c), u = new Array(s), d = 0; d < l; ++d) for (var p, h = i[d], f = a[d], g = h.length, m = u[d] = new Array(g), v = 0; v < g; ++v) (p = h[v] || f[v]) && (m[v] = p);
    for (; d < s; ++d) u[d] = i[d];
    return new Selection(u, this._parents);
  },
  order: function selection_order() {
    for (var n = this._groups, i = -1, a = n.length; ++i < a;) for (var s, c = n[i], l = c.length - 1, u = c[l]; --l >= 0;) (s = c[l]) && (u && 4 ^ s.compareDocumentPosition(u) && u.parentNode.insertBefore(s, u), u = s);
    return this;
  },
  sort: function selection_sort(n) {
    function compareNode(i, a) {
      return i && a ? n(i.__data__, a.__data__) : !i - !a;
    }
    n || (n = ascending);
    for (var i = this._groups, a = i.length, s = new Array(a), c = 0; c < a; ++c) {
      for (var l, u = i[c], d = u.length, p = s[c] = new Array(d), h = 0; h < d; ++h) (l = u[h]) && (p[h] = l);
      p.sort(compareNode);
    }
    return new Selection(s, this._parents).order();
  },
  call: function selection_call() {
    var n = arguments[0];
    return arguments[0] = this, n.apply(null, arguments), this;
  },
  nodes: function selection_nodes() {
    var n = new Array(this.size()),
      i = -1;
    return this.each(function () {
      n[++i] = this;
    }), n;
  },
  node: function selection_node() {
    for (var n = this._groups, i = 0, a = n.length; i < a; ++i) for (var s = n[i], c = 0, l = s.length; c < l; ++c) {
      var u = s[c];
      if (u) return u;
    }
    return null;
  },
  size: function selection_size() {
    var n = 0;
    return this.each(function () {
      ++n;
    }), n;
  },
  empty: function selection_empty() {
    return !this.node();
  },
  each: function selection_each(n) {
    for (var i = this._groups, a = 0, s = i.length; a < s; ++a) for (var c, l = i[a], u = 0, d = l.length; u < d; ++u) (c = l[u]) && n.call(c, c.__data__, u, l);
    return this;
  },
  attr: function selection_attr(n, i) {
    var a = namespace(n);
    if (arguments.length < 2) {
      var s = this.node();
      return a.local ? s.getAttributeNS(a.space, a.local) : s.getAttribute(a);
    }
    return this.each((null == i ? a.local ? attrRemoveNS : attrRemove : "function" == typeof i ? a.local ? attrFunctionNS : attrFunction : a.local ? attrConstantNS : attrConstant)(a, i));
  },
  style: function selection_style(n, i, a) {
    return arguments.length > 1 ? this.each((null == i ? styleRemove : "function" == typeof i ? styleFunction : styleConstant)(n, i, null == a ? "" : a)) : styleValue(this.node(), n);
  },
  property: function selection_property(n, i) {
    return arguments.length > 1 ? this.each((null == i ? propertyRemove : "function" == typeof i ? propertyFunction : propertyConstant)(n, i)) : this.node()[n];
  },
  classed: function selection_classed(n, i) {
    var a = classArray(n + "");
    if (arguments.length < 2) {
      for (var s = classList(this.node()), c = -1, l = a.length; ++c < l;) if (!s.contains(a[c])) return !1;
      return !0;
    }
    return this.each(("function" == typeof i ? classedFunction : i ? classedTrue : classedFalse)(a, i));
  },
  text: function selection_text(n) {
    return arguments.length ? this.each(null == n ? textRemove : ("function" == typeof n ? textFunction : textConstant)(n)) : this.node().textContent;
  },
  html: function selection_html(n) {
    return arguments.length ? this.each(null == n ? htmlRemove : ("function" == typeof n ? htmlFunction : htmlConstant)(n)) : this.node().innerHTML;
  },
  raise: function selection_raise() {
    return this.each(raise);
  },
  lower: function selection_lower() {
    return this.each(lower);
  },
  append: function selection_append(n) {
    var i = "function" == typeof n ? n : creator(n);
    return this.select(function () {
      return this.appendChild(i.apply(this, arguments));
    });
  },
  insert: function selection_insert(n, i) {
    var a = "function" == typeof n ? n : creator(n),
      s = null == i ? constantNull : "function" == typeof i ? i : selector(i);
    return this.select(function () {
      return this.insertBefore(a.apply(this, arguments), s.apply(this, arguments) || null);
    });
  },
  remove: function selection_remove() {
    return this.each(remove);
  },
  clone: function selection_clone(n) {
    return this.select(n ? selection_cloneDeep : selection_cloneShallow);
  },
  datum: function selection_datum(n) {
    return arguments.length ? this.property("__data__", n) : this.node().__data__;
  },
  on: function selection_on(n, i, a) {
    var s,
      c,
      l = parseTypenames(n + ""),
      u = l.length;
    if (!(arguments.length < 2)) {
      for (d = i ? onAdd : onRemove, null == a && (a = !1), s = 0; s < u; ++s) this.each(d(l[s], i, a));
      return this;
    }
    var d = this.node().__on;
    if (d) for (var p, h = 0, f = d.length; h < f; ++h) for (s = 0, p = d[h]; s < u; ++s) if ((c = l[s]).type === p.type && c.name === p.name) return p.value;
  },
  dispatch: function selection_dispatch(n, i) {
    return this.each(("function" == typeof i ? dispatchFunction : dispatchConstant)(n, i));
  }
};
var H = Object.freeze({
  __proto__: null,
  getInfo: function getInfo$2() {
    return {
      type: "svg"
    };
  },
  attach: function attach$2(n) {
    var i = n;
    return u.debug("populate root element", i), i.style.fontSize = "10px", function select(n) {
      return "string" == typeof n ? new Selection([[document.querySelector(n)]], [document.documentElement]) : new Selection([[n]], X);
    }(i);
  },
  detach: function detach$2(n, i) {
    u.debug("detach renderer", n), i.select("svg").remove();
  },
  resize: function resize$1(n, i, a, s, c) {
    var l = n.node().getBoundingClientRect(),
      d = n.selectAll("svg"),
      p = l.width < c ? c : l.width,
      h = l.height < s ? s : l.height;
    return d.attr("viewBox", "0 0 ".concat(p, ", ").concat(h)), d.attr("width", "".concat(p, "px")), d.attr("height", "".concat(h, "px")), u.debug("svg viewBox changed", d), i;
  },
  drawCurrentStroke: function drawCurrentStroke$1(n, i, a) {
    var s = i;
    return s.currentStroke.id = "pendingStroke-".concat(i.rawStrokes.length), u.trace("drawing current stroke ", i.currentStroke), n.select("#pendingStrokes #".concat(s.currentStroke.id)).remove(), drawStroke$2(n.select("#pendingStrokes").append("path").attr("id", i.currentStroke.id), i.currentStroke, a), s;
  },
  drawModel: function drawModel$1(n, i, a) {
    var s = extractPendingRecognizedSymbols(i);
    s && (s.forEach(function (i) {
      return function updateView(i) {
        i.updates.forEach(function (a) {
          try {
            var s = 'svg[data-layer="' + i.layer + '"]';
            switch (a.type) {
              case "REPLACE_ALL":
                n.select(s).remove();
                var c = n.node();
                c.insertAdjacentHTML ? c.insertAdjacentHTML("beforeEnd", a.svg) : insertAdjacentSVG(c, "beforeEnd", a.svg), "MODEL" === i.layer && n.select(s).append("g").attr("id", "pendingStrokes");
                break;
              case "REMOVE_ELEMENT":
                a.id.includes("s") || a.id.includes("MODEL") || n.select("#".concat(a.id)).attr("class", "removed-stroke"), n.select("#".concat(a.id)).remove();
                break;
              case "REPLACE_ELEMENT":
                var l = n.select("#".concat(a.id)).node().parentNode;
                n.select("#".concat(a.id)).remove(), l.insertAdjacentHTML ? l.insertAdjacentHTML("beforeEnd", a.svg) : (insertAdjacentSVG(l, "beforeEnd", a.svg), n.node().insertAdjacentHTML("beforeEnd", n.select(s).remove().node().outerHTML));
                break;
              case "REMOVE_CHILD":
                n.select("#".concat(a.parentId, " > *:nth-child(").concat(a.index + 1, ")")).remove();
                break;
              case "APPEND_CHILD":
                var d = n.select(a.parentId ? "#".concat(a.parentId) : s).node();
                d.insertAdjacentHTML ? d.insertAdjacentHTML("beforeEnd", a.svg) : (insertAdjacentSVG(d, "beforeEnd", a.svg), n.node().insertAdjacentHTML("beforeEnd", n.select(s).remove().node().outerHTML));
                break;
              case "INSERT_BEFORE":
                var p = n.select("#".concat(a.refId)).node();
                p.insertAdjacentHTML ? p.insertAdjacentHTML("beforeBegin", a.svg) : (insertAdjacentSVG(p, "beforeBegin", a.svg), n.node().insertAdjacentHTML("beforeEnd", n.select(s).remove().node().outerHTML));
                break;
              case "REMOVE_ATTRIBUTE":
                n.selectAll(a.id ? "#".concat(a.id) : "svg").attr(a.name, null);
                break;
              case "SET_ATTRIBUTE":
                a.id && n.selectAll("#".concat(a.id)).attr(a.name, a.value);
                break;
              default:
                u.debug("unknown update ".concat(a.type, " action"));
            }
          } catch (n) {
            u.error("Invalid update ".concat(a.type), a), u.error("Error on svg patch", n);
          }
        });
      }(i);
    }), updateModelRenderedPosition(i));
    var c = extractPendingStrokes(i);
    return c && c.forEach(function (i) {
      return function drawSymbol(n, i) {
        u.trace("attempting to draw ".concat(n.type, " symbol")), "stroke" !== n.type || i.select("id", n.id) ? u.warn("impossible to draw ".concat(n.type, " symbol")) : drawStroke$2(i.append("path").attr("id", n.id), n, a);
      }(i, n.select("#pendingStrokes"));
    }), i;
  }
});
function renderArc$1(n, i, a) {
  return ["M ".concat(i.x, ",").concat(i.y), "m ".concat(-a, ",0"), "a ".concat(a, ",").concat(a, " 0 1 0 ").concat(2 * a, ",0"), "a ".concat(a, ",").concat(a, " 0 1 0 ").concat(-2 * a, ",0")].join(" ");
}
function renderLine$1(n, i, a, s) {
  var c = computeLinksPoints(i, computeAxeAngle(i, a), s),
    l = computeLinksPoints(a, computeAxeAngle(i, a), s);
  return ["M ".concat(c[0].x, ",").concat(c[0].y), "L ".concat(l[0].x, ",").concat(l[0].y), "L ".concat(l[1].x, ",").concat(l[1].y), "L ".concat(c[1].x, ",").concat(c[1].y)].join(" ");
}
function renderQuadratic$1(n, i, a, s, c) {
  var l = computeLinksPoints(i, computeAxeAngle(i, s), c),
    u = computeLinksPoints(a, computeAxeAngle(s, a), c),
    d = computeLinksPoints(s, computeAxeAngle(i, a), c);
  return ["M ".concat(l[0].x, ",").concat(l[0].y), "Q ".concat(d[0].x, ",").concat(d[0].y, " ").concat(u[0].x, ",").concat(u[0].y), "L ".concat(u[1].x, ",").concat(u[1].y), "Q ".concat(d[1].x, ",").concat(d[1].y, " ").concat(l[1].x, ",").concat(l[1].y)].join(" ");
}
var B = Object.freeze({
    __proto__: null,
    getInfo: function getInfo$3() {
      return {
        type: "svg",
        name: "quadratic"
      };
    },
    drawStroke: function drawStroke$3(n, i) {
      var a = i.x.length,
        s = i.width,
        c = getPointByIndex(i, 0),
        l = a - 2,
        u = [];
      if (a < 3) u.push(renderArc$1(0, c, .6 * s));else {
        u.push(renderArc$1(0, c, s * c.p)), u.push(renderLine$1(0, c, computeMiddlePoint(c, getPointByIndex(i, 1)), s));
        for (var d = 0; d < l; d++) u.push(renderQuadratic$1(0, computeMiddlePoint(getPointByIndex(i, d), getPointByIndex(i, d + 1)), computeMiddlePoint(getPointByIndex(i, d + 1), getPointByIndex(i, d + 2)), getPointByIndex(i, d + 1), s));
        u.push(renderLine$1(0, computeMiddlePoint(getPointByIndex(i, a - 2), getPointByIndex(i, a - 1)), getPointByIndex(i, a - 1), s)), u.push(function renderFinal$1(n, i, a, s) {
          for (var c = computeAxeAngle(i, a), l = computeLinksPoints(a, c, s), u = ["M ".concat(l[0].x, ",").concat(l[0].y)], d = 1; d <= 6; d++) {
            var p = c - d * (Math.PI / 6);
            u.push("L ".concat(a.x - a.p * s * Math.sin(p), ",").concat(a.y + a.p * s * Math.cos(p)));
          }
          return u.join(" ");
        }(0, getPointByIndex(i, a - 2), getPointByIndex(i, a - 1), s));
      }
      var p = u.join(" ");
      n.attr("color", i.color).style("fill", i.color).style("stroke", "transparent").classed("pending-stroke", !0).attr("d", "".concat(p, "Z"));
    }
  }),
  G = createCommonjsModule(function (n) {
    var i = function (n) {
      var i,
        a = Object.prototype,
        s = a.hasOwnProperty,
        c = "function" == typeof Symbol ? Symbol : {},
        l = c.iterator || "@@iterator",
        u = c.asyncIterator || "@@asyncIterator",
        d = c.toStringTag || "@@toStringTag";
      function wrap(n, i, a, s) {
        var c = i && i.prototype instanceof Generator ? i : Generator,
          l = Object.create(c.prototype),
          u = new Context(s || []);
        return l._invoke = function makeInvokeMethod(n, i, a) {
          var s = p;
          return function invoke(c, l) {
            if (s === f) throw new Error("Generator is already running");
            if (s === g) {
              if ("throw" === c) throw l;
              return doneResult();
            }
            for (a.method = c, a.arg = l;;) {
              var u = a.delegate;
              if (u) {
                var d = maybeInvokeDelegate(u, a);
                if (d) {
                  if (d === m) continue;
                  return d;
                }
              }
              if ("next" === a.method) a.sent = a._sent = a.arg;else if ("throw" === a.method) {
                if (s === p) throw s = g, a.arg;
                a.dispatchException(a.arg);
              } else "return" === a.method && a.abrupt("return", a.arg);
              s = f;
              var v = tryCatch(n, i, a);
              if ("normal" === v.type) {
                if (s = a.done ? g : h, v.arg === m) continue;
                return {
                  value: v.arg,
                  done: a.done
                };
              }
              "throw" === v.type && (s = g, a.method = "throw", a.arg = v.arg);
            }
          };
        }(n, a, u), l;
      }
      function tryCatch(n, i, a) {
        try {
          return {
            type: "normal",
            arg: n.call(i, a)
          };
        } catch (n) {
          return {
            type: "throw",
            arg: n
          };
        }
      }
      n.wrap = wrap;
      var p = "suspendedStart",
        h = "suspendedYield",
        f = "executing",
        g = "completed",
        m = {};
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      var v = {};
      v[l] = function () {
        return this;
      };
      var y = Object.getPrototypeOf,
        b = y && y(y(values([])));
      b && b !== a && s.call(b, l) && (v = b);
      var x = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(v);
      function defineIteratorMethods(n) {
        ["next", "throw", "return"].forEach(function (i) {
          n[i] = function (n) {
            return this._invoke(i, n);
          };
        });
      }
      function AsyncIterator(n, i) {
        var a;
        this._invoke = function enqueue(c, l) {
          function callInvokeWithMethodAndArg() {
            return new i(function (a, u) {
              !function invoke(a, c, l, u) {
                var d = tryCatch(n[a], n, c);
                if ("throw" !== d.type) {
                  var p = d.arg,
                    h = p.value;
                  return h && "object" == typeof h && s.call(h, "__await") ? i.resolve(h.__await).then(function (n) {
                    invoke("next", n, l, u);
                  }, function (n) {
                    invoke("throw", n, l, u);
                  }) : i.resolve(h).then(function (n) {
                    p.value = n, l(p);
                  }, function (n) {
                    return invoke("throw", n, l, u);
                  });
                }
                u(d.arg);
              }(c, l, a, u);
            });
          }
          return a = a ? a.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }
      function maybeInvokeDelegate(n, a) {
        var s = n.iterator[a.method];
        if (s === i) {
          if (a.delegate = null, "throw" === a.method) {
            if (n.iterator.return && (a.method = "return", a.arg = i, maybeInvokeDelegate(n, a), "throw" === a.method)) return m;
            a.method = "throw", a.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return m;
        }
        var c = tryCatch(s, n.iterator, a.arg);
        if ("throw" === c.type) return a.method = "throw", a.arg = c.arg, a.delegate = null, m;
        var l = c.arg;
        return l ? l.done ? (a[n.resultName] = l.value, a.next = n.nextLoc, "return" !== a.method && (a.method = "next", a.arg = i), a.delegate = null, m) : l : (a.method = "throw", a.arg = new TypeError("iterator result is not an object"), a.delegate = null, m);
      }
      function pushTryEntry(n) {
        var i = {
          tryLoc: n[0]
        };
        1 in n && (i.catchLoc = n[1]), 2 in n && (i.finallyLoc = n[2], i.afterLoc = n[3]), this.tryEntries.push(i);
      }
      function resetTryEntry(n) {
        var i = n.completion || {};
        i.type = "normal", delete i.arg, n.completion = i;
      }
      function Context(n) {
        this.tryEntries = [{
          tryLoc: "root"
        }], n.forEach(pushTryEntry, this), this.reset(!0);
      }
      function values(n) {
        if (n) {
          var a = n[l];
          if (a) return a.call(n);
          if ("function" == typeof n.next) return n;
          if (!isNaN(n.length)) {
            var c = -1,
              u = function next() {
                for (; ++c < n.length;) if (s.call(n, c)) return next.value = n[c], next.done = !1, next;
                return next.value = i, next.done = !0, next;
              };
            return u.next = u;
          }
        }
        return {
          next: doneResult
        };
      }
      function doneResult() {
        return {
          value: i,
          done: !0
        };
      }
      return GeneratorFunction.prototype = x.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunctionPrototype[d] = GeneratorFunction.displayName = "GeneratorFunction", n.isGeneratorFunction = function (n) {
        var i = "function" == typeof n && n.constructor;
        return !!i && (i === GeneratorFunction || "GeneratorFunction" === (i.displayName || i.name));
      }, n.mark = function (n) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(n, GeneratorFunctionPrototype) : (n.__proto__ = GeneratorFunctionPrototype, d in n || (n[d] = "GeneratorFunction")), n.prototype = Object.create(x), n;
      }, n.awrap = function (n) {
        return {
          __await: n
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[u] = function () {
        return this;
      }, n.AsyncIterator = AsyncIterator, n.async = function (i, a, s, c, l) {
        void 0 === l && (l = Promise);
        var u = new AsyncIterator(wrap(i, a, s, c), l);
        return n.isGeneratorFunction(a) ? u : u.next().then(function (n) {
          return n.done ? n.value : u.next();
        });
      }, defineIteratorMethods(x), x[d] = "Generator", x[l] = function () {
        return this;
      }, x.toString = function () {
        return "[object Generator]";
      }, n.keys = function (n) {
        var i = [];
        for (var a in n) i.push(a);
        return i.reverse(), function next() {
          for (; i.length;) {
            var a = i.pop();
            if (a in n) return next.value = a, next.done = !1, next;
          }
          return next.done = !0, next;
        };
      }, n.values = values, Context.prototype = {
        constructor: Context,
        reset: function (n) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = i, this.done = !1, this.delegate = null, this.method = "next", this.arg = i, this.tryEntries.forEach(resetTryEntry), !n) for (var a in this) "t" === a.charAt(0) && s.call(this, a) && !isNaN(+a.slice(1)) && (this[a] = i);
        },
        stop: function () {
          this.done = !0;
          var n = this.tryEntries[0].completion;
          if ("throw" === n.type) throw n.arg;
          return this.rval;
        },
        dispatchException: function (n) {
          if (this.done) throw n;
          var a = this;
          function handle(s, c) {
            return u.type = "throw", u.arg = n, a.next = s, c && (a.method = "next", a.arg = i), !!c;
          }
          for (var c = this.tryEntries.length - 1; c >= 0; --c) {
            var l = this.tryEntries[c],
              u = l.completion;
            if ("root" === l.tryLoc) return handle("end");
            if (l.tryLoc <= this.prev) {
              var d = s.call(l, "catchLoc"),
                p = s.call(l, "finallyLoc");
              if (d && p) {
                if (this.prev < l.catchLoc) return handle(l.catchLoc, !0);
                if (this.prev < l.finallyLoc) return handle(l.finallyLoc);
              } else if (d) {
                if (this.prev < l.catchLoc) return handle(l.catchLoc, !0);
              } else {
                if (!p) throw new Error("try statement without catch or finally");
                if (this.prev < l.finallyLoc) return handle(l.finallyLoc);
              }
            }
          }
        },
        abrupt: function (n, i) {
          for (var a = this.tryEntries.length - 1; a >= 0; --a) {
            var c = this.tryEntries[a];
            if (c.tryLoc <= this.prev && s.call(c, "finallyLoc") && this.prev < c.finallyLoc) {
              var l = c;
              break;
            }
          }
          l && ("break" === n || "continue" === n) && l.tryLoc <= i && i <= l.finallyLoc && (l = null);
          var u = l ? l.completion : {};
          return u.type = n, u.arg = i, l ? (this.method = "next", this.next = l.finallyLoc, m) : this.complete(u);
        },
        complete: function (n, i) {
          if ("throw" === n.type) throw n.arg;
          return "break" === n.type || "continue" === n.type ? this.next = n.arg : "return" === n.type ? (this.rval = this.arg = n.arg, this.method = "return", this.next = "end") : "normal" === n.type && i && (this.next = i), m;
        },
        finish: function (n) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i];
            if (a.finallyLoc === n) return this.complete(a.completion, a.afterLoc), resetTryEntry(a), m;
          }
        },
        catch: function (n) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i];
            if (a.tryLoc === n) {
              var s = a.completion;
              if ("throw" === s.type) {
                var c = s.arg;
                resetTryEntry(a);
              }
              return c;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function (n, a, s) {
          return this.delegate = {
            iterator: values(n),
            resultName: a,
            nextLoc: s
          }, "next" === this.method && (this.arg = i), m;
        }
      }, n;
    }(n.exports);
    try {
      regeneratorRuntime = i;
    } catch (n) {
      Function("r", "regeneratorRuntime = r")(i);
    }
  });
function asyncGeneratorStep(n, i, a, s, c, l, u) {
  try {
    var d = n[l](u),
      p = d.value;
  } catch (n) {
    return void a(n);
  }
  d.done ? i(p) : Promise.resolve(p).then(s, c);
}
var Y = function _asyncToGenerator(n) {
    return function () {
      var i = this,
        a = arguments;
      return new Promise(function (s, c) {
        var l = n.apply(i, a);
        function _next(n) {
          asyncGeneratorStep(l, s, c, _next, _throw, "next", n);
        }
        function _throw(n) {
          asyncGeneratorStep(l, s, c, _next, _throw, "throw", n);
        }
        _next(void 0);
      });
    };
  },
  $ = createCommonjsModule(function (n, i) {
    var a;
    n.exports = (a = a || function (n, i) {
      var a = Object.create || function () {
          function F() {}
          return function (n) {
            var i;
            return F.prototype = n, i = new F(), F.prototype = null, i;
          };
        }(),
        s = {},
        c = s.lib = {},
        l = c.Base = {
          extend: function (n) {
            var i = a(this);
            return n && i.mixIn(n), i.hasOwnProperty("init") && this.init !== i.init || (i.init = function () {
              i.$super.init.apply(this, arguments);
            }), i.init.prototype = i, i.$super = this, i;
          },
          create: function () {
            var n = this.extend();
            return n.init.apply(n, arguments), n;
          },
          init: function () {},
          mixIn: function (n) {
            for (var i in n) n.hasOwnProperty(i) && (this[i] = n[i]);
            n.hasOwnProperty("toString") && (this.toString = n.toString);
          },
          clone: function () {
            return this.init.prototype.extend(this);
          }
        },
        u = c.WordArray = l.extend({
          init: function (n, a) {
            n = this.words = n || [], this.sigBytes = a != i ? a : 4 * n.length;
          },
          toString: function (n) {
            return (n || p).stringify(this);
          },
          concat: function (n) {
            var i = this.words,
              a = n.words,
              s = this.sigBytes,
              c = n.sigBytes;
            if (this.clamp(), s % 4) for (var l = 0; l < c; l++) {
              var u = a[l >>> 2] >>> 24 - l % 4 * 8 & 255;
              i[s + l >>> 2] |= u << 24 - (s + l) % 4 * 8;
            } else for (l = 0; l < c; l += 4) i[s + l >>> 2] = a[l >>> 2];
            return this.sigBytes += c, this;
          },
          clamp: function () {
            var i = this.words,
              a = this.sigBytes;
            i[a >>> 2] &= 4294967295 << 32 - a % 4 * 8, i.length = n.ceil(a / 4);
          },
          clone: function () {
            var n = l.clone.call(this);
            return n.words = this.words.slice(0), n;
          },
          random: function (i) {
            for (var a, s = [], r = function (i) {
                i = i;
                var a = 987654321,
                  s = 4294967295;
                return function () {
                  var c = ((a = 36969 * (65535 & a) + (a >> 16) & s) << 16) + (i = 18e3 * (65535 & i) + (i >> 16) & s) & s;
                  return c /= 4294967296, (c += .5) * (n.random() > .5 ? 1 : -1);
                };
              }, c = 0; c < i; c += 4) {
              var l = r(4294967296 * (a || n.random()));
              a = 987654071 * l(), s.push(4294967296 * l() | 0);
            }
            return new u.init(s, i);
          }
        }),
        d = s.enc = {},
        p = d.Hex = {
          stringify: function (n) {
            for (var i = n.words, a = n.sigBytes, s = [], c = 0; c < a; c++) {
              var l = i[c >>> 2] >>> 24 - c % 4 * 8 & 255;
              s.push((l >>> 4).toString(16)), s.push((15 & l).toString(16));
            }
            return s.join("");
          },
          parse: function (n) {
            for (var i = n.length, a = [], s = 0; s < i; s += 2) a[s >>> 3] |= parseInt(n.substr(s, 2), 16) << 24 - s % 8 * 4;
            return new u.init(a, i / 2);
          }
        },
        h = d.Latin1 = {
          stringify: function (n) {
            for (var i = n.words, a = n.sigBytes, s = [], c = 0; c < a; c++) {
              var l = i[c >>> 2] >>> 24 - c % 4 * 8 & 255;
              s.push(String.fromCharCode(l));
            }
            return s.join("");
          },
          parse: function (n) {
            for (var i = n.length, a = [], s = 0; s < i; s++) a[s >>> 2] |= (255 & n.charCodeAt(s)) << 24 - s % 4 * 8;
            return new u.init(a, i);
          }
        },
        f = d.Utf8 = {
          stringify: function (n) {
            try {
              return decodeURIComponent(escape(h.stringify(n)));
            } catch (n) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          parse: function (n) {
            return h.parse(unescape(encodeURIComponent(n)));
          }
        },
        g = c.BufferedBlockAlgorithm = l.extend({
          reset: function () {
            this._data = new u.init(), this._nDataBytes = 0;
          },
          _append: function (n) {
            "string" == typeof n && (n = f.parse(n)), this._data.concat(n), this._nDataBytes += n.sigBytes;
          },
          _process: function (i) {
            var a = this._data,
              s = a.words,
              c = a.sigBytes,
              l = this.blockSize,
              d = c / (4 * l),
              p = (d = i ? n.ceil(d) : n.max((0 | d) - this._minBufferSize, 0)) * l,
              h = n.min(4 * p, c);
            if (p) {
              for (var f = 0; f < p; f += l) this._doProcessBlock(s, f);
              var g = s.splice(0, p);
              a.sigBytes -= h;
            }
            return new u.init(g, h);
          },
          clone: function () {
            var n = l.clone.call(this);
            return n._data = this._data.clone(), n;
          },
          _minBufferSize: 0
        }),
        m = (c.Hasher = g.extend({
          cfg: l.extend(),
          init: function (n) {
            this.cfg = this.cfg.extend(n), this.reset();
          },
          reset: function () {
            g.reset.call(this), this._doReset();
          },
          update: function (n) {
            return this._append(n), this._process(), this;
          },
          finalize: function (n) {
            return n && this._append(n), this._doFinalize();
          },
          blockSize: 16,
          _createHelper: function (n) {
            return function (i, a) {
              return new n.init(a).finalize(i);
            };
          },
          _createHmacHelper: function (n) {
            return function (i, a) {
              return new m.HMAC.init(n, a).finalize(i);
            };
          }
        }), s.algo = {});
      return s;
    }(Math), a);
  }),
  V = createCommonjsModule(function (n, i) {
    n.exports = $.enc.Hex;
  }),
  K = (createCommonjsModule(function (n, i) {
    var a, s, c, l, u, d, p;
    n.exports = (c = (s = p = $).lib, l = c.Base, u = c.WordArray, (d = s.x64 = {}).Word = l.extend({
      init: function (n, i) {
        this.high = n, this.low = i;
      }
    }), d.WordArray = l.extend({
      init: function (n, i) {
        n = this.words = n || [], this.sigBytes = i != a ? i : 8 * n.length;
      },
      toX32: function () {
        for (var n = this.words, i = n.length, a = [], s = 0; s < i; s++) {
          var c = n[s];
          a.push(c.high), a.push(c.low);
        }
        return u.create(a, this.sigBytes);
      },
      clone: function () {
        for (var n = l.clone.call(this), i = n.words = this.words.slice(0), a = i.length, s = 0; s < a; s++) i[s] = i[s].clone();
        return n;
      }
    }), p);
  }), createCommonjsModule(function (n, i) {
    var a;
    n.exports = (a = $, function () {
      var n = a,
        i = n.lib.Hasher,
        s = n.x64,
        c = s.Word,
        l = s.WordArray,
        u = n.algo;
      function X64Word_create() {
        return c.create.apply(c, arguments);
      }
      var d = [X64Word_create(1116352408, 3609767458), X64Word_create(1899447441, 602891725), X64Word_create(3049323471, 3964484399), X64Word_create(3921009573, 2173295548), X64Word_create(961987163, 4081628472), X64Word_create(1508970993, 3053834265), X64Word_create(2453635748, 2937671579), X64Word_create(2870763221, 3664609560), X64Word_create(3624381080, 2734883394), X64Word_create(310598401, 1164996542), X64Word_create(607225278, 1323610764), X64Word_create(1426881987, 3590304994), X64Word_create(1925078388, 4068182383), X64Word_create(2162078206, 991336113), X64Word_create(2614888103, 633803317), X64Word_create(3248222580, 3479774868), X64Word_create(3835390401, 2666613458), X64Word_create(4022224774, 944711139), X64Word_create(264347078, 2341262773), X64Word_create(604807628, 2007800933), X64Word_create(770255983, 1495990901), X64Word_create(1249150122, 1856431235), X64Word_create(1555081692, 3175218132), X64Word_create(1996064986, 2198950837), X64Word_create(2554220882, 3999719339), X64Word_create(2821834349, 766784016), X64Word_create(2952996808, 2566594879), X64Word_create(3210313671, 3203337956), X64Word_create(3336571891, 1034457026), X64Word_create(3584528711, 2466948901), X64Word_create(113926993, 3758326383), X64Word_create(338241895, 168717936), X64Word_create(666307205, 1188179964), X64Word_create(773529912, 1546045734), X64Word_create(1294757372, 1522805485), X64Word_create(1396182291, 2643833823), X64Word_create(1695183700, 2343527390), X64Word_create(1986661051, 1014477480), X64Word_create(2177026350, 1206759142), X64Word_create(2456956037, 344077627), X64Word_create(2730485921, 1290863460), X64Word_create(2820302411, 3158454273), X64Word_create(3259730800, 3505952657), X64Word_create(3345764771, 106217008), X64Word_create(3516065817, 3606008344), X64Word_create(3600352804, 1432725776), X64Word_create(4094571909, 1467031594), X64Word_create(275423344, 851169720), X64Word_create(430227734, 3100823752), X64Word_create(506948616, 1363258195), X64Word_create(659060556, 3750685593), X64Word_create(883997877, 3785050280), X64Word_create(958139571, 3318307427), X64Word_create(1322822218, 3812723403), X64Word_create(1537002063, 2003034995), X64Word_create(1747873779, 3602036899), X64Word_create(1955562222, 1575990012), X64Word_create(2024104815, 1125592928), X64Word_create(2227730452, 2716904306), X64Word_create(2361852424, 442776044), X64Word_create(2428436474, 593698344), X64Word_create(2756734187, 3733110249), X64Word_create(3204031479, 2999351573), X64Word_create(3329325298, 3815920427), X64Word_create(3391569614, 3928383900), X64Word_create(3515267271, 566280711), X64Word_create(3940187606, 3454069534), X64Word_create(4118630271, 4000239992), X64Word_create(116418474, 1914138554), X64Word_create(174292421, 2731055270), X64Word_create(289380356, 3203993006), X64Word_create(460393269, 320620315), X64Word_create(685471733, 587496836), X64Word_create(852142971, 1086792851), X64Word_create(1017036298, 365543100), X64Word_create(1126000580, 2618297676), X64Word_create(1288033470, 3409855158), X64Word_create(1501505948, 4234509866), X64Word_create(1607167915, 987167468), X64Word_create(1816402316, 1246189591)],
        p = [];
      !function () {
        for (var n = 0; n < 80; n++) p[n] = X64Word_create();
      }();
      var h = u.SHA512 = i.extend({
        _doReset: function () {
          this._hash = new l.init([new c.init(1779033703, 4089235720), new c.init(3144134277, 2227873595), new c.init(1013904242, 4271175723), new c.init(2773480762, 1595750129), new c.init(1359893119, 2917565137), new c.init(2600822924, 725511199), new c.init(528734635, 4215389547), new c.init(1541459225, 327033209)]);
        },
        _doProcessBlock: function (n, i) {
          for (var a = this._hash.words, s = a[0], c = a[1], l = a[2], u = a[3], h = a[4], f = a[5], g = a[6], m = a[7], v = s.high, y = s.low, b = c.high, x = c.low, w = l.high, _ = l.low, S = u.high, k = u.low, C = h.high, P = h.low, I = f.high, T = f.low, M = g.high, R = g.low, L = m.high, A = m.low, D = v, j = y, U = b, O = x, z = w, N = _, W = S, X = k, H = C, B = P, G = I, Y = T, $ = M, V = R, K = L, J = A, q = 0; q < 80; q++) {
            var Z = p[q];
            if (q < 16) var Q = Z.high = 0 | n[i + 2 * q],
              ee = Z.low = 0 | n[i + 2 * q + 1];else {
              var te = p[q - 15],
                ne = te.high,
                re = te.low,
                oe = (ne >>> 1 | re << 31) ^ (ne >>> 8 | re << 24) ^ ne >>> 7,
                ie = (re >>> 1 | ne << 31) ^ (re >>> 8 | ne << 24) ^ (re >>> 7 | ne << 25),
                ae = p[q - 2],
                se = ae.high,
                ce = ae.low,
                le = (se >>> 19 | ce << 13) ^ (se << 3 | ce >>> 29) ^ se >>> 6,
                ue = (ce >>> 19 | se << 13) ^ (ce << 3 | se >>> 29) ^ (ce >>> 6 | se << 26),
                de = p[q - 7],
                pe = de.high,
                he = de.low,
                fe = p[q - 16],
                ge = fe.high,
                me = fe.low;
              Q = (Q = (Q = oe + pe + ((ee = ie + he) >>> 0 < ie >>> 0 ? 1 : 0)) + le + ((ee += ue) >>> 0 < ue >>> 0 ? 1 : 0)) + ge + ((ee += me) >>> 0 < me >>> 0 ? 1 : 0), Z.high = Q, Z.low = ee;
            }
            var ve,
              ye = H & G ^ ~H & $,
              be = B & Y ^ ~B & V,
              xe = D & U ^ D & z ^ U & z,
              we = j & O ^ j & N ^ O & N,
              Ee = (D >>> 28 | j << 4) ^ (D << 30 | j >>> 2) ^ (D << 25 | j >>> 7),
              _e = (j >>> 28 | D << 4) ^ (j << 30 | D >>> 2) ^ (j << 25 | D >>> 7),
              Se = (H >>> 14 | B << 18) ^ (H >>> 18 | B << 14) ^ (H << 23 | B >>> 9),
              ke = (B >>> 14 | H << 18) ^ (B >>> 18 | H << 14) ^ (B << 23 | H >>> 9),
              Ce = d[q],
              Pe = Ce.high,
              Ie = Ce.low,
              Te = K + Se + ((ve = J + ke) >>> 0 < J >>> 0 ? 1 : 0),
              Me = _e + we;
            K = $, J = V, $ = G, V = Y, G = H, Y = B, H = W + (Te = (Te = (Te = Te + ye + ((ve += be) >>> 0 < be >>> 0 ? 1 : 0)) + Pe + ((ve += Ie) >>> 0 < Ie >>> 0 ? 1 : 0)) + Q + ((ve += ee) >>> 0 < ee >>> 0 ? 1 : 0)) + ((B = X + ve | 0) >>> 0 < X >>> 0 ? 1 : 0) | 0, W = z, X = N, z = U, N = O, U = D, O = j, D = Te + (Ee + xe + (Me >>> 0 < _e >>> 0 ? 1 : 0)) + ((j = ve + Me | 0) >>> 0 < ve >>> 0 ? 1 : 0) | 0;
          }
          y = s.low = y + j, s.high = v + D + (y >>> 0 < j >>> 0 ? 1 : 0), x = c.low = x + O, c.high = b + U + (x >>> 0 < O >>> 0 ? 1 : 0), _ = l.low = _ + N, l.high = w + z + (_ >>> 0 < N >>> 0 ? 1 : 0), k = u.low = k + X, u.high = S + W + (k >>> 0 < X >>> 0 ? 1 : 0), P = h.low = P + B, h.high = C + H + (P >>> 0 < B >>> 0 ? 1 : 0), T = f.low = T + Y, f.high = I + G + (T >>> 0 < Y >>> 0 ? 1 : 0), R = g.low = R + V, g.high = M + $ + (R >>> 0 < V >>> 0 ? 1 : 0), A = m.low = A + J, m.high = L + K + (A >>> 0 < J >>> 0 ? 1 : 0);
        },
        _doFinalize: function () {
          var n = this._data,
            i = n.words,
            a = 8 * this._nDataBytes,
            s = 8 * n.sigBytes;
          return i[s >>> 5] |= 128 << 24 - s % 32, i[30 + (s + 128 >>> 10 << 5)] = Math.floor(a / 4294967296), i[31 + (s + 128 >>> 10 << 5)] = a, n.sigBytes = 4 * i.length, this._process(), this._hash.toX32();
        },
        clone: function () {
          var n = i.clone.call(this);
          return n._hash = this._hash.clone(), n;
        },
        blockSize: 32
      });
      n.SHA512 = i._createHelper(h), n.HmacSHA512 = i._createHmacHelper(h);
    }(), a.SHA512);
  }), createCommonjsModule(function (n, i) {
    var a, s, c;
    n.exports = (s = (a = $).lib.Base, c = a.enc.Utf8, void (a.algo.HMAC = s.extend({
      init: function (n, i) {
        n = this._hasher = new n.init(), "string" == typeof i && (i = c.parse(i));
        var a = n.blockSize,
          s = 4 * a;
        i.sigBytes > s && (i = n.finalize(i)), i.clamp();
        for (var l = this._oKey = i.clone(), u = this._iKey = i.clone(), d = l.words, p = u.words, h = 0; h < a; h++) d[h] ^= 1549556828, p[h] ^= 909522486;
        l.sigBytes = u.sigBytes = s, this.reset();
      },
      reset: function () {
        var n = this._hasher;
        n.reset(), n.update(this._iKey);
      },
      update: function (n) {
        return this._hasher.update(n), this;
      },
      finalize: function (n) {
        var i = this._hasher,
          a = i.finalize(n);
        return i.reset(), i.finalize(this._oKey.clone().concat(a));
      }
    })));
  }), createCommonjsModule(function (n, i) {
    n.exports = $.HmacSHA512;
  }));
function computeHmac(n, i, a) {
  var s = "object" === h(n) ? JSON.stringify(n) : n;
  return d.debug("The HmacSHA512 function is loaded", K), new K(s, i + a).toString(V);
}
function post(n, i, a, s, c) {
  return _post.apply(this, arguments);
}
function _post() {
  return (_post = Y(G.mark(function _callee2(n, i, a, s, c) {
    var l, u, d, p, h, f, g, m;
    return G.wrap(function _callee2$(s) {
      for (;;) switch (s.prev = s.next) {
        case 0:
          return l = n.editor.configuration, (u = n) && (u.idle = !0), s.prev = 3, (d = new Headers()).append("Accept", "application/json," + c), d.append("applicationKey", l.recognitionParams.server.applicationKey), d.append("hmac", computeHmac(JSON.stringify(a), l.recognitionParams.server.applicationKey, l.recognitionParams.server.hmacKey)), d.append("Content-Type", "application/json"), p = {
            method: "POST",
            headers: d,
            credentials: "include",
            body: JSON.stringify(a)
          }, h = new Request(i, p), s.next = 13, fetch(h);
        case 13:
          f = s.sent, g = f.headers.get("content-type"), m = "", s.t0 = g, s.next = "application/vnd.openxmlformats-officedocument.presentationml.presentation" === s.t0 || "image/png" === s.t0 || "image/jpeg" === s.t0 ? 19 : "application/json" === s.t0 ? 23 : "application/vnd.myscript.jiix" === s.t0 ? 27 : 31;
          break;
        case 19:
          return s.next = 21, f.blob();
        case 21:
          return m = s.sent, s.abrupt("break", 35);
        case 23:
          return s.next = 25, f.json();
        case 25:
          return m = s.sent, s.abrupt("break", 35);
        case 27:
          return s.next = 29, f.clone().json().catch(Y(G.mark(function _callee() {
            return G.wrap(function _callee$(n) {
              for (;;) switch (n.prev = n.next) {
                case 0:
                  return n.next = 2, f.text();
                case 2:
                  return n.abrupt("return", n.sent);
                case 3:
                case "end":
                  return n.stop();
              }
            }, _callee);
          })));
        case 29:
          return m = s.sent, s.abrupt("break", 35);
        case 31:
          return s.next = 33, f.text();
        case 33:
          return m = s.sent, s.abrupt("break", 35);
        case 35:
          return s.abrupt("return", m);
        case 38:
          throw s.prev = 38, s.t1 = s.catch(3), new Error({
            msg: "Could not connect to ".concat(i, " connection error"),
            recoverable: !1
          });
        case 41:
        case "end":
          return s.stop();
      }
    }, _callee2, null, [[3, 38]]);
  }))).apply(this, arguments);
}
function createEmptyRecognizerContext(n) {
  var i = Date.now();
  return d.info("Create empty recognizer context with ID: " + i), {
    id: i,
    editor: n,
    recognitionContexts: [],
    initPromise: void 0,
    lastPositions: {
      lastSentPosition: -1,
      lastReceivedPosition: -1
    },
    url: void 0,
    websocket: void 0,
    websocketCallback: void 0,
    reconnect: void 0,
    currentReconnectionCount: 0,
    sessionId: void 0,
    contentPartCount: 0,
    currentPartId: void 0,
    instanceId: void 0,
    canUndo: !1,
    canRedo: !1,
    isEmpty: void 0,
    supportedImportMimeTypes: [],
    undoStackIndex: 0,
    possibleUndoCount: 0,
    idle: !0,
    initialized: !1
  };
}
function isResetRequired(n, i) {
  return !!n.lastPositions && n.lastPositions.lastSentPosition >= i.rawStrokes.length - 1;
}
function updateRecognitionPositions(n, i) {
  var a = n;
  return i && (a.lastPositions.lastSentPosition = i.lastSentPosition, a.lastPositions.lastReceivedPosition = i.lastReceivedPosition), a.lastPositions.lastSentPosition === a.lastPositions.lastReceivedPosition === -1 && delete a.instanceId, a;
}
function setRecognitionContext(n, i) {
  var a = n;
  return a.recognitionContexts[0] = i, a;
}
function canReconnect(n) {
  return !0 === n.websocket.autoReconnect && n.currentReconnectionCount <= n.websocket.maxRetryCount;
}
function shouldAttemptImmediateReconnect(n) {
  var i = n;
  return !0 === i.websocket.autoReconnect && i.currentReconnectionCount++ <= i.websocket.maxRetryCount;
}
var J = {
    type: "LOST_CONNECTION"
  },
  q = Object.freeze({
    __proto__: null,
    createEmptyRecognizerContext: createEmptyRecognizerContext,
    isResetRequired: isResetRequired,
    updateRecognitionPositions: updateRecognitionPositions,
    setRecognitionContext: setRecognitionContext,
    canReconnect: canReconnect,
    shouldAttemptImmediateReconnect: shouldAttemptImmediateReconnect,
    LOST_CONNEXION_MESSAGE: J,
    CLOSE_RECOGNIZER_MESSAGE: "CLOSE_RECOGNIZER"
  });
/*!
 * perfect-scrollbar v1.5.0
 * Copyright 2020 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */
function get(n) {
  return getComputedStyle(n);
}
function set(n, i) {
  for (var a in i) {
    var s = i[a];
    "number" == typeof s && (s += "px"), n.style[a] = s;
  }
  return n;
}
function div(n) {
  var i = document.createElement("div");
  return i.className = n, i;
}
var Z = "undefined" != typeof Element && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function matches(n, i) {
  if (!Z) throw new Error("No element matching method supported");
  return Z.call(n, i);
}
function remove$1(n) {
  n.remove ? n.remove() : n.parentNode && n.parentNode.removeChild(n);
}
function queryChildren(n, i) {
  return Array.prototype.filter.call(n.children, function (n) {
    return matches(n, i);
  });
}
var Q = "ps",
  ee = "ps__rtl",
  te = {
    thumb: function (n) {
      return "ps__thumb-" + n;
    },
    rail: function (n) {
      return "ps__rail-" + n;
    },
    consuming: "ps__child--consume"
  },
  ne = {
    focus: "ps--focus",
    clicking: "ps--clicking",
    active: function (n) {
      return "ps--active-" + n;
    },
    scrolling: function (n) {
      return "ps--scrolling-" + n;
    }
  },
  re = {
    x: null,
    y: null
  };
function addScrollingClass(n, i) {
  var a = n.element.classList,
    s = ne.scrolling(i);
  a.contains(s) ? clearTimeout(re[i]) : a.add(s);
}
function removeScrollingClass(n, i) {
  re[i] = setTimeout(function () {
    return n.isAlive && n.element.classList.remove(ne.scrolling(i));
  }, n.settings.scrollingThreshold);
}
var oe = function EventElement(n) {
    this.element = n, this.handlers = {};
  },
  ie = {
    isEmpty: {
      configurable: !0
    }
  };
oe.prototype.bind = function bind(n, i) {
  void 0 === this.handlers[n] && (this.handlers[n] = []), this.handlers[n].push(i), this.element.addEventListener(n, i, !1);
}, oe.prototype.unbind = function unbind(n, i) {
  var a = this;
  this.handlers[n] = this.handlers[n].filter(function (s) {
    return !(!i || s === i) || (a.element.removeEventListener(n, s, !1), !1);
  });
}, oe.prototype.unbindAll = function unbindAll() {
  for (var n in this.handlers) this.unbind(n);
}, ie.isEmpty.get = function () {
  var n = this;
  return Object.keys(this.handlers).every(function (i) {
    return 0 === n.handlers[i].length;
  });
}, Object.defineProperties(oe.prototype, ie);
var ae = function EventManager() {
  this.eventElements = [];
};
function createEvent(n) {
  if ("function" == typeof window.CustomEvent) return new CustomEvent(n);
  var i = document.createEvent("CustomEvent");
  return i.initCustomEvent(n, !1, !1, void 0), i;
}
function processScrollDiff(n, i, a, s, c) {
  var l;
  if (void 0 === s && (s = !0), void 0 === c && (c = !1), "top" === i) l = ["contentHeight", "containerHeight", "scrollTop", "y", "up", "down"];else {
    if ("left" !== i) throw new Error("A proper axis should be provided");
    l = ["contentWidth", "containerWidth", "scrollLeft", "x", "left", "right"];
  }
  !function processScrollDiff$1(n, i, a, s, c) {
    var l = a[0],
      u = a[1],
      d = a[2],
      p = a[3],
      h = a[4],
      f = a[5];
    void 0 === s && (s = !0);
    void 0 === c && (c = !1);
    var g = n.element;
    n.reach[p] = null, g[d] < 1 && (n.reach[p] = "start");
    g[d] > n[l] - n[u] - 1 && (n.reach[p] = "end");
    i && (g.dispatchEvent(createEvent("ps-scroll-" + p)), i < 0 ? g.dispatchEvent(createEvent("ps-scroll-" + h)) : i > 0 && g.dispatchEvent(createEvent("ps-scroll-" + f)), s && function setScrollingClassInstantly(n, i) {
      addScrollingClass(n, i), removeScrollingClass(n, i);
    }(n, p));
    n.reach[p] && (i || c) && g.dispatchEvent(createEvent("ps-" + p + "-reach-" + n.reach[p]));
  }(n, a, l, s, c);
}
function toInt(n) {
  return parseInt(n, 10) || 0;
}
ae.prototype.eventElement = function eventElement(n) {
  var i = this.eventElements.filter(function (i) {
    return i.element === n;
  })[0];
  return i || (i = new oe(n), this.eventElements.push(i)), i;
}, ae.prototype.bind = function bind(n, i, a) {
  this.eventElement(n).bind(i, a);
}, ae.prototype.unbind = function unbind(n, i, a) {
  var s = this.eventElement(n);
  s.unbind(i, a), s.isEmpty && this.eventElements.splice(this.eventElements.indexOf(s), 1);
}, ae.prototype.unbindAll = function unbindAll() {
  this.eventElements.forEach(function (n) {
    return n.unbindAll();
  }), this.eventElements = [];
}, ae.prototype.once = function once(n, i, a) {
  var s = this.eventElement(n),
    onceHandler = function (n) {
      s.unbind(i, onceHandler), a(n);
    };
  s.bind(i, onceHandler);
};
var se = {
  isWebKit: "undefined" != typeof document && "WebkitAppearance" in document.documentElement.style,
  supportsTouch: "undefined" != typeof window && ("ontouchstart" in window || "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: "undefined" != typeof navigator && navigator.msMaxTouchPoints,
  isChrome: "undefined" != typeof navigator && /Chrome/i.test(navigator && navigator.userAgent)
};
function updateGeometry(n) {
  var i = n.element,
    a = Math.floor(i.scrollTop),
    s = i.getBoundingClientRect();
  n.containerWidth = Math.ceil(s.width), n.containerHeight = Math.ceil(s.height), n.contentWidth = i.scrollWidth, n.contentHeight = i.scrollHeight, i.contains(n.scrollbarXRail) || (queryChildren(i, te.rail("x")).forEach(function (n) {
    return remove$1(n);
  }), i.appendChild(n.scrollbarXRail)), i.contains(n.scrollbarYRail) || (queryChildren(i, te.rail("y")).forEach(function (n) {
    return remove$1(n);
  }), i.appendChild(n.scrollbarYRail)), !n.settings.suppressScrollX && n.containerWidth + n.settings.scrollXMarginOffset < n.contentWidth ? (n.scrollbarXActive = !0, n.railXWidth = n.containerWidth - n.railXMarginWidth, n.railXRatio = n.containerWidth / n.railXWidth, n.scrollbarXWidth = getThumbSize(n, toInt(n.railXWidth * n.containerWidth / n.contentWidth)), n.scrollbarXLeft = toInt((n.negativeScrollAdjustment + i.scrollLeft) * (n.railXWidth - n.scrollbarXWidth) / (n.contentWidth - n.containerWidth))) : n.scrollbarXActive = !1, !n.settings.suppressScrollY && n.containerHeight + n.settings.scrollYMarginOffset < n.contentHeight ? (n.scrollbarYActive = !0, n.railYHeight = n.containerHeight - n.railYMarginHeight, n.railYRatio = n.containerHeight / n.railYHeight, n.scrollbarYHeight = getThumbSize(n, toInt(n.railYHeight * n.containerHeight / n.contentHeight)), n.scrollbarYTop = toInt(a * (n.railYHeight - n.scrollbarYHeight) / (n.contentHeight - n.containerHeight))) : n.scrollbarYActive = !1, n.scrollbarXLeft >= n.railXWidth - n.scrollbarXWidth && (n.scrollbarXLeft = n.railXWidth - n.scrollbarXWidth), n.scrollbarYTop >= n.railYHeight - n.scrollbarYHeight && (n.scrollbarYTop = n.railYHeight - n.scrollbarYHeight), function updateCss(n, i) {
    var a = {
        width: i.railXWidth
      },
      s = Math.floor(n.scrollTop);
    i.isRtl ? a.left = i.negativeScrollAdjustment + n.scrollLeft + i.containerWidth - i.contentWidth : a.left = n.scrollLeft;
    i.isScrollbarXUsingBottom ? a.bottom = i.scrollbarXBottom - s : a.top = i.scrollbarXTop + s;
    set(i.scrollbarXRail, a);
    var c = {
      top: s,
      height: i.railYHeight
    };
    i.isScrollbarYUsingRight ? i.isRtl ? c.right = i.contentWidth - (i.negativeScrollAdjustment + n.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth - 9 : c.right = i.scrollbarYRight - n.scrollLeft : i.isRtl ? c.left = i.negativeScrollAdjustment + n.scrollLeft + 2 * i.containerWidth - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth : c.left = i.scrollbarYLeft + n.scrollLeft;
    set(i.scrollbarYRail, c), set(i.scrollbarX, {
      left: i.scrollbarXLeft,
      width: i.scrollbarXWidth - i.railBorderXWidth
    }), set(i.scrollbarY, {
      top: i.scrollbarYTop,
      height: i.scrollbarYHeight - i.railBorderYWidth
    });
  }(i, n), n.scrollbarXActive ? i.classList.add(ne.active("x")) : (i.classList.remove(ne.active("x")), n.scrollbarXWidth = 0, n.scrollbarXLeft = 0, i.scrollLeft = !0 === n.isRtl ? n.contentWidth : 0), n.scrollbarYActive ? i.classList.add(ne.active("y")) : (i.classList.remove(ne.active("y")), n.scrollbarYHeight = 0, n.scrollbarYTop = 0, i.scrollTop = 0);
}
function getThumbSize(n, i) {
  return n.settings.minScrollbarLength && (i = Math.max(i, n.settings.minScrollbarLength)), n.settings.maxScrollbarLength && (i = Math.min(i, n.settings.maxScrollbarLength)), i;
}
function bindMouseScrollHandler(n, i) {
  var a = i[0],
    s = i[1],
    c = i[2],
    l = i[3],
    u = i[4],
    d = i[5],
    p = i[6],
    h = i[7],
    f = i[8],
    g = n.element,
    m = null,
    v = null,
    y = null;
  function mouseMoveHandler(i) {
    i.touches && i.touches[0] && (i[c] = i.touches[0].pageY), g[p] = m + y * (i[c] - v), addScrollingClass(n, h), updateGeometry(n), i.stopPropagation(), i.preventDefault();
  }
  function mouseUpHandler() {
    removeScrollingClass(n, h), n[f].classList.remove(ne.clicking), n.event.unbind(n.ownerDocument, "mousemove", mouseMoveHandler);
  }
  function bindMoves(i, u) {
    m = g[p], u && i.touches && (i[c] = i.touches[0].pageY), v = i[c], y = (n[s] - n[a]) / (n[l] - n[d]), u ? n.event.bind(n.ownerDocument, "touchmove", mouseMoveHandler) : (n.event.bind(n.ownerDocument, "mousemove", mouseMoveHandler), n.event.once(n.ownerDocument, "mouseup", mouseUpHandler), i.preventDefault()), n[f].classList.add(ne.clicking), i.stopPropagation();
  }
  n.event.bind(n[u], "mousedown", function (n) {
    bindMoves(n);
  }), n.event.bind(n[u], "touchstart", function (n) {
    bindMoves(n, !0);
  });
}
var ce = {
    "click-rail": function clickRail(n) {
      n.element, n.event.bind(n.scrollbarY, "mousedown", function (n) {
        return n.stopPropagation();
      }), n.event.bind(n.scrollbarYRail, "mousedown", function (i) {
        var a = i.pageY - window.pageYOffset - n.scrollbarYRail.getBoundingClientRect().top > n.scrollbarYTop ? 1 : -1;
        n.element.scrollTop += a * n.containerHeight, updateGeometry(n), i.stopPropagation();
      }), n.event.bind(n.scrollbarX, "mousedown", function (n) {
        return n.stopPropagation();
      }), n.event.bind(n.scrollbarXRail, "mousedown", function (i) {
        var a = i.pageX - window.pageXOffset - n.scrollbarXRail.getBoundingClientRect().left > n.scrollbarXLeft ? 1 : -1;
        n.element.scrollLeft += a * n.containerWidth, updateGeometry(n), i.stopPropagation();
      });
    },
    "drag-thumb": function dragThumb(n) {
      bindMouseScrollHandler(n, ["containerWidth", "contentWidth", "pageX", "railXWidth", "scrollbarX", "scrollbarXWidth", "scrollLeft", "x", "scrollbarXRail"]), bindMouseScrollHandler(n, ["containerHeight", "contentHeight", "pageY", "railYHeight", "scrollbarY", "scrollbarYHeight", "scrollTop", "y", "scrollbarYRail"]);
    },
    keyboard: function keyboard(n) {
      var i = n.element;
      n.event.bind(n.ownerDocument, "keydown", function (a) {
        if (!(a.isDefaultPrevented && a.isDefaultPrevented() || a.defaultPrevented) && (matches(i, ":hover") || matches(n.scrollbarX, ":focus") || matches(n.scrollbarY, ":focus"))) {
          var s = document.activeElement ? document.activeElement : n.ownerDocument.activeElement;
          if (s) {
            if ("IFRAME" === s.tagName) s = s.contentDocument.activeElement;else for (; s.shadowRoot;) s = s.shadowRoot.activeElement;
            if (function isEditable(n) {
              return matches(n, "input,[contenteditable]") || matches(n, "select,[contenteditable]") || matches(n, "textarea,[contenteditable]") || matches(n, "button,[contenteditable]");
            }(s)) return;
          }
          var c = 0,
            l = 0;
          switch (a.which) {
            case 37:
              c = a.metaKey ? -n.contentWidth : a.altKey ? -n.containerWidth : -30;
              break;
            case 38:
              l = a.metaKey ? n.contentHeight : a.altKey ? n.containerHeight : 30;
              break;
            case 39:
              c = a.metaKey ? n.contentWidth : a.altKey ? n.containerWidth : 30;
              break;
            case 40:
              l = a.metaKey ? -n.contentHeight : a.altKey ? -n.containerHeight : -30;
              break;
            case 32:
              l = a.shiftKey ? n.containerHeight : -n.containerHeight;
              break;
            case 33:
              l = n.containerHeight;
              break;
            case 34:
              l = -n.containerHeight;
              break;
            case 36:
              l = n.contentHeight;
              break;
            case 35:
              l = -n.contentHeight;
              break;
            default:
              return;
          }
          n.settings.suppressScrollX && 0 !== c || n.settings.suppressScrollY && 0 !== l || (i.scrollTop -= l, i.scrollLeft += c, updateGeometry(n), function shouldPreventDefault(a, s) {
            var c = Math.floor(i.scrollTop);
            if (0 === a) {
              if (!n.scrollbarYActive) return !1;
              if (0 === c && s > 0 || c >= n.contentHeight - n.containerHeight && s < 0) return !n.settings.wheelPropagation;
            }
            var l = i.scrollLeft;
            if (0 === s) {
              if (!n.scrollbarXActive) return !1;
              if (0 === l && a < 0 || l >= n.contentWidth - n.containerWidth && a > 0) return !n.settings.wheelPropagation;
            }
            return !0;
          }(c, l) && a.preventDefault());
        }
      });
    },
    wheel: function wheel(n) {
      var i = n.element;
      function mousewheelHandler(a) {
        var s = function getDeltaFromEvent(n) {
            var i = n.deltaX,
              a = -1 * n.deltaY;
            return void 0 !== i && void 0 !== a || (i = -1 * n.wheelDeltaX / 6, a = n.wheelDeltaY / 6), n.deltaMode && 1 === n.deltaMode && (i *= 10, a *= 10), i != i && a != a && (i = 0, a = n.wheelDelta), n.shiftKey ? [-a, -i] : [i, a];
          }(a),
          c = s[0],
          l = s[1];
        if (!function shouldBeConsumedByChild(n, a, s) {
          if (!se.isWebKit && i.querySelector("select:focus")) return !0;
          if (!i.contains(n)) return !1;
          for (var c = n; c && c !== i;) {
            if (c.classList.contains(te.consuming)) return !0;
            var l = get(c);
            if (s && l.overflowY.match(/(scroll|auto)/)) {
              var u = c.scrollHeight - c.clientHeight;
              if (u > 0 && (c.scrollTop > 0 && s < 0 || c.scrollTop < u && s > 0)) return !0;
            }
            if (a && l.overflowX.match(/(scroll|auto)/)) {
              var d = c.scrollWidth - c.clientWidth;
              if (d > 0 && (c.scrollLeft > 0 && a < 0 || c.scrollLeft < d && a > 0)) return !0;
            }
            c = c.parentNode;
          }
          return !1;
        }(a.target, c, l)) {
          var u = !1;
          n.settings.useBothWheelAxes ? n.scrollbarYActive && !n.scrollbarXActive ? (l ? i.scrollTop -= l * n.settings.wheelSpeed : i.scrollTop += c * n.settings.wheelSpeed, u = !0) : n.scrollbarXActive && !n.scrollbarYActive && (c ? i.scrollLeft += c * n.settings.wheelSpeed : i.scrollLeft -= l * n.settings.wheelSpeed, u = !0) : (i.scrollTop -= l * n.settings.wheelSpeed, i.scrollLeft += c * n.settings.wheelSpeed), updateGeometry(n), (u = u || function shouldPreventDefault(a, s) {
            var c = Math.floor(i.scrollTop),
              l = 0 === i.scrollTop,
              u = c + i.offsetHeight === i.scrollHeight,
              d = 0 === i.scrollLeft,
              p = i.scrollLeft + i.offsetWidth === i.scrollWidth;
            return !(Math.abs(s) > Math.abs(a) ? l || u : d || p) || !n.settings.wheelPropagation;
          }(c, l)) && !a.ctrlKey && (a.stopPropagation(), a.preventDefault());
        }
      }
      void 0 !== window.onwheel ? n.event.bind(i, "wheel", mousewheelHandler) : void 0 !== window.onmousewheel && n.event.bind(i, "mousewheel", mousewheelHandler);
    },
    touch: function touch(n) {
      if (se.supportsTouch || se.supportsIePointer) {
        var i = n.element,
          a = {},
          s = 0,
          c = {},
          l = null;
        se.supportsTouch ? (n.event.bind(i, "touchstart", touchStart), n.event.bind(i, "touchmove", touchMove), n.event.bind(i, "touchend", touchEnd)) : se.supportsIePointer && (window.PointerEvent ? (n.event.bind(i, "pointerdown", touchStart), n.event.bind(i, "pointermove", touchMove), n.event.bind(i, "pointerup", touchEnd)) : window.MSPointerEvent && (n.event.bind(i, "MSPointerDown", touchStart), n.event.bind(i, "MSPointerMove", touchMove), n.event.bind(i, "MSPointerUp", touchEnd)));
      }
      function applyTouchMove(a, s) {
        i.scrollTop -= s, i.scrollLeft -= a, updateGeometry(n);
      }
      function getTouch(n) {
        return n.targetTouches ? n.targetTouches[0] : n;
      }
      function shouldHandle(n) {
        return (!n.pointerType || "pen" !== n.pointerType || 0 !== n.buttons) && (!(!n.targetTouches || 1 !== n.targetTouches.length) || !(!n.pointerType || "mouse" === n.pointerType || n.pointerType === n.MSPOINTER_TYPE_MOUSE));
      }
      function touchStart(n) {
        if (shouldHandle(n)) {
          var i = getTouch(n);
          a.pageX = i.pageX, a.pageY = i.pageY, s = new Date().getTime(), null !== l && clearInterval(l);
        }
      }
      function touchMove(l) {
        if (shouldHandle(l)) {
          var u = getTouch(l),
            d = {
              pageX: u.pageX,
              pageY: u.pageY
            },
            p = d.pageX - a.pageX,
            h = d.pageY - a.pageY;
          if (function shouldBeConsumedByChild(n, a, s) {
            if (!i.contains(n)) return !1;
            for (var c = n; c && c !== i;) {
              if (c.classList.contains(te.consuming)) return !0;
              var l = get(c);
              if (s && l.overflowY.match(/(scroll|auto)/)) {
                var u = c.scrollHeight - c.clientHeight;
                if (u > 0 && (c.scrollTop > 0 && s < 0 || c.scrollTop < u && s > 0)) return !0;
              }
              if (a && l.overflowX.match(/(scroll|auto)/)) {
                var d = c.scrollWidth - c.clientWidth;
                if (d > 0 && (c.scrollLeft > 0 && a < 0 || c.scrollLeft < d && a > 0)) return !0;
              }
              c = c.parentNode;
            }
            return !1;
          }(l.target, p, h)) return;
          applyTouchMove(p, h), a = d;
          var f = new Date().getTime(),
            g = f - s;
          g > 0 && (c.x = p / g, c.y = h / g, s = f), function shouldPrevent(a, s) {
            var c = Math.floor(i.scrollTop),
              l = i.scrollLeft,
              u = Math.abs(a),
              d = Math.abs(s);
            if (d > u) {
              if (s < 0 && c === n.contentHeight - n.containerHeight || s > 0 && 0 === c) return 0 === window.scrollY && s > 0 && se.isChrome;
            } else if (u > d && (a < 0 && l === n.contentWidth - n.containerWidth || a > 0 && 0 === l)) return !0;
            return !0;
          }(p, h) && l.preventDefault();
        }
      }
      function touchEnd() {
        n.settings.swipeEasing && (clearInterval(l), l = setInterval(function () {
          n.isInitialized ? clearInterval(l) : c.x || c.y ? Math.abs(c.x) < .01 && Math.abs(c.y) < .01 ? clearInterval(l) : (applyTouchMove(30 * c.x, 30 * c.y), c.x *= .8, c.y *= .8) : clearInterval(l);
        }, 10));
      }
    }
  },
  le = function PerfectScrollbar(n, i) {
    var a = this;
    if (void 0 === i && (i = {}), "string" == typeof n && (n = document.querySelector(n)), !n || !n.nodeName) throw new Error("no element is specified to initialize PerfectScrollbar");
    for (var s in this.element = n, n.classList.add(Q), this.settings = {
      handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
      maxScrollbarLength: null,
      minScrollbarLength: null,
      scrollingThreshold: 1e3,
      scrollXMarginOffset: 0,
      scrollYMarginOffset: 0,
      suppressScrollX: !1,
      suppressScrollY: !1,
      swipeEasing: !0,
      useBothWheelAxes: !1,
      wheelPropagation: !0,
      wheelSpeed: 1
    }, i) this.settings[s] = i[s];
    this.containerWidth = null, this.containerHeight = null, this.contentWidth = null, this.contentHeight = null;
    var c,
      l,
      focus = function () {
        return n.classList.add(ne.focus);
      },
      blur = function () {
        return n.classList.remove(ne.focus);
      };
    this.isRtl = "rtl" === get(n).direction, !0 === this.isRtl && n.classList.add(ee), this.isNegativeScroll = (l = n.scrollLeft, n.scrollLeft = -1, c = n.scrollLeft < 0, n.scrollLeft = l, c), this.negativeScrollAdjustment = this.isNegativeScroll ? n.scrollWidth - n.clientWidth : 0, this.event = new ae(), this.ownerDocument = n.ownerDocument || document, this.scrollbarXRail = div(te.rail("x")), n.appendChild(this.scrollbarXRail), this.scrollbarX = div(te.thumb("x")), this.scrollbarXRail.appendChild(this.scrollbarX), this.scrollbarX.setAttribute("tabindex", 0), this.event.bind(this.scrollbarX, "focus", focus), this.event.bind(this.scrollbarX, "blur", blur), this.scrollbarXActive = null, this.scrollbarXWidth = null, this.scrollbarXLeft = null;
    var u = get(this.scrollbarXRail);
    this.scrollbarXBottom = parseInt(u.bottom, 10), isNaN(this.scrollbarXBottom) ? (this.isScrollbarXUsingBottom = !1, this.scrollbarXTop = toInt(u.top)) : this.isScrollbarXUsingBottom = !0, this.railBorderXWidth = toInt(u.borderLeftWidth) + toInt(u.borderRightWidth), set(this.scrollbarXRail, {
      display: "block"
    }), this.railXMarginWidth = toInt(u.marginLeft) + toInt(u.marginRight), set(this.scrollbarXRail, {
      display: ""
    }), this.railXWidth = null, this.railXRatio = null, this.scrollbarYRail = div(te.rail("y")), n.appendChild(this.scrollbarYRail), this.scrollbarY = div(te.thumb("y")), this.scrollbarYRail.appendChild(this.scrollbarY), this.scrollbarY.setAttribute("tabindex", 0), this.event.bind(this.scrollbarY, "focus", focus), this.event.bind(this.scrollbarY, "blur", blur), this.scrollbarYActive = null, this.scrollbarYHeight = null, this.scrollbarYTop = null;
    var d = get(this.scrollbarYRail);
    this.scrollbarYRight = parseInt(d.right, 10), isNaN(this.scrollbarYRight) ? (this.isScrollbarYUsingRight = !1, this.scrollbarYLeft = toInt(d.left)) : this.isScrollbarYUsingRight = !0, this.scrollbarYOuterWidth = this.isRtl ? function outerWidth(n) {
      var i = get(n);
      return toInt(i.width) + toInt(i.paddingLeft) + toInt(i.paddingRight) + toInt(i.borderLeftWidth) + toInt(i.borderRightWidth);
    }(this.scrollbarY) : null, this.railBorderYWidth = toInt(d.borderTopWidth) + toInt(d.borderBottomWidth), set(this.scrollbarYRail, {
      display: "block"
    }), this.railYMarginHeight = toInt(d.marginTop) + toInt(d.marginBottom), set(this.scrollbarYRail, {
      display: ""
    }), this.railYHeight = null, this.railYRatio = null, this.reach = {
      x: n.scrollLeft <= 0 ? "start" : n.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
      y: n.scrollTop <= 0 ? "start" : n.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null
    }, this.isAlive = !0, this.settings.handlers.forEach(function (n) {
      return ce[n](a);
    }), this.lastScrollTop = Math.floor(n.scrollTop), this.lastScrollLeft = n.scrollLeft, this.event.bind(this.element, "scroll", function (n) {
      return a.onScroll(n);
    }), updateGeometry(this);
  };
le.prototype.update = function update() {
  this.isAlive && (this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0, set(this.scrollbarXRail, {
    display: "block"
  }), set(this.scrollbarYRail, {
    display: "block"
  }), this.railXMarginWidth = toInt(get(this.scrollbarXRail).marginLeft) + toInt(get(this.scrollbarXRail).marginRight), this.railYMarginHeight = toInt(get(this.scrollbarYRail).marginTop) + toInt(get(this.scrollbarYRail).marginBottom), set(this.scrollbarXRail, {
    display: "none"
  }), set(this.scrollbarYRail, {
    display: "none"
  }), updateGeometry(this), processScrollDiff(this, "top", 0, !1, !0), processScrollDiff(this, "left", 0, !1, !0), set(this.scrollbarXRail, {
    display: ""
  }), set(this.scrollbarYRail, {
    display: ""
  }));
}, le.prototype.onScroll = function onScroll(n) {
  this.isAlive && (updateGeometry(this), processScrollDiff(this, "top", this.element.scrollTop - this.lastScrollTop), processScrollDiff(this, "left", this.element.scrollLeft - this.lastScrollLeft), this.lastScrollTop = Math.floor(this.element.scrollTop), this.lastScrollLeft = this.element.scrollLeft);
}, le.prototype.destroy = function destroy() {
  this.isAlive && (this.event.unbindAll(), remove$1(this.scrollbarX), remove$1(this.scrollbarY), remove$1(this.scrollbarXRail), remove$1(this.scrollbarYRail), this.removePsClasses(), this.element = null, this.scrollbarX = null, this.scrollbarY = null, this.scrollbarXRail = null, this.scrollbarYRail = null, this.isAlive = !1);
}, le.prototype.removePsClasses = function removePsClasses() {
  this.element.className = this.element.className.split(" ").filter(function (n) {
    return !n.match(/^ps([-_].+|)$/);
  }).join(" ");
};
var ue = function select$1(n) {
    var i;
    if ("SELECT" === n.nodeName) n.focus(), i = n.value;else if ("INPUT" === n.nodeName || "TEXTAREA" === n.nodeName) {
      var a = n.hasAttribute("readonly");
      a || n.setAttribute("readonly", ""), n.select(), n.setSelectionRange(0, n.value.length), a || n.removeAttribute("readonly"), i = n.value;
    } else {
      n.hasAttribute("contenteditable") && n.focus();
      var s = window.getSelection(),
        c = document.createRange();
      c.selectNodeContents(n), s.removeAllRanges(), s.addRange(c), i = s.toString();
    }
    return i;
  },
  de = createCommonjsModule(function (n, i) {
    !function (n, i) {
      var a = _interopRequireDefault(i);
      function _interopRequireDefault(n) {
        return n && n.__esModule ? n : {
          default: n
        };
      }
      var s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      };
      function _classCallCheck(n, i) {
        if (!(n instanceof i)) throw new TypeError("Cannot call a class as a function");
      }
      var c = function () {
          function defineProperties(n, i) {
            for (var a = 0; a < i.length; a++) {
              var s = i[a];
              s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(n, s.key, s);
            }
          }
          return function (n, i, a) {
            return i && defineProperties(n.prototype, i), a && defineProperties(n, a), n;
          };
        }(),
        l = function () {
          function ClipboardAction(n) {
            _classCallCheck(this, ClipboardAction), this.resolveOptions(n), this.initSelection();
          }
          return c(ClipboardAction, [{
            key: "resolveOptions",
            value: function resolveOptions() {
              var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              this.action = n.action, this.container = n.container, this.emitter = n.emitter, this.target = n.target, this.text = n.text, this.trigger = n.trigger, this.selectedText = "";
            }
          }, {
            key: "initSelection",
            value: function initSelection() {
              this.text ? this.selectFake() : this.target && this.selectTarget();
            }
          }, {
            key: "selectFake",
            value: function selectFake() {
              var n = this,
                i = "rtl" == document.documentElement.getAttribute("dir");
              this.removeFake(), this.fakeHandlerCallback = function () {
                return n.removeFake();
              }, this.fakeHandler = this.container.addEventListener("click", this.fakeHandlerCallback) || !0, this.fakeElem = document.createElement("textarea"), this.fakeElem.style.fontSize = "12pt", this.fakeElem.style.border = "0", this.fakeElem.style.padding = "0", this.fakeElem.style.margin = "0", this.fakeElem.style.position = "absolute", this.fakeElem.style[i ? "right" : "left"] = "-9999px";
              var s = window.pageYOffset || document.documentElement.scrollTop;
              this.fakeElem.style.top = s + "px", this.fakeElem.setAttribute("readonly", ""), this.fakeElem.value = this.text, this.container.appendChild(this.fakeElem), this.selectedText = (0, a.default)(this.fakeElem), this.copyText();
            }
          }, {
            key: "removeFake",
            value: function removeFake() {
              this.fakeHandler && (this.container.removeEventListener("click", this.fakeHandlerCallback), this.fakeHandler = null, this.fakeHandlerCallback = null), this.fakeElem && (this.container.removeChild(this.fakeElem), this.fakeElem = null);
            }
          }, {
            key: "selectTarget",
            value: function selectTarget() {
              this.selectedText = (0, a.default)(this.target), this.copyText();
            }
          }, {
            key: "copyText",
            value: function copyText() {
              var n = void 0;
              try {
                n = document.execCommand(this.action);
              } catch (i) {
                n = !1;
              }
              this.handleResult(n);
            }
          }, {
            key: "handleResult",
            value: function handleResult(n) {
              this.emitter.emit(n ? "success" : "error", {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
              });
            }
          }, {
            key: "clearSelection",
            value: function clearSelection() {
              this.trigger && this.trigger.focus(), window.getSelection().removeAllRanges();
            }
          }, {
            key: "destroy",
            value: function destroy() {
              this.removeFake();
            }
          }, {
            key: "action",
            set: function set() {
              var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "copy";
              if (this._action = n, "copy" !== this._action && "cut" !== this._action) throw new Error('Invalid "action" value, use either "copy" or "cut"');
            },
            get: function get() {
              return this._action;
            }
          }, {
            key: "target",
            set: function set(n) {
              if (void 0 !== n) {
                if (!n || "object" !== (void 0 === n ? "undefined" : s(n)) || 1 !== n.nodeType) throw new Error('Invalid "target" value, use a valid Element');
                if ("copy" === this.action && n.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                if ("cut" === this.action && (n.hasAttribute("readonly") || n.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                this._target = n;
              }
            },
            get: function get() {
              return this._target;
            }
          }]), ClipboardAction;
        }();
      n.exports = l;
    }(n, ue);
  });
function E() {}
unwrapExports(de), E.prototype = {
  on: function (n, i, a) {
    var s = this.e || (this.e = {});
    return (s[n] || (s[n] = [])).push({
      fn: i,
      ctx: a
    }), this;
  },
  once: function (n, i, a) {
    var s = this;
    function listener() {
      s.off(n, listener), i.apply(a, arguments);
    }
    return listener._ = i, this.on(n, listener, a);
  },
  emit: function (n) {
    for (var i = [].slice.call(arguments, 1), a = ((this.e || (this.e = {}))[n] || []).slice(), s = 0, c = a.length; s < c; s++) a[s].fn.apply(a[s].ctx, i);
    return this;
  },
  off: function (n, i) {
    var a = this.e || (this.e = {}),
      s = a[n],
      c = [];
    if (s && i) for (var l = 0, u = s.length; l < u; l++) s[l].fn !== i && s[l].fn._ !== i && c.push(s[l]);
    return c.length ? a[n] = c : delete a[n], this;
  }
};
var pe = E,
  he = createCommonjsModule(function (n, i) {
    i.node = function (n) {
      return void 0 !== n && n instanceof HTMLElement && 1 === n.nodeType;
    }, i.nodeList = function (n) {
      var a = Object.prototype.toString.call(n);
      return void 0 !== n && ("[object NodeList]" === a || "[object HTMLCollection]" === a) && "length" in n && (0 === n.length || i.node(n[0]));
    }, i.string = function (n) {
      return "string" == typeof n || n instanceof String;
    }, i.fn = function (n) {
      return "[object Function]" === Object.prototype.toString.call(n);
    };
  });
he.node, he.nodeList, he.string, he.fn;
if ("undefined" != typeof Element && !Element.prototype.matches) {
  var fe = Element.prototype;
  fe.matches = fe.matchesSelector || fe.mozMatchesSelector || fe.msMatchesSelector || fe.oMatchesSelector || fe.webkitMatchesSelector;
}
var ge = function closest(n, i) {
  for (; n && 9 !== n.nodeType;) {
    if ("function" == typeof n.matches && n.matches(i)) return n;
    n = n.parentNode;
  }
};
function listener(n, i, a, s) {
  return function (a) {
    a.delegateTarget = ge(a.target, i), a.delegateTarget && s.call(n, a);
  };
}
var me = function delegate(n, i, a, s, c) {
  var l = listener.apply(this, arguments);
  return n.addEventListener(a, l, c), {
    destroy: function () {
      n.removeEventListener(a, l, c);
    }
  };
};
var ve = function listen(n, i, a) {
    if (!n && !i && !a) throw new Error("Missing required arguments");
    if (!he.string(i)) throw new TypeError("Second argument must be a String");
    if (!he.fn(a)) throw new TypeError("Third argument must be a Function");
    if (he.node(n)) return function listenNode(n, i, a) {
      return n.addEventListener(i, a), {
        destroy: function () {
          n.removeEventListener(i, a);
        }
      };
    }(n, i, a);
    if (he.nodeList(n)) return function listenNodeList(n, i, a) {
      return Array.prototype.forEach.call(n, function (n) {
        n.addEventListener(i, a);
      }), {
        destroy: function () {
          Array.prototype.forEach.call(n, function (n) {
            n.removeEventListener(i, a);
          });
        }
      };
    }(n, i, a);
    if (he.string(n)) return function listenSelector(n, i, a) {
      return me(document.body, n, i, a);
    }(n, i, a);
    throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
  },
  ye = unwrapExports(createCommonjsModule(function (n, i) {
    !function (n, i, a, s) {
      var c = _interopRequireDefault(i),
        l = _interopRequireDefault(a),
        u = _interopRequireDefault(s);
      function _interopRequireDefault(n) {
        return n && n.__esModule ? n : {
          default: n
        };
      }
      var d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      };
      function _classCallCheck(n, i) {
        if (!(n instanceof i)) throw new TypeError("Cannot call a class as a function");
      }
      var p = function () {
        function defineProperties(n, i) {
          for (var a = 0; a < i.length; a++) {
            var s = i[a];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(n, s.key, s);
          }
        }
        return function (n, i, a) {
          return i && defineProperties(n.prototype, i), a && defineProperties(n, a), n;
        };
      }();
      function _possibleConstructorReturn(n, i) {
        if (!n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !i || "object" != typeof i && "function" != typeof i ? n : i;
      }
      function _inherits(n, i) {
        if ("function" != typeof i && null !== i) throw new TypeError("Super expression must either be null or a function, not " + typeof i);
        n.prototype = Object.create(i && i.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), i && (Object.setPrototypeOf ? Object.setPrototypeOf(n, i) : n.__proto__ = i);
      }
      var h = function (n) {
        function Clipboard(n, i) {
          _classCallCheck(this, Clipboard);
          var a = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
          return a.resolveOptions(i), a.listenClick(n), a;
        }
        return _inherits(Clipboard, n), p(Clipboard, [{
          key: "resolveOptions",
          value: function resolveOptions() {
            var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.action = "function" == typeof n.action ? n.action : this.defaultAction, this.target = "function" == typeof n.target ? n.target : this.defaultTarget, this.text = "function" == typeof n.text ? n.text : this.defaultText, this.container = "object" === d(n.container) ? n.container : document.body;
          }
        }, {
          key: "listenClick",
          value: function listenClick(n) {
            var i = this;
            this.listener = (0, u.default)(n, "click", function (n) {
              return i.onClick(n);
            });
          }
        }, {
          key: "onClick",
          value: function onClick(n) {
            var i = n.delegateTarget || n.currentTarget;
            this.clipboardAction && (this.clipboardAction = null), this.clipboardAction = new c.default({
              action: this.action(i),
              target: this.target(i),
              text: this.text(i),
              container: this.container,
              trigger: i,
              emitter: this
            });
          }
        }, {
          key: "defaultAction",
          value: function defaultAction(n) {
            return getAttributeValue("action", n);
          }
        }, {
          key: "defaultTarget",
          value: function defaultTarget(n) {
            var i = getAttributeValue("target", n);
            if (i) return document.querySelector(i);
          }
        }, {
          key: "defaultText",
          value: function defaultText(n) {
            return getAttributeValue("text", n);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.listener.destroy(), this.clipboardAction && (this.clipboardAction.destroy(), this.clipboardAction = null);
          }
        }], [{
          key: "isSupported",
          value: function isSupported() {
            var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ["copy", "cut"],
              i = "string" == typeof n ? [n] : n,
              a = !!document.queryCommandSupported;
            return i.forEach(function (n) {
              a = a && !!document.queryCommandSupported(n);
            }), a;
          }
        }]), Clipboard;
      }(l.default);
      function getAttributeValue(n, i) {
        var a = "data-clipboard-" + n;
        if (i.hasAttribute(a)) return i.getAttribute(a);
      }
      n.exports = h;
    }(n, de, pe, ve);
  }));
function isInShadow(n) {
  for (var i = n && n.parentNode; i;) {
    if ("[object ShadowRoot]" === i.toString()) return !0;
    i = i.parentNode;
  }
  return !1;
}
function addListeners(i, a) {
  var s = a.elements;
  s.textElement.addEventListener("click", function (s) {
    return function showCandidates(i, a, s) {
      var c = s,
        l = s.elements;
      if (i.target.id !== "prompter-text".concat(s.randomString)) {
        var u = i.target.id.replace("word-", "").replace(s.randomString, ""),
          d = JSON.parse(a.exports[n.Exports.JIIX]).words;
        if (c.wordToChange = d[u], c.wordToChange.id = u, l.candidatesElement.innerHTML = "", c.wordToChange && c.wordToChange.candidates) {
          l.candidatesElement.style.display = "flex", c.wordToChange.candidates.forEach(function (n, i) {
            c.wordToChange.label === n ? l.candidatesElement.innerHTML += '<span id="cdt-'.concat(i).concat(s.randomString, '" class="selected-word">').concat(n, "</span>") : l.candidatesElement.innerHTML += '<span id="cdt-'.concat(i).concat(s.randomString, '">').concat(n, "</span>");
          });
          var p = i.target.getBoundingClientRect().left - 60;
          l.candidatesElement.style.top = "".concat(48, "px"), l.candidatesElement.style.left = "".concat(p, "px"), i.target.parentNode.parentNode.parentNode.insertBefore(l.candidatesElement, i.target.parentNode.parentNode);
        }
      }
    }(s, i, a);
  }), s.candidatesElement.addEventListener("click", function (s) {
    return function clickCandidate(i, a, s) {
      var c = s,
        l = s.elements,
        u = i.target.innerText;
      if (u !== c.wordToChange.label && c.wordToChange.candidates.includes(u)) {
        var d = JSON.parse(a.exports[n.Exports.JIIX]);
        d.words[c.wordToChange.id].label = u, a.import_(JSON.stringify(d), n.Exports.JIIX);
      }
      l.candidatesElement.style.display = "none";
    }(s, i, a);
  }), s.ellipsisElement.addEventListener("click", function (n) {
    return function showActions(n, i) {
      var a = i,
        s = function positionActions() {
          var i = n.target.offsetLeft - 68;
          a.menuElement.style.left = "".concat(i, "px");
        },
        c = document.contains(a.menuElement);
      isInShadow(a.menuElement) || c ? "none" === a.menuElement.style.display && (s(), a.menuElement.style.display = "flex") : (a.menuElement.style.display = "flex", s(), function insertActions() {
        a.menuElement.appendChild(a.convertElement), a.menuElement.appendChild(a.copyElement), a.menuElement.appendChild(a.deleteElement), n.target.parentNode.insertBefore(a.menuElement, n.target);
      }());
    }(n, s);
  }), s.copyElement.addEventListener("click", function () {
    s.menuElement.style.display = "none";
  }), s.convertElement.addEventListener("click", function () {
    s.menuElement.style.display = "none", i.convert();
  }), s.deleteElement.addEventListener("click", function () {
    s.menuElement.style.display = "none", i.clear();
  });
}
function createSmartGuide(n) {
  var i = "-" + Math.random().toString(10).substring(2, 12),
    a = function createHTMLElements(n) {
      var i = document.createElement("div");
      i.id = "smartguide" + n, i.classList.add("smartguide");
      var a = document.createElement("div");
      a.id = "prompter-text" + n, a.classList.add("prompter-text"), a.setAttribute("touch-action", "none");
      var s = document.createElement("div");
      s.id = "prompter-text-container" + n, s.classList.add("prompter-text-container"), s.appendChild(a);
      var c = document.createElement("div");
      c.id = "ellipsis" + n, c.classList.add("ellipsis"), c.innerHTML = "...";
      var l = document.createElement("div");
      l.id = "tag-icon" + n, l.classList.add("tag-icon"), l.innerHTML = "&#182;";
      var u = document.createElement("div");
      u.id = "candidates" + n, u.classList.add("candidates");
      var d = document.createElement("div");
      d.id = "more-menu" + n, d.classList.add("more-menu");
      var p = document.createElement("button");
      p.classList.add("options-label-button"), p.id = "convert" + n, p.innerHTML = "Convert";
      var h = document.createElement("button");
      h.classList.add("options-label-button"), h.id = "copy" + n, h.innerHTML = "Copy";
      var f = document.createElement("button");
      return f.classList.add("options-label-button"), f.id = "delete" + n, f.innerHTML = "Delete", {
        smartGuideElement: i,
        textElement: a,
        textContainer: s,
        candidatesElement: u,
        menuElement: d,
        tagElement: l,
        ellipsisElement: c,
        convertElement: p,
        copyElement: h,
        deleteElement: f
      };
    }(i),
    s = (new ye(a.copyElement), {
      editor: n,
      wordToChange: "",
      lastWord: "",
      previousLabelExport: " ",
      perfectScrollbar: new le(a.textContainer, {
        suppressScrollY: !0,
        scrollXMarginOffset: 1
      }),
      elements: a,
      smartGuideTimeOutId: 0,
      randomString: i
    });
  return addListeners(n, s), n.configuration.recognitionParams.iink.text.smartGuideFadeOut.enable && function callFadeOutObserver() {
    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1e4,
      i = arguments.length > 1 ? arguments[1] : void 0,
      a = i,
      s = i.elements;
    new MutationObserver(function (i) {
      i.forEach(function () {
        a.smartGuideTimeOutId && clearTimeout(a.smartGuideTimeOutId), "none" === s.candidatesElement.style.display && "none" === s.menuElement.style.display ? a.smartGuideTimeOutId = setTimeout(function () {
          s.smartGuideElement.classList.add("smartguide-out"), s.smartGuideElement.classList.remove("smartguide-in");
        }, n) : document.contains(s.candidatesElement) || document.contains(s.menuElement) || (a.smartGuideTimeOutId = setTimeout(function () {
          s.smartGuideElement.classList.add("smartguide-out"), s.smartGuideElement.classList.remove("smartguide-in");
        }, n));
      });
    }).observe(s.smartGuideElement, {
      childList: !0,
      subtree: !0,
      attributes: !0
    });
  }(n.configuration.recognitionParams.iink.text.smartGuideFadeOut.duration, s), s;
}
function resize$2(n) {
  var i = n,
    a = n.elements,
    s = 3.779527559 * i.editor.configuration.recognitionParams.iink.text.margin.left,
    c = i.editor.domElement.clientWidth - s - a.tagElement.offsetWidth - 35 - s;
  a.textContainer.style.width = "".concat(c, "px"), a.textContainer.style.maxWidth = "".concat(c, "px"), s = a.tagElement.offsetWidth, s += c, a.ellipsisElement.style.left = "".concat(s, "px"), a.smartGuideElement.style.width = "".concat(a.tagElement.offsetWidth + a.textContainer.offsetWidth + a.ellipsisElement.offsetWidth, "px"), i.perfectScrollbar.update();
}
function launchSmartGuide(i, a) {
  var s = i,
    c = i.elements,
    l = document.contains(c.smartGuideElement);
  isInShadow(c.smartGuideElement) || l || function insertSmartGuide(n) {
    var i = n,
      a = n.elements,
      s = 3.779527559,
      c = i.editor.configuration.recognitionParams.iink.text.margin.top * s,
      l = i.editor.configuration.recognitionParams.iink.text.margin.left * s;
    !function insertSmartGuideElement(n, s) {
      a.smartGuideElement.style.top = "".concat(s, "px"), a.smartGuideElement.style.left = "".concat(n, "px"), a.smartGuideElement.style.visibility = "hidden", i.editor.domElement.insertBefore(a.smartGuideElement, i.editor.loader);
    }(l, c - 45.354330708), function insertTag() {
      a.smartGuideElement.appendChild(a.tagElement);
    }();
    var u = i.editor.domElement.clientWidth - l - a.tagElement.offsetWidth - 35 - l;
    (function insertTextContainer(n, i) {
      a.textContainer.style.left = "".concat(n, "px"), a.textContainer.style.width = "".concat(i, "px"), a.textContainer.style.maxWidth = "".concat(i, "px"), a.smartGuideElement.appendChild(a.textContainer);
    })(l = a.tagElement.offsetWidth, u), function insertEllipsis(n) {
      a.ellipsisElement.style.left = "".concat(n, "px"), a.smartGuideElement.appendChild(a.ellipsisElement);
    }(l += u), a.menuElement.style.display = "none", a.menuElement.appendChild(a.convertElement), a.menuElement.appendChild(a.copyElement), a.menuElement.appendChild(a.deleteElement), a.smartGuideElement.appendChild(a.menuElement), a.candidatesElement.style.display = "none", a.smartGuideElement.appendChild(a.candidatesElement), a.smartGuideElement.style.height = "48px", a.smartGuideElement.style.width = "".concat(a.tagElement.offsetWidth + a.textContainer.offsetWidth + a.ellipsisElement.offsetWidth, "px"), i.perfectScrollbar.update();
  }(i);
  var u = function createWordSpan(n, a, s) {
    var c = document.createElement("span");
    return c.id = "word-".concat(a).concat(i.randomString), n ? c.innerHTML = "&nbsp;" : c.textContent = s.label, c;
  };
  if (a && JSON.parse(a[n.Exports.JIIX]).words.length > 0) {
    if (c.smartGuideElement.classList.add("smartguide-in"), c.smartGuideElement.classList.remove("smartguide-out"), c.candidatesElement.style.display = "none", c.menuElement.style.display = "none", s.previousLabelExport && s.previousLabelExport !== JSON.parse(a[n.Exports.JIIX]).label) {
      var d = JSON.parse(a[n.Exports.JIIX]).words;
      !function populatePrompter(n) {
        c.textElement.innerHTML = "";
        var i = document.createDocumentFragment();
        n.forEach(function (a, l) {
          if (" " === a.label || a.label.includes("\n")) i.appendChild(u(!0, l));else if (l !== n.length - 1) i.appendChild(u(!1, l, a));else {
            c.textElement.appendChild(i), s.perfectScrollbar.update(), "" === s.lastWord && (s.lastWord = a);
            var d = u(!1, l, a);
            s.lastWord.candidates !== a.candidates && s.lastWord.label !== a.label ? (d.classList.add("added-word"), c.textElement.appendChild(d), c.textContainer.scrollLeft = d.offsetLeft, s.lastWord = a) : (c.textElement.appendChild(d), c.textContainer.scrollLeft = d.offsetLeft);
          }
        });
      }(d), function addAnimationToModifiedWord(l) {
        if (s.tempWords && s.tempWords.length === l.length) {
          var u = l.map(function (n) {
              return n.label;
            }),
            d = s.tempWords.map(function (n) {
              return n.label;
            }),
            p = u.indexOf(u.filter(function (n) {
              return -1 === d.indexOf(n);
            })[0]);
          document.getElementById("word-".concat(p).concat(i.randomString)) && p > -1 && (document.getElementById("word-".concat(p).concat(i.randomString)).classList.add("modified-word"), c.textContainer.scrollLeft = document.getElementById("word-".concat(p).concat(i.randomString)).offsetLeft - 10);
        }
        s.tempWords = JSON.parse(a[n.Exports.JIIX]).words;
      }(d);
    }
    s.previousLabelExport = JSON.parse(a[n.Exports.JIIX]).label, c.copyElement.setAttribute("data-clipboard-text", JSON.parse(a[n.Exports.JIIX]).label);
  } else c.smartGuideElement.classList.add("smartguide-out"), c.smartGuideElement.classList.remove("smartguide-in");
  return s;
}
var be = function _classCallCheck(n, i) {
  if (!(n instanceof i)) throw new TypeError("Cannot call a class as a function");
};
function _defineProperties(n, i) {
  for (var a = 0; a < i.length; a++) {
    var s = i[a];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(n, s.key, s);
  }
}
var xe = function _createClass(n, i, a) {
  return i && _defineProperties(n.prototype, i), a && _defineProperties(n, a), n;
};
function updateUndoRedoState(n) {
  var i = n;
  return i.canUndo = n.currentPosition > 0, i.canRedo = n.currentPosition < n.stack.length - 1, i;
}
function getModel(n) {
  for (var i = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], a = n.stack[n.currentPosition], s = arguments.length, c = new Array(s > 2 ? s - 2 : 0), l = 2; l < s; l++) c[l - 2] = arguments[l];
  var u = {
    res: i ? cloneModel(a) : a,
    types: c
  };
  return Promise.resolve(u);
}
var we = Object.freeze({
  __proto__: null,
  getModel: getModel,
  updateModel: function updateModel(i, a) {
    var s = i.stack.findIndex(function (n) {
        return n.modificationTime === a.modificationTime && n.rawStrokes.length === a.rawStrokes.length;
      }),
      l = a;
    l.modificationTime = new Date().getTime();
    var u = [];
    if (s > -1) i.stack.splice(s, 1, cloneModel(l)), c.debug("model updated", l);else {
      var d = i;
      d.currentPosition += 1, d.stack = d.stack.slice(0, d.currentPosition), d.stack.push(cloneModel(l)), d.stack.length > d.maxSize && (d.stack.shift(), d.currentPosition--), c.debug("model pushed", l), u.push(n.EventType.CHANGED);
    }
    return updateUndoRedoState(i), c.debug("undo/redo stack updated", i), getModel.apply(void 0, [i, !1].concat(u));
  },
  undo: function undo(i, a) {
    var s = i;
    return s.currentPosition > 0 && (s.currentPosition -= 1, updateUndoRedoState(i), c.debug("undo index", s.currentPosition)), getModel(i, !0, n.EventType.CHANGED, n.EventType.EXPORTED);
  },
  redo: function redo(i, a) {
    var s = i;
    return s.currentPosition < s.stack.length - 1 && (s.currentPosition += 1, updateUndoRedoState(i), c.debug("redo index", s.currentPosition)), getModel(i, !0, n.EventType.CHANGED, n.EventType.EXPORTED);
  }
});
function createCanvas$1(n) {
  var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10,
    a = document,
    s = a.createElement("canvas");
  return s.width = Math.abs(n.maxX - n.minX) + 2 * i, s.style.width = "".concat(s.width, "px"), s.height = Math.abs(n.maxY - n.minY) + 2 * i, s.style.height = "".concat(s.height, "px"), s;
}
var Ee = Object.freeze({
  __proto__: null,
  inkImporter: function inkImporter(n, i, a, c) {
    var l = n;
    s.debug("inkImporter start importing =>", i);
    var u = Object.assign({}, l.behavior.grabber);
    u.detach = l.behavior.grabber.detach, l.behavior.grabber = {};
    var d = [];
    i.forEach(function (n) {
      n.convert ? d.push({
        action: "convert",
        value: !0
      }) : n.setDelay ? d.push({
        action: "setDelay",
        value: n.setDelay
      }) : (n.color && d.push({
        action: "setColor",
        value: n.color
      }), n.X.forEach(function (i, a) {
        var s = "move";
        0 === a ? s = "down" : a === n.X.length - 1 && (s = "up"), d.push({
          action: s,
          point: {
            x: n.X[a],
            y: n.Y[a]
          }
        });
      }));
    }), s.debug("Array of actions =>", d), function play(n, i, a) {
      if (i < n.length) {
        var s = n[i],
          d = a;
        if ("convert" === s.action ? l.convert() : "setDelay" === s.action ? d = s.value : "setColor" === s.action ? l.penStyle = {
          color: s.value
        } : (s.point.t = new Date().getTime(), "down" === s.action ? l.pointerDown(s.point) : "up" === s.action ? l.pointerUp(s.point) : "move" === s.action && l.pointerMove(s.point)), c && i === n.map(function (n) {
          return n.action;
        }).lastIndexOf("down") - 1) setTimeout(function () {
          play(n, i + 1, d);
        }, c);else if (i === n.length - 1) {
          var p = new Event("drawEnded");
          document.dispatchEvent(p), l.behavior.grabber = u;
        } else setTimeout(function () {
          play(n, i + 1, d);
        }, d);
      }
    }(d, 0, a);
  },
  importStrokeGroups: function importStrokeGroups(n, i) {
    i.forEach(function (i) {
      i.strokes.forEach(function (a) {
        addStroke(n.model, a), addStrokeToGroup(n.model, a, i.penStyle);
      });
    }), n.renderer.drawModel(n.rendererContext, n.model, n.stroker);
  }
});
function destructurePromise() {
  var n, i;
  return {
    promise: new Promise(function (a, s) {
      n = a, i = s;
    }),
    resolve: n,
    reject: i
  };
}
function delay(n) {
  var i = null;
  return {
    promise: new Promise(function (a) {
      i = setTimeout(a, n);
    }),
    timer: i
  };
}
function manageResetState(n, i) {
  return n.recognizer.reset && isResetRequired(n.recognizerContext, i) ? n.recognizer.reset(n.recognizerContext, i) : null;
}
function isTriggerValid(n, i) {
  var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : n.configuration.triggers[i];
  return !(!n.recognizer || !n.recognizer.getInfo().availableTriggers[i].includes(a)) || (s.error("".concat(a, " is not a valid trigger for ").concat(i)), !1);
}
function _addStrokes() {
  return (_addStrokes = Y(G.mark(function _callee4(n, i) {
    var a,
      s,
      c = arguments;
    return G.wrap(function _callee4$(l) {
      for (;;) switch (l.prev = l.next) {
        case 0:
          if (a = c.length > 2 && void 0 !== c[2] ? c[2] : n.configuration.triggers.addStrokes, !n.recognizer || !n.recognizer.addStrokes) {
            l.next = 13;
            break;
          }
          return l.next = 4, n.recognizerContext.initPromise;
        case 4:
          if (!l.sent) {
            l.next = 13;
            break;
          }
          if (!isTriggerValid(n, "addStrokes", a)) {
            l.next = 13;
            break;
          }
          return l.next = 9, manageResetState(n, i);
        case 9:
          if (!(s = l.sent)) {
            l.next = 12;
            break;
          }
          return l.abrupt("return", n.recognizer.addStrokes(n.recognizerContext, s));
        case 12:
          return l.abrupt("return", n.recognizer.addStrokes(n.recognizerContext, i));
        case 13:
          return l.abrupt("return", Promise.reject(new Error("Cannot addStrokes")));
        case 14:
        case "end":
          return l.stop();
      }
    }, _callee4);
  }))).apply(this, arguments);
}
function _launchPointerEvents() {
  return (_launchPointerEvents = Y(G.mark(function _callee5(n, i, a) {
    return G.wrap(function _callee5$(s) {
      for (;;) switch (s.prev = s.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.pointerEvents) {
            s.next = 6;
            break;
          }
          return s.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!s.sent) {
            s.next = 6;
            break;
          }
          return s.abrupt("return", n.recognizer.pointerEvents(n.recognizerContext, i, a));
        case 6:
          return s.abrupt("return", Promise.reject(new Error("Cannot launch pointerEvents")));
        case 7:
        case "end":
          return s.stop();
      }
    }, _callee5);
  }))).apply(this, arguments);
}
function launchExport(n, i, a) {
  return _launchExport.apply(this, arguments);
}
function _launchExport() {
  return (_launchExport = Y(G.mark(function _callee6(i, a, s) {
    var c,
      l,
      u,
      d,
      p,
      h = arguments;
    return G.wrap(function _callee6$(f) {
      for (;;) switch (f.prev = f.next) {
        case 0:
          if (c = h.length > 3 && void 0 !== h[3] ? h[3] : i.configuration.triggers.exportContent, !i.recognizer || !i.recognizer.export_) {
            f.next = 20;
            break;
          }
          return f.next = 4, i.recognizerContext.initPromise;
        case 4:
          if (!f.sent) {
            f.next = 20;
            break;
          }
          if (!isTriggerValid(i, "exportContent", c)) {
            f.next = 20;
            break;
          }
          return l = i, window.clearTimeout(i.exportTimer), u = c === n.Trigger.QUIET_PERIOD ? i.configuration.triggerDelay : 0, d = delay(u), l.exportTimer = d.timer, f.next = 14, d.promise;
        case 14:
          return f.next = 16, manageResetState(i, a);
        case 16:
          if (!(p = f.sent)) {
            f.next = 19;
            break;
          }
          return f.abrupt("return", i.recognizer.export_(i.recognizerContext, p, s));
        case 19:
          return f.abrupt("return", i.recognizer.export_(i.recognizerContext, a, s));
        case 20:
          return f.abrupt("return", Promise.reject(new Error("Cannot launch export")));
        case 21:
        case "end":
          return f.stop();
      }
    }, _callee6);
  }))).apply(this, arguments);
}
function _launchImport() {
  return (_launchImport = Y(G.mark(function _callee7(n, i, a) {
    return G.wrap(function _callee7$(s) {
      for (;;) switch (s.prev = s.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.import_) {
            s.next = 6;
            break;
          }
          return s.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!s.sent) {
            s.next = 6;
            break;
          }
          return s.abrupt("return", n.recognizer.import_(n.recognizerContext, i, a));
        case 6:
          return s.abrupt("return", Promise.reject(new Error("Cannot launch import")));
        case 7:
        case "end":
          return s.stop();
      }
    }, _callee7);
  }))).apply(this, arguments);
}
function _launchGetSupportedImportMimeTypes() {
  return (_launchGetSupportedImportMimeTypes = Y(G.mark(function _callee8(n, i) {
    return G.wrap(function _callee8$(a) {
      for (;;) switch (a.prev = a.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.getSupportedImportMimeTypes) {
            a.next = 6;
            break;
          }
          return a.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!a.sent) {
            a.next = 6;
            break;
          }
          return a.abrupt("return", n.recognizer.getSupportedImportMimeTypes(n.recognizerContext, i));
        case 6:
          return a.abrupt("return", Promise.reject(new Error("Cannot launch getSupportedImportMimeTypes")));
        case 7:
        case "end":
          return a.stop();
      }
    }, _callee8);
  }))).apply(this, arguments);
}
function launchConvert(n, i, a) {
  return _launchConvert.apply(this, arguments);
}
function _launchConvert() {
  return (_launchConvert = Y(G.mark(function _callee9(n, i, a) {
    return G.wrap(function _callee9$(s) {
      for (;;) switch (s.prev = s.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.convert) {
            s.next = 6;
            break;
          }
          return s.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!s.sent) {
            s.next = 6;
            break;
          }
          return s.abrupt("return", n.recognizer.convert(n.recognizerContext, i, a));
        case 6:
          return s.abrupt("return", Promise.reject(new Error("Cannot launch convert")));
        case 7:
        case "end":
          return s.stop();
      }
    }, _callee9);
  }))).apply(this, arguments);
}
function launchConfig(n, i) {
  return _launchConfig.apply(this, arguments);
}
function _launchConfig() {
  return (_launchConfig = Y(G.mark(function _callee10(n, i) {
    return G.wrap(function _callee10$(a) {
      for (;;) switch (a.prev = a.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.sendConfiguration) {
            a.next = 6;
            break;
          }
          return a.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!a.sent) {
            a.next = 6;
            break;
          }
          return a.abrupt("return", n.recognizer.sendConfiguration(n.recognizerContext, i));
        case 6:
          return a.abrupt("return", Promise.reject(new Error("Cannot launch config")));
        case 7:
        case "end":
          return a.stop();
      }
    }, _callee10);
  }))).apply(this, arguments);
}
function _launchResize() {
  return (_launchResize = Y(G.mark(function _callee11(n, i) {
    var a, s;
    return G.wrap(function _callee11$(c) {
      for (;;) switch (c.prev = c.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.resize) {
            c.next = 13;
            break;
          }
          return c.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!c.sent) {
            c.next = 13;
            break;
          }
          return a = n, window.clearTimeout(n.resizeTimer), s = delay(n.configuration.resizeTriggerDelay), a.resizeTimer = s.timer, resize$2(n.smartGuide), c.next = 12, s.promise;
        case 12:
          return c.abrupt("return", n.recognizer.resize(n.recognizerContext, i, n.domElement));
        case 13:
          return c.abrupt("return", Promise.reject(new Error("Cannot launch resize")));
        case 14:
        case "end":
          return c.stop();
      }
    }, _callee11);
  }))).apply(this, arguments);
}
function _launchWaitForIdle() {
  return (_launchWaitForIdle = Y(G.mark(function _callee12(n, i) {
    return G.wrap(function _callee12$(a) {
      for (;;) switch (a.prev = a.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.waitForIdle) {
            a.next = 6;
            break;
          }
          return a.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!a.sent) {
            a.next = 6;
            break;
          }
          return a.abrupt("return", n.recognizer.waitForIdle(n.recognizerContext, i));
        case 6:
          return a.abrupt("return", Promise.reject(new Error("Cannot launch wait for idle")));
        case 7:
        case "end":
          return a.stop();
      }
    }, _callee12);
  }))).apply(this, arguments);
}
function _launchClose() {
  return (_launchClose = Y(G.mark(function _callee13(n, i) {
    return G.wrap(function _callee13$(a) {
      for (;;) switch (a.prev = a.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.close) {
            a.next = 6;
            break;
          }
          return a.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!a.sent) {
            a.next = 6;
            break;
          }
          return a.abrupt("return", n.recognizer.close(n.recognizerContext, i));
        case 6:
          return a.abrupt("return", Promise.reject(new Error("Cannot launch close")));
        case 7:
        case "end":
          return a.stop();
      }
    }, _callee13);
  }))).apply(this, arguments);
}
function setPenStyle(n, i) {
  return _setPenStyle.apply(this, arguments);
}
function _setPenStyle() {
  return (_setPenStyle = Y(G.mark(function _callee14(n, i) {
    return G.wrap(function _callee14$(a) {
      for (;;) switch (a.prev = a.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.setPenStyle) {
            a.next = 7;
            break;
          }
          return a.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!a.sent) {
            a.next = 6;
            break;
          }
          return a.abrupt("return", n.recognizer.setPenStyle(n.recognizerContext, i, n.penStyle));
        case 6:
          return a.abrupt("return", Promise.reject(new Error("Cannot set pentStyle")));
        case 7:
          return a.abrupt("return", null);
        case 8:
        case "end":
          return a.stop();
      }
    }, _callee14);
  }))).apply(this, arguments);
}
function setPenStyleClasses(n, i) {
  return _setPenStyleClasses.apply(this, arguments);
}
function _setPenStyleClasses() {
  return (_setPenStyleClasses = Y(G.mark(function _callee15(n, i) {
    return G.wrap(function _callee15$(a) {
      for (;;) switch (a.prev = a.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.setPenStyleClasses) {
            a.next = 7;
            break;
          }
          return a.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!a.sent) {
            a.next = 6;
            break;
          }
          return a.abrupt("return", n.recognizer.setPenStyleClasses(n.recognizerContext, i, n.penStyleClasses));
        case 6:
          return a.abrupt("return", Promise.reject(new Error("Cannot set penStyleClasses")));
        case 7:
          return a.abrupt("return", null);
        case 8:
        case "end":
          return a.stop();
      }
    }, _callee15);
  }))).apply(this, arguments);
}
function setTheme(n, i) {
  return _setTheme.apply(this, arguments);
}
function _setTheme() {
  return (_setTheme = Y(G.mark(function _callee16(n, i) {
    return G.wrap(function _callee16$(a) {
      for (;;) switch (a.prev = a.next) {
        case 0:
          if (!n.recognizer || !n.recognizer.setTheme) {
            a.next = 7;
            break;
          }
          return a.next = 3, n.recognizerContext.initPromise;
        case 3:
          if (!a.sent) {
            a.next = 6;
            break;
          }
          return a.abrupt("return", n.recognizer.setTheme(n.recognizerContext, i, n.theme));
        case 6:
          return a.abrupt("return", Promise.reject(new Error("Cannot set theme")));
        case 7:
          return a.abrupt("return", null);
        case 8:
        case "end":
          return a.stop();
      }
    }, _callee16);
  }))).apply(this, arguments);
}
var _e = function () {
  function Editor(n, i, a, c, l) {
    be(this, Editor);
    var u = document.createElement("style");
    u.appendChild(document.createTextNode("")), n.appendChild(u);
    var d = u.sheet;
    u.textContent = "/*\n * Container style\n */\n.ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  -ms-overflow-style: none;\n  touch-action: auto;\n  -ms-touch-action: auto;\n}\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n}\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n  background-color: #eee;\n  opacity: 0.9;\n}\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, height .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, height .2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n.ps__thumb-y {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, width .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, width .2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x,\n.ps__rail-x.ps--clicking .ps__thumb-x {\n  background-color: #999;\n  height: 11px;\n}\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n  background-color: #999;\n  width: 11px;\n}\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n.ms-editor {\n    position: relative;\n    z-index: 20;\n    color: #1A9FFF;\n    font-family: sans-serif;\n}\n.ms-editor canvas,\n.ms-editor svg {\n    z-index: 15;\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n}\n.ms-editor canvas.ms-rendering-canvas {\n    z-index: 10;\n    pointer-events: none;\n    background-image: linear-gradient(to right, #F5F6F7 1px, transparent 1px),\n    linear-gradient(to bottom, #F5F6F7 1px, transparent 1px);\n    background-size: 18px 18px;\n}\n.ms-editor svg {\n    z-index: 10;\n    pointer-events: none;\n}\n.ms-editor svg[data-layer=\"BACKGROUND\"] {\n    z-index: 9;\n}\n.ms-editor .loader {\n    z-index: 30;\n    position: absolute;\n    width: 120px;\n    height: 120px;\n    top: calc(50% - 60px);\n    left: calc(50% - 60px);\n    border: 16px solid #F5F6F7;\n    border-radius: 50%;\n    border-top-color: #1A9FFF;\n    -webkit-animation: spin 2s linear infinite;\n    animation: spin 2s linear infinite;\n}\n.ms-editor .error-msg {\n    z-index: 25;\n    position: absolute;\n    width: 200px;\n    height: 200px;\n    top: calc(50% - 100px);\n    left: calc(50% - 100px);\n    font-size: 16px;\n    text-align: center;\n    word-wrap: break-word;\n}\n.ms-editor .error-msg::before {\n    content: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCA3Ni41IDYxMiA0NTkiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaW5ZTWluIG1lZXQiPgogICAgPHBhdGggZmlsbD0iIzFBOUZGRiIgZD0iTTQ5NC43LDIyOS41Yy0xNy44NTEtODYuNy05NC4zNTEtMTUzLTE4OC43LTE1M2MtMzguMjUsMC03My45NSwxMC4yLTEwMiwzMC42bDM4LjI1LDM4LjI1IGMxNy44NS0xMi43NSw0MC44LTE3Ljg1LDYzLjc1LTE3Ljg1Yzc2LjUsMCwxNDAuMjUsNjMuNzUsMTQwLjI1LDE0MC4yNXYxMi43NWgzOC4yNWM0My4zNSwwLDc2LjUsMzMuMTUsNzYuNSw3Ni41IGMwLDI4LjA1LTE1LjMsNTMuNTUtNDAuOCw2Ni4zbDM4LjI1LDM4LjI1QzU5MS42LDQzOC42LDYxMiw0MDAuMzUsNjEyLDM1N0M2MTIsMjkwLjcsNTU4LjQ1LDIzNC42LDQ5NC43LDIyOS41eiBNNzYuNSwxMDkuNjUgbDcxLjQsNjguODVDNjYuMywxODMuNiwwLDI0OS45LDAsMzMxLjVjMCw4NC4xNSw2OC44NSwxNTMsMTUzLDE1M2gyOTguMzVsNTEsNTFsMzMuMTUtMzMuMTVMMTA5LjY1LDc2LjVMNzYuNSwxMDkuNjV6IE0xOTYuMzUsMjI5LjVsMjA0LDIwNEgxNTNjLTU2LjEsMC0xMDItNDUuOS0xMDItMTAyYzAtNTYuMSw0NS45LTEwMiwxMDItMTAySDE5Ni4zNXoiIC8+Cjwvc3ZnPgo=);\n}\n.smartguide {\n    position: absolute;\n    z-index: 40;\n    font-size: 16px;\n}\n.smartguide-in {\n    visibility: visible !important;\n    transition: opacity 0.5s;\n    opacity: 1;\n}\n.smartguide-out {\n    transition: opacity 1s, visibility 1s;\n    visibility: hidden !important;\n    opacity: 0;\n}\n.prompter-text-container {\n    background-color: rgba(255, 255, 255, 0.9);\n    height: 48px;\n    line-height: 48px;\n    overflow: hidden;\n    white-space: nowrap;\n    display: block;\n    text-align: left;\n    border-bottom: 1px solid #959DA6;\n    position: absolute;\n    z-index: 30;\n    color: #bfbfbf;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n}\n.prompter-text-container > div > span {\n    cursor: pointer;\n    display: inline-block;\n}\n.prompter-text {\n    margin-left: 12px;\n}\n.added-word {\n    animation: 0.1s linear word-added,\n    3s ease-in-out color-input;\n}\n.modified-word {\n    animation: 0.1s linear word-modified,\n    3s ease-in-out color-input;\n}\n@keyframes color-input {\n    0% {\n        color: black;\n    }\n    100% {\n        color: #bfbfbf;\n    }\n}\n@keyframes word-added {\n    0% {\n        transform: translate(5px, 0);\n    }\n    100% {\n        transform: none;\n    }\n}\n@keyframes word-modified {\n    0% {\n        transform: translate(0, 5px);\n    }\n    100% {\n        transform: none;\n    }\n}\n.candidates {\n    color: black;\n    flex-direction: column;\n    text-align: center;\n    line-height: 30px;\n    border-radius: 3px;\n    position: absolute;\n    box-shadow: 2px 2px 12px #BDBDBD, -2px 2px 12px #BDBDBD;\n    background-color: #F5F5F5;\n    z-index: 100;\n    -webkit-tap-highlight-color: transparent;\n}\n.candidates > span {\n    cursor: pointer;\n    padding: 2px 20px;\n}\n.candidates > span:hover {\n    background-color: #EEEEEE;\n}\n.candidates > span:active {\n    background-color: #E0E0E0;\n}\n.selected-word {\n    font-weight: bold;\n    background-color: #E0E0E0;\n}\n.tag-icon {\n    padding: 0 18px;\n    border: 1px solid #959DA6;\n    font-weight: bold;\n    font-size: large;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    position: absolute;\n    z-index: 31;\n    height: 48px;\n    line-height: 48px;\n    background-color: rgba(255, 255, 255, 0.9);\n    color: #959DA6;\n}\n.ellipsis {\n    cursor: pointer;\n    border-bottom: 1px solid #959DA6;\n    position: absolute;\n    z-index: 31;\n    height: 48px;\n    line-height: 38px;\n    padding: 0 8px;\n    font-weight: bold;\n    font-size: x-large;\n    background-color: rgba(255, 255, 255, 0.9);\n    color: #959DA6;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n}\n.ellipsis:active {\n    background-color: #e0e0e0;\n}\n.more-menu {\n    flex-direction: column;\n    margin-right: 12px;\n    line-height: 30px;\n    border-radius: 3px;\n    position: absolute;\n    z-index: 100;\n    box-shadow: 2px 2px 12px #BDBDBD;\n    background-color: #F5F5F5;\n}\n.options-label-button {\n    color: black;\n    font-size: 16px;\n    cursor: pointer;\n    box-sizing: border-box;\n    background: transparent;\n    border: none;\n    padding: 0 24px;\n    margin: 0;\n    height: 40px;\n    outline: none;\n    -webkit-tap-highlight-color: transparent;\n}\n.options-label-button:hover {\n    background-color: #EEEEEE;\n}\n.options-label-button:active {\n    background-color: #E0E0E0;\n}\n.ps__rail-x {\n    top: 32px !important;\n}\n/** Stroke **/\n.removed-stroke {\n    opacity: 0;\n    transition: opacity 0.1s ease-in-out;\n}\n.added-stroke {\n    animation: 0.2s opacity-appear;\n}\n@keyframes opacity-appear {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity : 1;\n    }\n}\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n@keyframes rotate-plan {\n    0% {\n        transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n    }\n    25% {\n        transform: perspective(120px) rotateX(0deg) rotateY(-180deg);\n    }\n    50% {\n        transform: perspective(120px) rotateX(-180deg) rotateY(-180deg);\n    }\n    75% {\n        transform: perspective(120px) rotateX(-180deg) rotateY(0deg);\n    }\n    100% {\n        transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n    }\n}\n@-webkit-keyframes rotate-plan {\n    0% {\n        -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)\n    }\n    25% {\n        -webkit-transform: perspective(120px) rotateX(180deg) rotateY(0deg)\n    }\n    50% {\n        -webkit-transform: perspective(120px) rotateX(180deg) rotateY(180deg)\n    }\n    75% {\n        -webkit-transform: perspective(120px) rotateX(0deg) rotateY(180deg)\n    }\n    100% {\n        -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)\n    }\n}\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n", this.sheet = d, this.domElement = n, this.domElement.classList.add("ms-editor"), this.loader = document.createElement("div"), this.loader.classList.add("loader"), this.loader = this.domElement.appendChild(this.loader), this.error = document.createElement("div"), this.error.classList.add("error-msg"), this.error = this.domElement.appendChild(this.error), this.exportTimer = void 0, this.resizeTimer = void 0, this.notifyTimer = void 0, this.innerBehaviors = function overrideDefaultBehaviors(n) {
      if (n) {
        var i = {
          grabber: n.grabber || je.grabber,
          rendererList: n.rendererList || je.rendererList,
          strokerList: n.strokerList || je.strokerList,
          recognizerList: n.recognizerList || je.recognizerList,
          events: n.events || je.events,
          getBehaviorFromConfiguration: n.getBehaviorFromConfiguration || je.getBehaviorFromConfiguration
        };
        return s.debug("Override default behaviors", i), i;
      }
      return je;
    }(l), this.configuration = i, this.smartGuide = createSmartGuide(this), this.localTheme = "", this.theme = c, this.penStyle = a, this.penStyleClasses = "", this.domElement.editor = this;
  }
  var i, a;
  return xe(Editor, [{
    key: "pointerDown",
    value: function pointerDown(n) {
      var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "pen",
        a = arguments.length > 2 ? arguments[2] : void 0;
      s.trace("Pointer down", n), window.clearTimeout(this.notifyTimer), window.clearTimeout(this.exportTimer), this.model = initPendingStroke(this.model, n, Object.assign({
        pointerType: i,
        pointerId: a
      }, this.theme.ink, this.localPenStyle)), this.renderer.drawCurrentStroke(this.rendererContext, this.model, this.stroker);
    }
  }, {
    key: "pointerMove",
    value: function pointerMove(n) {
      s.trace("Pointer move", n), this.model = appendToPendingStroke(this.model, n), this.renderer.drawCurrentStroke(this.rendererContext, this.model, this.stroker);
    }
  }, {
    key: "pointerUp",
    value: function pointerUp(n) {
      s.trace("Pointer up", n), this.model = endPendingStroke(this.model, n, this.penStyle), this.renderer.drawModel(this.rendererContext, this.model, this.stroker), this.recognizer.addStrokes ? function addStrokes(n, i) {
        return _addStrokes.apply(this, arguments);
      }(this, this.model) : handleSuccess(this, this.model);
    }
  }, {
    key: "removeStroke",
    value: function removeStroke(n) {
      this.model.strokeGroups.forEach(function (i) {
        var a = i.strokes.map(function (n) {
          return JSON.stringify(n);
        }).indexOf(JSON.stringify(n));
        -1 !== a && i.strokes.splice(a, 1);
      });
      var i = this.model.rawStrokes.map(function (n) {
        return JSON.stringify(n);
      }).indexOf(JSON.stringify(n));
      -1 !== i && this.model.rawStrokes.splice(i, 1), this.renderer.drawModel(this.rendererContext, this.model, this.stroker), handleSuccess(this, this.model), "DEMAND" !== this.configuration.triggers.exportContent && launchExport(this, this.model);
    }
  }, {
    key: "reDraw",
    value: function reDraw(n, i) {
      var a = this;
      n.forEach(function (n) {
        addStroke(a.model, n);
      }), i.forEach(function (n) {
        n.strokes.forEach(function (i) {
          addStrokeToGroup(a.model, i, n.penStyle);
        });
      }), this.renderer.drawModel(this.rendererContext, this.model, this.stroker), handleSuccess(this, this.model);
    }
  }, {
    key: "waitForIdle",
    value: function waitForIdle() {
      return emitEvents(this, void 0, n.EventType.IDLE), function launchWaitForIdle(n, i) {
        return _launchWaitForIdle.apply(this, arguments);
      }(this, this.model);
    }
  }, {
    key: "undo",
    value: (a = Y(G.mark(function _callee() {
      var i,
        a,
        c,
        l = this;
      return G.wrap(function _callee$(u) {
        for (;;) switch (u.prev = u.next) {
          case 0:
            return s.debug("Undo current model", this.model), emitEvents(this, void 0, n.EventType.UNDO), u.next = 4, this.undoRedoManager.undo(this.undoRedoContext, this.model).catch(function (n) {
              return handleError(l, n);
            });
          case 4:
            return i = u.sent, a = i.res, c = i.types, manageRecognizedModel.apply(void 0, [this, a].concat(L(c))), u.abrupt("return", a);
          case 9:
          case "end":
            return u.stop();
        }
      }, _callee, this);
    })), function undo() {
      return a.apply(this, arguments);
    })
  }, {
    key: "redo",
    value: (i = Y(G.mark(function _callee2() {
      var i,
        a,
        c,
        l = this;
      return G.wrap(function _callee2$(u) {
        for (;;) switch (u.prev = u.next) {
          case 0:
            return s.debug("Redo current model", this.model), emitEvents(this, void 0, n.EventType.REDO), u.next = 4, this.undoRedoManager.redo(this.undoRedoContext, this.model).catch(function (n) {
              return handleError(l, n);
            });
          case 4:
            return i = u.sent, a = i.res, c = i.types, manageRecognizedModel.apply(void 0, [this, a].concat(L(c))), u.abrupt("return", a);
          case 9:
          case "end":
            return u.stop();
        }
      }, _callee2, this);
    })), function redo() {
      return i.apply(this, arguments);
    })
  }, {
    key: "clear",
    value: function () {
      var i = Y(G.mark(function _callee3() {
        var i,
          a,
          c,
          l = this;
        return G.wrap(function _callee3$(u) {
          for (;;) switch (u.prev = u.next) {
            case 0:
              if (!this.canClear) {
                u.next = 10;
                break;
              }
              return s.debug("Clear current model", this.model), emitEvents(this, void 0, n.EventType.CLEAR), u.next = 5, this.recognizer.clear(this.recognizerContext, this.model).catch(function (n) {
                return handleError(l, n);
              });
            case 5:
              return i = u.sent, a = i.res, c = i.events, handleSuccess.apply(void 0, [this, a].concat(L(c))), u.abrupt("return", a);
            case 10:
              return u.abrupt("return", Promise.reject(new Error("Cannot launch clear")));
            case 11:
            case "end":
              return u.stop();
          }
        }, _callee3, this);
      }));
      return function clear() {
        return i.apply(this, arguments);
      };
    }()
  }, {
    key: "convert",
    value: function convert() {
      var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "DIGITAL_EDIT";
      return this.canConvert ? (emitEvents(this, void 0, n.EventType.CONVERT), launchConvert(this, this.model, i)) : Promise.reject(new Error("Cannot launch convert"));
    }
  }, {
    key: "setGuides",
    value: function setGuides() {
      var n = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
      return this.configuration.recognitionParams.iink.text.guides.enable = n, launchConfig(this, this.model);
    }
  }, {
    key: "export_",
    value: function export_(i) {
      return this.canExport ? (emitEvents(this, void 0, n.EventType.EXPORT), launchExport(this, this.model, i, n.Trigger.DEMAND)) : Promise.reject(new Error("Cannot launch export"));
    }
  }, {
    key: "import_",
    value: function import_(i, a) {
      return emitEvents(this, void 0, n.EventType.IMPORT), function launchImport(n, i, a) {
        return _launchImport.apply(this, arguments);
      }(this, this.model, i instanceof Blob ? i : new Blob([i], {
        type: a
      }));
    }
  }, {
    key: "getSupportedImportMimeTypes",
    value: function getSupportedImportMimeTypes() {
      return function launchGetSupportedImportMimeTypes(n, i) {
        return _launchGetSupportedImportMimeTypes.apply(this, arguments);
      }(this, this.model);
    }
  }, {
    key: "pointerEvents",
    value: function pointerEvents(n) {
      return function launchPointerEvents(n, i, a) {
        return _launchPointerEvents.apply(this, arguments);
      }(this, this.model, n);
    }
  }, {
    key: "resize",
    value: function resize() {
      return s.debug("Resizing editor"), this.renderer.resize(this.rendererContext, this.model, this.stroker, this.configuration.renderingParams.minHeight, this.configuration.renderingParams.minWidth), function launchResize(n, i) {
        return _launchResize.apply(this, arguments);
      }(this, this.model);
    }
  }, {
    key: "unload",
    value: function unload() {
      this.grabber && this.grabber.detach(this.domElement, this.grabberContext), this.innerRenderer && this.innerRenderer.detach(this.domElement, this.rendererContext);
    }
  }, {
    key: "close",
    value: function close() {
      return this.configuration.recognitionParams.protocol === n.Protocol.WEBSOCKET ? function launchClose(n, i) {
        return _launchClose.apply(this, arguments);
      }(this, this.model) : null;
    }
  }, {
    key: "forceChange",
    value: function forceChange() {
      emitEvents(this, void 0, n.EventType.CHANGED);
    }
  }, {
    key: "configuration",
    set: function set(i) {
      var a = this;
      this.loader.style.display = "initial", this.error.style.display = "none";
      var c = {
        update: function update(i) {
          var s = !Object.keys(n.Languages).includes(i);
          a.theme[".text"]["font-family"] = s ? n.Languages.default : n.Languages[i], a.behavior = a.behaviors.getBehaviorFromConfiguration(a.behaviors, a.innerConfiguration);
        },
        prop: "lang"
      };
      this.innerConfiguration = function overrideDefaultConfiguration(n, i) {
        var a,
          c = n;
        c && c.recognitionParams.server && c.recognitionParams.server.useWindowLocation ? (c.recognitionParams.server.scheme = window.location.protocol.slice(0, -1), c.recognitionParams.server.host = window.location.host, a = f({}, g, void 0 === c ? {} : c)) : a = f({}, g, void 0 === n ? {} : n), s.debug("Override default configuration", a);
        var l = {
          get: function get(n, i) {
            return i !== m && "object" === h(n[i]) && null !== n[i] ? new Proxy(n[i], l) : n[i];
          },
          set: function set(n, a, s) {
            return a === i.prop && i.update(s), n[a] = s, !0;
          }
        };
        return new Proxy(a, l);
      }(i, c), this.behavior = this.behaviors.getBehaviorFromConfiguration(this.behaviors, this.innerConfiguration);
    },
    get: function get() {
      return this.innerConfiguration;
    }
  }, {
    key: "penStyle",
    set: function set(n) {
      this.innerPenStyle = function overrideDefaultPenStyle(n) {
        var i = f({}, void 0, void 0 === n ? {} : n);
        return s.debug("Override default pen style", i), i;
      }(n), this.localPenStyle = this.innerPenStyle, setPenStyle(this, this.model);
    },
    get: function get() {
      return this.innerPenStyle;
    }
  }, {
    key: "penStyleClasses",
    set: function set(n) {
      this.innerPenStyleClasses = n, this.localPenStyle = this.theme[".".concat(this.innerPenStyleClasses)], setPenStyleClasses(this, this.model);
    },
    get: function get() {
      return this.innerPenStyleClasses;
    }
  }, {
    key: "theme",
    set: function set(n) {
      this.innerTheme = function overrideDefaultTheme(n) {
        var i = f({}, w, void 0 === n ? {} : n);
        return s.debug("Override default theme", i), i;
      }(n), setTheme(this, this.model);
    },
    get: function get() {
      return this.innerTheme;
    }
  }, {
    key: "behaviors",
    get: function get() {
      return this.innerBehaviors;
    }
  }, {
    key: "behavior",
    set: function set(n) {
      n && (this.grabber && this.grabber.detach(this.domElement, this.grabberContext), this.innerBehavior = n, this.renderer = this.innerBehavior.renderer, this.recognizer = this.innerBehavior.recognizer, this.grabberContext = this.grabber.attach(this.domElement, this));
    },
    get: function get() {
      return this.innerBehavior;
    }
  }, {
    key: "recognizer",
    set: function set(n) {
      var i = this;
      this.undoRedoContext = function createUndoRedoContext(n) {
        return {
          stack: [],
          currentPosition: -1,
          maxSize: n.undoRedoMaxStackSize,
          canUndo: !1,
          canRedo: !1
        };
      }(this.configuration), this.undoRedoManager = we;
      var a = function initialize(a, c) {
        i.innerRecognizer = n, i.innerRecognizer && (i.recognizerContext = createEmptyRecognizerContext(i), i.innerRecognizer.undo && i.innerRecognizer.redo && i.innerRecognizer.clear && (i.undoRedoContext = i.recognizerContext, i.undoRedoManager = i.innerRecognizer), i.innerRecognizer.init(i.recognizerContext, a).then(function (n) {
          s.info("Recognizer initialized !"), c && (setTheme(i, i.model), setPenStyle(i, i.model), setPenStyleClasses(i, i.model)), i.loader.style.display = "none";
        }).catch(function (n) {
          return handleError(i, n);
        }));
      };
      n && (this.innerRecognizer ? this.innerRecognizer.close(this.recognizerContext, this.model).then(function (n) {
        s.info("Recognizer closed"), handleSuccess(i, n), a(clearModel(n), !0);
      }).catch(function (n) {
        return handleError(i, n);
      }) : (this.model = createModel(this.configuration), a(this.model, !1)));
    },
    get: function get() {
      return this.innerRecognizer;
    }
  }, {
    key: "renderer",
    set: function set(n) {
      n && (this.innerRenderer && this.innerRenderer.detach(this.domElement, this.rendererContext), this.innerRenderer = n, this.innerRenderer && (this.rendererContext = this.innerRenderer.attach(this.domElement, this.configuration.renderingParams.minHeight, this.configuration.renderingParams.minWidth)));
    },
    get: function get() {
      return this.innerRenderer;
    }
  }, {
    key: "grabber",
    get: function get() {
      return this.behavior ? this.behavior.grabber : void 0;
    }
  }, {
    key: "stroker",
    get: function get() {
      return this.behavior ? this.behavior.stroker : void 0;
    }
  }, {
    key: "emit",
    get: function get() {
      return this.behavior ? this.behavior.events : void 0;
    }
  }, {
    key: "png",
    get: function get() {
      return function getImage(n, i) {
        var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10;
        if (n.rawStrokes.length > 0) {
          var s = getBorderCoordinates(n),
            c = createCanvas$1(s, a),
            l = createCanvas$1(s, a),
            u = {
              renderingCanvas: l,
              renderingCanvasContext: l.getContext("2d"),
              capturingCanvas: c,
              capturingCanvasContext: c.getContext("2d")
            };
          return u.renderingCanvasContext.translate(-s.minX + a, -s.minY + a), drawModel(u, n, i), u.renderingCanvas.toDataURL("image/png");
        }
        return null;
      }(this.model, this.stroker);
    }
  }, {
    key: "initialized",
    get: function get() {
      return !!this.recognizerContext && this.recognizerContext.initialized;
    }
  }, {
    key: "idle",
    get: function get() {
      return this.recognizerContext.idle;
    }
  }, {
    key: "canUndo",
    get: function get() {
      return this.undoRedoContext.canUndo;
    }
  }, {
    key: "canRedo",
    get: function get() {
      return this.undoRedoContext.canRedo;
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.recognizerContext.isEmpty;
    }
  }, {
    key: "canClear",
    get: function get() {
      return !this.isEmpty;
    }
  }, {
    key: "canConvert",
    get: function get() {
      return !!(this.canUndo && this.canClear && this.recognizer && this.recognizer.convert);
    }
  }, {
    key: "possibleUndoCount",
    get: function get() {
      return this.recognizerContext.possibleUndoCount;
    }
  }, {
    key: "undoStackIndex",
    get: function get() {
      return this.recognizerContext.undoStackIndex;
    }
  }, {
    key: "canExport",
    get: function get() {
      return this.canUndo && this.canClear && this.recognizer && this.recognizer.getInfo().availableTriggers.exportContent.includes(n.Trigger.DEMAND);
    }
  }, {
    key: "exports",
    get: function get() {
      return this.model ? this.model.exports : void 0;
    }
  }, {
    key: "supportedImportMimeTypes",
    get: function get() {
      return this.recognizerContext.supportedImportMimeTypes;
    }
  }, {
    key: "eastereggs",
    get: function get() {
      return Ee;
    }
  }]), Editor;
}();
function emitEvents(i, a) {
  for (var s = i, c = arguments.length, l = new Array(c > 2 ? c - 2 : 0), u = 2; u < c; u++) l[u - 2] = arguments[u];
  l.forEach(function (c) {
    switch (c) {
      case n.EventType.RENDERED:
        break;
      case n.EventType.UNDO:
      case n.EventType.REDO:
      case n.EventType.CLEAR:
      case n.EventType.CONVERT:
      case n.EventType.EXPORT:
        i.emit.call(i.domElement, c);
        break;
      case n.EventType.LOADED:
      case n.EventType.CHANGED:
        i.emit.call(i.domElement, c, {
          initialized: i.initialized,
          canUndo: i.canUndo,
          canRedo: i.canRedo,
          canClear: i.canClear,
          isEmpty: i.isEmpty,
          possibleUndoCount: i.possibleUndoCount,
          undoStackIndex: i.undoStackIndex,
          canConvert: i.canConvert,
          canExport: i.canExport
        });
        break;
      case n.EventType.EXPORTED:
        window.clearTimeout(s.notifyTimer), s.notifyTimer = window.setTimeout(function () {
          i.emit.call(i.domElement, c, {
            exports: i.exports
          });
        }, s.configuration.processDelay);
        break;
      case n.EventType.SUPPORTED_IMPORT_MIMETYPES:
        i.emit.call(i.domElement, c, {
          mimeTypes: i.supportedImportMimeTypes
        });
        break;
      case n.EventType.ERROR:
        i.emit.call(i.domElement, c, a);
        break;
      case n.EventType.IDLE:
        i.emit.call(i.domElement, c, {
          idle: i.idle
        });
        break;
      default:
        d.debug("No valid trigger configured for ".concat(c));
    }
  });
}
function manageRecognizedModel(i, a) {
  for (var s = i, c = a, l = arguments.length, u = new Array(l > 2 ? l - 2 : 0), p = 2; p < l; p++) u[p - 2] = arguments[p];
  d.debug("model changed callback on ".concat(u, " event(s)"), a), c.creationTime === i.model.creationTime && (c.rawStrokes.length === i.model.rawStrokes.length && c.lastPositions.lastSentPosition >= i.model.lastPositions.lastReceivedPosition ? (s.model = mergeModels(s.model, c), (needRedraw(s.model) || u.includes(n.EventType.RENDERED)) && i.renderer.drawModel(i.rendererContext, s.model, i.stroker)) : (s.model = c, i.renderer.drawModel(i.rendererContext, s.model, i.stroker)), emitEvents.apply(void 0, [i, void 0].concat(u))), "TEXT" === i.configuration.recognitionParams.type && "REST" !== i.configuration.recognitionParams.protocol && i.configuration.recognitionParams.iink.text.mimeTypes.includes(n.Exports.JIIX) && i.configuration.recognitionParams.iink.text.smartGuide && (s.smartGuide = launchSmartGuide(i.smartGuide, c.exports)), extractPendingStrokes(a).length > 0 && !i.recognizer.addStrokes && i.configuration.triggers.exportContent !== n.Trigger.DEMAND && launchExport(i, a);
}
function handleError(i, a) {
  var s = i;
  if ("close" !== a.type && d.error("Error while firing the recognition", a.stack || a), "Invalid application key." === a.message || "Invalid HMAC" === a.message || a.error && a.error.result && a.error.result.error && ("InvalidApplicationKeyException" === a.error.result.error || "InvalidHMACSignatureException" === a.error.result.error) || a.code && "access.not.granted" === a.code ? s.error.innerText = n.Error.WRONG_CREDENTIALS : "Session is too old. Max Session Duration Reached." === a.message || a.code && "session.too.old" === a.code ? s.error.innerText = n.Error.TOO_OLD : 1006 !== a.code && 1e3 !== a.code || "none" !== s.error.style.display || (s.error.innerText = n.Error.NOT_REACHABLE), s.error.innerText !== n.Error.TOO_OLD && "CLOSE_RECOGNIZER" !== a.reason || !canReconnect(i.recognizerContext)) {
    s.loader.style.display = "none", s.error.style.display = "initial";
    for (var c = arguments.length, l = new Array(c > 2 ? c - 2 : 0), u = 2; u < c; u++) l[u - 2] = arguments[u];
    emitEvents.apply(void 0, [i, a, n.EventType.ERROR].concat(l));
  } else d.info("Reconnection is available", a.stack || a), s.error.style.display = "none";
}
function handleSuccess(n, i) {
  for (var a = arguments.length, s = new Array(a > 2 ? a - 2 : 0), c = 2; c < a; c++) s[c - 2] = arguments[c];
  var l = n;
  n.undoRedoManager.updateModel ? n.undoRedoManager.updateModel(n.undoRedoContext, i).then(function (n) {
    var i = n.res,
      a = n.types;
    manageRecognizedModel.apply(void 0, [l, i].concat(L([].concat(s, L(a)).filter(function (n, i, a) {
      return i === a.indexOf(n);
    }))));
  }) : ("initial" === l.error.style.display && (l.error.style.display = "none"), manageRecognizedModel.apply(void 0, [l, i].concat(s)));
}
function clear(i, a) {
  var s = clearModel(a);
  d.debug("Updated model", s);
  var c = updateRecognitionPositions(i, s.lastPositions);
  return delete c.instanceId, d.debug("Updated recognizer context", c), Promise.resolve({
    err: void 0,
    res: s,
    events: [n.EventType.CHANGED, n.EventType.EXPORTED, n.EventType.RENDERED]
  });
}
var Se = {
  types: [n.RecognitionType.TEXT, n.RecognitionType.DIAGRAM, n.RecognitionType.MATH, n.RecognitionType.RAWCONTENT],
  protocol: n.Protocol.REST,
  availableTriggers: {
    exportContent: [n.Trigger.QUIET_PERIOD, n.Trigger.DEMAND]
  }
};
function postMessage(n, i, a, s) {
  var c = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "",
    l = arguments.length > 5 ? arguments[5] : void 0,
    u = i.editor.configuration;
  return post(i, "".concat(u.recognitionParams.server.scheme, "://").concat(u.recognitionParams.server.host).concat(n), s(i, a, c), "V4", l).then(function (n) {
    d.debug("iinkRestRecognizer success", n);
    var a = i.lastPositions;
    a.lastReceivedPosition = a.lastSentPosition;
    var s = updateRecognitionPositions(i, a);
    return n.instanceId && (s.instanceId = n.instanceId), n;
  });
}
function buildData(n, i, a) {
  var s,
    c = n.editor.configuration;
  "TEXT" === c.recognitionParams.type ? s = function buildTextConf(n) {
    return {
      text: n.recognitionParams.iink.text,
      lang: n.recognitionParams.iink.lang,
      export: n.recognitionParams.iink.export
    };
  }(c) : "MATH" === c.recognitionParams.type ? s = function buildMathConf(n) {
    return {
      math: n.recognitionParams.iink.math,
      lang: n.recognitionParams.iink.lang,
      export: n.recognitionParams.iink.export
    };
  }(c) : "DIAGRAM" === c.recognitionParams.type ? s = function buildDiagramConf(n) {
    return {
      diagram: n.recognitionParams.iink.diagram,
      lang: n.recognitionParams.iink.lang,
      export: n.recognitionParams.iink.export
    };
  }(c) : "Raw Content" === c.recognitionParams.type && (s = function buildRawContentConf(n) {
    return {
      "raw-content": {
        recognition: n.recognitionParams.iink["raw-content"].recognition
      },
      lang: n.recognitionParams.iink.lang,
      export: n.recognitionParams.iink.export
    };
  }(c));
  var l = [];
  i.strokeGroups.forEach(function (n) {
    var i = {
      penStyle: "{}" === JSON.stringify(n.penStyle) ? null : toCSS(n.penStyle),
      strokes: n.strokes.map(function (n) {
        return function toJSON(n) {
          return {
            x: n.x,
            y: n.y,
            t: n.t
          };
        }(n);
      })
    };
    l.push(i);
  });
  var u = {
    configuration: s,
    xDPI: 96,
    yDPI: 96,
    contentType: "Raw Content" === c.recognitionParams.type ? "Raw Content" : c.recognitionParams.type.charAt(0).toUpperCase() + c.recognitionParams.type.slice(1).toLowerCase(),
    theme: toCSS$1(n.editor.theme),
    strokeGroups: l
  };
  return n.editor.domElement && (u.height = n.editor.domElement.clientHeight, u.width = n.editor.domElement.clientWidth), a && (u.conversionState = "DIGITAL_EDIT"), updateModelSentPosition(i), u;
}
function extractExports(n, i, a) {
  var s = {};
  return s[i] = a, s;
}
function resultCallback(i, a, s, c, l) {
  d.debug("iinkRestRecognizer result callback", a);
  var u = updateModelReceivedPosition(a);
  u.rawResults.exports = c, u.exports ? Object.assign(u.exports, extractExports(0, l, c)) : u.exports = extractExports(0, l, c), d.debug("iinkRestRecognizer model updated", u), i.editor.undoRedoManager && handleSuccess(i.editor, u, n.EventType.EXPORTED, n.EventType.IDLE);
}
function callPostMessage(n, i, a) {
  var s = n.editor.configuration;
  return postMessage("/api/v4.0/iink/batch", n, i, buildData, s.restConversionState, a).then(function (s) {
    return resultCallback(n, i, 0, s, a), i;
  }).catch(function (i) {
    return handleError(n.editor, i), i;
  });
}
function export_(n, i, a) {
  var s = n.editor.configuration;
  return a ? Promise.all(a.map(function (a) {
    return callPostMessage(n, i, a);
  })) : "TEXT" === s.recognitionParams.type ? Promise.all(s.recognitionParams.iink.text.mimeTypes.map(function (a) {
    return callPostMessage(n, i, a);
  })) : "DIAGRAM" === s.recognitionParams.type ? Promise.all(s.recognitionParams.iink.diagram.mimeTypes.map(function (a) {
    return callPostMessage(n, i, a);
  })) : "MATH" === s.recognitionParams.type ? Promise.all(s.recognitionParams.iink.math.mimeTypes.map(function (a) {
    return callPostMessage(n, i, a);
  })) : "Raw Content" === s.recognitionParams.type ? Promise.all(s.recognitionParams.iink["raw-content"].mimeTypes.map(function (a) {
    return callPostMessage(n, i, a);
  })) : Promise.reject(new Error("Export failed"));
}
var ke = Object.freeze({
  __proto__: null,
  iinkRestConfiguration: Se,
  getInfo: function getInfo$4() {
    return Se;
  },
  postMessage: postMessage,
  export_: export_,
  convert: function convert(n, i) {
    var a = n.editor.configuration;
    postMessage("/api/v4.0/iink/batch", n, i, buildData, "DIGITAL_EDIT").then(function (n) {
      return resultCallback(i, a);
    }).catch(function (i) {
      return handleError(n.editor, i);
    });
  },
  resize: function resize$3(n, i) {
    i.strokeGroups.length && export_(n, i);
  },
  init: function init(i, a) {
    var s = resetModelPositions(a);
    d.debug("Updated model", s);
    var c = updateRecognitionPositions(i, s.lastPositions);
    return c.initPromise = Promise.resolve(s), c.initPromise.then(function (i) {
      return c.initialized = !0, d.debug("Updated recognizer context", c), handleSuccess(c.editor, i, n.EventType.LOADED), i;
    });
  },
  close: function close(n, i) {
    var a = n;
    return a.initialized = !1, delete a.instanceId, Promise.resolve(i);
  },
  clear: clear,
  reset: function reset(n, i) {
    var a = resetModelPositions(i);
    d.debug("Updated model", a);
    var s = updateRecognitionPositions(n, a.lastPositions);
    return delete s.instanceId, d.debug("Updated recognizer context", s), Promise.resolve({
      res: a
    });
  }
});
var Ce = function _arrayWithHoles(n) {
  if (Array.isArray(n)) return n;
};
var Pe = function _iterableToArrayLimit(n, i) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(n)) {
    var a = [],
      s = !0,
      c = !1,
      l = void 0;
    try {
      for (var u, d = n[Symbol.iterator](); !(s = (u = d.next()).done) && (a.push(u.value), !i || a.length !== i); s = !0);
    } catch (n) {
      c = !0, l = n;
    } finally {
      try {
        s || null == d.return || d.return();
      } finally {
        if (c) throw l;
      }
    }
    return a;
  }
};
var Ie = function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var Te = function _slicedToArray(n, i) {
  return Ce(n) || Pe(n, i) || M(n, i) || Ie();
};
function UUIDjs() {}
function getRandomInt(n, i) {
  return Math.floor(Math.random() * (i - n + 1)) + n;
}
UUIDjs.maxFromBits = function (n) {
  return Math.pow(2, n);
}, UUIDjs.limitUI04 = UUIDjs.maxFromBits(4), UUIDjs.limitUI06 = UUIDjs.maxFromBits(6), UUIDjs.limitUI08 = UUIDjs.maxFromBits(8), UUIDjs.limitUI12 = UUIDjs.maxFromBits(12), UUIDjs.limitUI14 = UUIDjs.maxFromBits(14), UUIDjs.limitUI16 = UUIDjs.maxFromBits(16), UUIDjs.limitUI32 = UUIDjs.maxFromBits(32), UUIDjs.limitUI40 = UUIDjs.maxFromBits(40), UUIDjs.limitUI48 = UUIDjs.maxFromBits(48), UUIDjs.randomUI04 = function () {
  return getRandomInt(0, UUIDjs.limitUI04 - 1);
}, UUIDjs.randomUI06 = function () {
  return getRandomInt(0, UUIDjs.limitUI06 - 1);
}, UUIDjs.randomUI08 = function () {
  return getRandomInt(0, UUIDjs.limitUI08 - 1);
}, UUIDjs.randomUI12 = function () {
  return getRandomInt(0, UUIDjs.limitUI12 - 1);
}, UUIDjs.randomUI14 = function () {
  return getRandomInt(0, UUIDjs.limitUI14 - 1);
}, UUIDjs.randomUI16 = function () {
  return getRandomInt(0, UUIDjs.limitUI16 - 1);
}, UUIDjs.randomUI32 = function () {
  return getRandomInt(0, UUIDjs.limitUI32 - 1);
}, UUIDjs.randomUI40 = function () {
  return (0 | Math.random() * (1 << 30)) + (0 | 1024 * Math.random()) * (1 << 30);
}, UUIDjs.randomUI48 = function () {
  return (0 | Math.random() * (1 << 30)) + (0 | Math.random() * (1 << 18)) * (1 << 30);
}, UUIDjs.paddedString = function (n, i, a) {
  a = a || "0";
  for (var s = i - (n = String(n)).length; s > 0; s >>>= 1, a += a) 1 & s && (n = a + n);
  return n;
}, UUIDjs.prototype.fromParts = function (n, i, a, s, c, l) {
  return this.version = a >> 12 & 15, this.hex = UUIDjs.paddedString(n.toString(16), 8) + "-" + UUIDjs.paddedString(i.toString(16), 4) + "-" + UUIDjs.paddedString(a.toString(16), 4) + "-" + UUIDjs.paddedString(s.toString(16), 2) + UUIDjs.paddedString(c.toString(16), 2) + "-" + UUIDjs.paddedString(l.toString(16), 12), this;
}, UUIDjs.prototype.toString = function () {
  return this.hex;
}, UUIDjs.prototype.toURN = function () {
  return "urn:uuid:" + this.hex;
}, UUIDjs.prototype.toBytes = function () {
  for (var n = this.hex.split("-"), i = [], a = 0, s = 0; s < n.length; s++) for (var c = 0; c < n[s].length; c += 2) i[a++] = parseInt(n[s].substr(c, 2), 16);
  return i;
}, UUIDjs.prototype.equals = function (n) {
  return n instanceof UUID && this.hex === n.hex;
}, UUIDjs.getTimeFieldValues = function (n) {
  var i = n - Date.UTC(1582, 9, 15),
    a = i / 4294967296 * 1e4 & 268435455;
  return {
    low: 1e4 * (268435455 & i) % 4294967296,
    mid: 65535 & a,
    hi: a >>> 16,
    timestamp: i
  };
}, UUIDjs._create4 = function () {
  return new UUIDjs().fromParts(UUIDjs.randomUI32(), UUIDjs.randomUI16(), 16384 | UUIDjs.randomUI12(), 128 | UUIDjs.randomUI06(), UUIDjs.randomUI08(), UUIDjs.randomUI48());
}, UUIDjs._create1 = function () {
  var n = new Date().getTime(),
    i = UUIDjs.randomUI14(),
    a = 1099511627776 * (1 | UUIDjs.randomUI08()) + UUIDjs.randomUI40(),
    s = UUIDjs.randomUI04(),
    c = 0;
  n != c ? (n < c && i++, c = n, s = UUIDjs.randomUI04()) : Math.random() < 1 / 4 && s < 9984 ? s += 1 + UUIDjs.randomUI04() : i++;
  var l = UUIDjs.getTimeFieldValues(c),
    u = l.low + s,
    d = 4095 & l.hi | 4096,
    p = (i &= 16383) >>> 8 | 128,
    h = 255 & i;
  return new UUIDjs().fromParts(u, l.mid, d, p, h, a);
}, UUIDjs.create = function (n) {
  return this["_create" + (n = n || 4)]();
}, UUIDjs.fromTime = function (n, i) {
  i = i || !1;
  var a = UUIDjs.getTimeFieldValues(n),
    s = a.low,
    c = 4095 & a.hi | 4096;
  return !1 === i ? new UUIDjs().fromParts(s, a.mid, c, 0, 0, 0) : new UUIDjs().fromParts(s, a.mid, c, 128 | UUIDjs.limitUI06, UUIDjs.limitUI08 - 1, UUIDjs.limitUI48 - 1);
}, UUIDjs.firstFromTime = function (n) {
  return UUIDjs.fromTime(n, !1);
}, UUIDjs.lastFromTime = function (n) {
  return UUIDjs.fromTime(n, !0);
}, UUIDjs.fromURN = function (n) {
  var i;
  return (i = /^(?:urn:uuid:|\{)?([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{2})([0-9a-f]{2})-([0-9a-f]{12})(?:\})?$/i.exec(n)) ? new UUIDjs().fromParts(parseInt(i[1], 16), parseInt(i[2], 16), parseInt(i[3], 16), parseInt(i[4], 16), parseInt(i[5], 16), parseInt(i[6], 16)) : null;
}, UUIDjs.fromBytes = function (n) {
  if (n.length < 5) return null;
  for (var i = "", a = 0, s = [4, 2, 2, 2, 6], c = 0; c < s.length; c++) {
    for (var l = 0; l < s[c]; l++) {
      var u = n[a++].toString(16);
      1 == u.length && (u = "0" + u), i += u;
    }
    6 !== s[c] && (i += "-");
  }
  return UUIDjs.fromURN(i);
}, UUIDjs.fromBinary = function (n) {
  for (var i = [], a = 0; a < n.length; a++) if (i[a] = n.charCodeAt(a), i[a] > 255 || i[a] < 0) throw new Error("Unexpected byte in binary data.");
  return UUIDjs.fromBytes(i);
}, UUIDjs.new = function () {
  return this.create(4);
}, UUIDjs.newTS = function () {
  return this.create(1);
};
var Me = UUIDjs;
function openWebSocket(n) {
  var i;
  try {
    i = new WebSocket(n.url);
  } catch (n) {
    d.error("Unable to open websocket, Check the host and your connectivity");
  }
  return function addWebsocketAttributes(n, i) {
    var a = i.editor.configuration.recognitionParams.server.websocket,
      s = n;
    s.start = new Date(), s.autoReconnect = a.autoReconnect, s.maxRetryCount = a.maxRetryCount, s.pingEnabled = a.pingEnabled, s.pingDelay = a.pingDelay, s.maxPingLost = a.maxPingLostCount, s.pingLostCount = 0, s.recognizerContext = i;
  }(i, n), i.pingEnabled && function infinitePing(n) {
    var i = n;
    i.pingLostCount++, i.pingLostCount > i.maxPingLost ? n.close(1e3, "PING_LOST") : i.readyState <= 1 && setTimeout(function () {
      i.readyState <= 1 && (i.send(JSON.stringify({
        type: "ping"
      })), infinitePing(i));
    }, i.pingDelay);
  }(i), i.onopen = function (i) {
    d.trace("onOpen"), n.websocketCallback(i);
  }, i.onclose = function (a) {
    d.trace("onClose", new Date() - i.start), n.websocketCallback(a);
  }, i.onerror = function (i) {
    d.trace("onError"), n.websocketCallback(i);
  }, i.onmessage = function (a) {
    if (d.trace("onMessage"), i.pingLostCount = 0, "pong" !== JSON.parse(a.data).type) {
      var s = {
        type: a.type,
        data: JSON.parse(a.data)
      };
      n.websocketCallback(s);
    }
  }, i;
}
function send(n, i) {
  var a = n;
  a.idle = !1;
  var s = a.websocket;
  if (1 !== s.readyState) throw J;
  s.send(JSON.stringify(i)), d.debug("".concat(i.type, " message sent"), i);
}
function buildWebSocketCallback(n) {
  return function (i) {
    var a = n;
    d.trace("".concat(i.type, " websocket callback"), i);
    var s = n.recognitionContexts[n.recognitionContexts.length - 1];
    switch (d.debug("Current recognition context", s), i.type) {
      case "open":
        n.sessionId ? send(n, buildRestoreIInkSessionInput(n.editor.configuration, n.editor.domElement, n.sessionId)) : send(n, buildNewContentPackageInput(n.editor.configuration, n.editor.domElement));
        break;
      case "message":
        switch (d.debug("Receiving ".concat(i.data.type, " message"), i), i.data.type) {
          case "ack":
            i.data.hmacChallenge && send(n, function buildHmacMessage(n, i) {
              return {
                type: "hmac",
                hmac: computeHmac(i.data.hmacChallenge, n.recognitionParams.server.applicationKey, n.recognitionParams.server.hmacKey)
              };
            }(n.editor.configuration, i)), i.data.iinkSessionId && (a.sessionId = i.data.iinkSessionId);
            break;
          case "newPart":
            break;
          case "contentPackageDescription":
            a.currentReconnectionCount = 0, a.contentPartCount = i.data.contentPartCount, send(n, buildConfiguration(n.editor.configuration)), a.currentPartId ? send(n, buildOpenContentPart(n.editor.configuration, n.currentPartId)) : send(n, buildNewContentPart(n.editor.configuration));
            break;
          case "partChanged":
            i.data.partId && (a.currentPartId = i.data.partId), a.initialized = !0, s.partChange ? s.partChange.resolve([void 0, i.data]) : s.error(i);
            break;
          case "contentChanged":
            void 0 !== i.data.canUndo && (a.canUndo = i.data.canUndo), void 0 !== i.data.canRedo && (a.canRedo = i.data.canRedo), void 0 !== i.data.empty && (a.isEmpty = i.data.empty), void 0 !== i.data.possibleUndoCount && (a.possibleUndoCount = i.data.possibleUndoCount), void 0 !== i.data.undoStackIndex && (a.undoStackIndex = i.data.undoStackIndex), s.contentChange.resolve([void 0, i.data]);
            break;
          case "exported":
            s.response(void 0, i.data);
            break;
          case "svgPatch":
            s.patch(void 0, i.data);
            break;
          case "supportedImportMimeTypes":
            a.supportedImportMimeTypes = i.data.mimeTypes, s.response(void 0, i.data);
            break;
          case "fileChunkAck":
            s.response(void 0, i.data);
            break;
          case "idle":
            a.idle = !0, s.patch(void 0, i.data);
            break;
          case "error":
            if (d.debug("Error detected stopping all recognition", i), s) {
              var c = function func() {};
              s.patch ? c = s.patch : s.response && (c = s.response), c(i.data);
            } else s.initPromise.reject(Object.assign({}, i.data, {
              recoverable: !1
            }));
            break;
          default:
            d.warn("This is something unexpected in current recognizer. Not the type of message we should have here.", i);
        }
        break;
      case "error":
        if (d.debug("Error detected stopping all recognition", i), s) {
          var l = function _func() {};
          s.patch ? l = s.patch : s.response && (l = s.response), l(Object.assign({}, i, {
            recoverable: !1
          }));
        } else s.initPromise.reject(Object.assign({}, i, {
          recoverable: !1
        }));
        break;
      case "close":
        d.debug("Close detected stopping all recognition", i), a.initialized = !1, s ? s.error(i) : s.initPromise.reject(i);
        break;
      default:
        d.warn("This is something unexpected in current recognizer. Not the type of message we should have here.", i);
    }
  };
}
function init$1(n, i, a, s) {
  var c = i.recognitionContexts[0],
    l = updateRecognitionPositions(i, c.model.lastPositions);
  return l.url = function buildUrl(n, i) {
    var a = "https" === n.recognitionParams.server.scheme ? "wss" : "ws";
    return "".concat(a, "://").concat(n.recognitionParams.server.host).concat(i);
  }(i.editor.configuration, n), l.reconnect = s, l.initPromise = c.initPromise.promise, d.debug("Opening the websocket for context ", i), l.websocketCallback = a(l), l.websocket = openWebSocket(l), l.initPromise;
}
function retry(n, i, a, s) {
  return _retry.apply(this, arguments);
}
function _retry() {
  return (_retry = Y(G.mark(function _callee(n, i, a, s) {
    var c,
      l,
      u,
      p = arguments;
    return G.wrap(function _callee$(h) {
      for (;;) switch (h.prev = h.next) {
        case 0:
          for (c = p.length, l = new Array(c > 4 ? c - 4 : 0), u = 4; u < c; u++) l[u - 4] = p[u];
          if (!shouldAttemptImmediateReconnect(i) || !i.reconnect) {
            h.next = 11;
            break;
          }
          return d.info("Attempting a retry", i.currentReconnectionCount), h.next = 5, i.reconnect(i, a).catch(function (c) {
            d.error("Failed retry", c), retry.apply(void 0, [n, i, a, s].concat(l));
          });
        case 5:
          return setTheme$1(i, a, i.editor.theme), setPenStyle$1(i, a, i.editor.penStyle), setPenStyleClasses$1(i, a, i.editor.penStyleClasses), h.abrupt("return", n.apply(void 0, [i, a, s].concat(l)));
        case 11:
          Ae(a, "Unable to reconnect");
        case 12:
        case "end":
          return h.stop();
      }
    }, _callee);
  }))).apply(this, arguments);
}
function sendMessage(n, i) {
  for (var a = arguments.length, s = new Array(a > 2 ? a - 2 : 0), c = 2; c < a; c++) s[c - 2] = arguments[c];
  return n.initPromise.then(function () {
    d.trace("Init was done. Sending message");
    var a = i.apply(void 0, s);
    if (a) {
      send(n, a);
      var c = n.recognitionContexts[0].model.lastPositions;
      c && updateRecognitionPositions(n, c);
    } else d.warn("empty message");
  });
}
function close$2(n, i) {
  var a = destructurePromise(),
    s = n,
    c = {
      model: i,
      initPromise: a,
      error: function error(n, a) {
        return Ae(i, n, a, s);
      }
    };
  return n.initPromise.then(function () {
    return s.recognitionContexts[0] = c, s;
  }).then(function (n) {
    return function close$1(n, i, a) {
      var s = n.websocket;
      s && s.readyState < 2 && s.close(i, a);
    }(n, 1e3, "CLOSE_RECOGNIZER"), c.model;
  });
}
var Re = Object.freeze({
  __proto__: null,
  init: init$1,
  retry: retry,
  sendMessage: sendMessage,
  clear: function clear$1(n, i, a) {
    var s = clearModel(i),
      c = updateRecognitionPositions(n, s.lastPositions);
    if (c && c.websocket) {
      delete c.instanceId;
      try {
        send(c, {
          type: "reset"
        });
      } catch (n) {
        c.websocketCallback(destructurePromise(), c, i);
      }
    }
    a(void 0, s);
  },
  close: close$2
});
var Le = {
  types: [n.RecognitionType.MATH, n.RecognitionType.TEXT, n.RecognitionType.DIAGRAM, n.RecognitionType.NEBO],
  protocol: n.Protocol.WEBSOCKET,
  availableTriggers: {
    exportContent: [n.Trigger.POINTER_UP, n.Trigger.DEMAND],
    addStrokes: [n.Trigger.POINTER_UP]
  }
};
function buildNewContentPackageInput(n, i) {
  return {
    type: "newContentPackage",
    applicationKey: n.recognitionParams.server.applicationKey,
    xDpi: 96,
    yDpi: 96,
    viewSizeHeight: i.clientHeight < n.renderingParams.minHeight ? n.renderingParams.minHeight : i.clientHeight,
    viewSizeWidth: i.clientWidth < n.renderingParams.minWidth ? n.renderingParams.minWidth : i.clientWidth
  };
}
function buildRestoreIInkSessionInput(n, i, a) {
  return {
    type: "restoreIInkSession",
    iinkSessionId: a,
    applicationKey: n.recognitionParams.server.applicationKey,
    xDpi: 96,
    yDpi: 96,
    viewSizeHeight: i.clientHeight < n.renderingParams.minHeight ? n.renderingParams.minHeight : i.clientHeight,
    viewSizeWidth: i.clientWidth < n.renderingParams.minWidth ? n.renderingParams.minWidth : i.clientWidth
  };
}
function buildNewContentPart(i) {
  return {
    type: "newContentPart",
    contentType: i.recognitionParams.type,
    mimeTypes: i.triggers.exportContent !== n.Trigger.DEMAND ? i.recognitionParams.iink["".concat(i.recognitionParams.type.toLowerCase())].mimeTypes : void 0
  };
}
function buildOpenContentPart(i, a) {
  return {
    type: "openContentPart",
    id: a,
    mimeTypes: i.triggers.exportContent !== n.Trigger.DEMAND ? i.recognitionParams.iink["".concat(i.recognitionParams.type.toLowerCase())].mimeTypes : void 0
  };
}
function buildConfiguration(n) {
  return Object.assign({
    type: "configuration"
  }, n.recognitionParams.iink);
}
function buildAddStrokes(n, i) {
  var a = extractPendingStrokes(i, n.lastPositions.lastSentPosition + 1);
  if (a.length > 0) return updateModelSentPosition(i), {
    type: "addStrokes",
    strokes: a.map(function (n) {
      return Object.assign({}, {
        id: n.id,
        pointerType: n.pointerType,
        pointerId: n.pointerId,
        x: n.x,
        y: n.y,
        t: n.t,
        p: n.p
      });
    })
  };
}
function buildUndo() {
  return {
    type: "undo"
  };
}
function buildRedo() {
  return {
    type: "redo"
  };
}
function buildClear() {
  return {
    type: "clear"
  };
}
function buildConvert(n) {
  return {
    type: "convert",
    conversionState: n
  };
}
function buildZoom(n) {
  return {
    type: "zoom",
    zoom: n
  };
}
function buildResize(n) {
  var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
  return {
    type: "changeViewSize",
    height: n.clientHeight < i ? i : n.clientHeight,
    width: n.clientWidth < a ? a : n.clientWidth
  };
}
function buildExport(n, i, a) {
  return {
    type: "export",
    partId: i,
    mimeTypes: a && 0 !== Object.keys(a).length ? a : n.recognitionParams.iink["".concat(n.recognitionParams.type.toLowerCase())].mimeTypes
  };
}
function buildImportFile(n, i) {
  return {
    type: "importFile",
    importFileId: n,
    mimeType: i
  };
}
function buildImportChunk(n, i, a) {
  return {
    type: "fileChunk",
    importFileId: n,
    data: i,
    lastChunk: a
  };
}
function buildPointerEvents(n) {
  return Object.assign({
    type: "pointerEvents"
  }, n);
}
function buildWaitForIdle() {
  return {
    type: "waitForIdle"
  };
}
function buildGetSupportedImportMimeTypes() {
  return {
    type: "getSupportedImportMimeTypes"
  };
}
function buildSetPenStyle(n) {
  return {
    type: "setPenStyle",
    style: n ? toCSS(n) : ""
  };
}
function buildSetPenStyleClasses(n) {
  return {
    type: "setPenStyleClasses",
    styleClasses: n
  };
}
function buildSetTheme(n) {
  return {
    type: "setTheme",
    theme: toCSS$1(n)
  };
}
var Ae = function responseCallback(i, a, s, c) {
  var l = updateModelReceivedPosition(i);
  if (s) {
    var u = "";
    return void 0 !== s.updates && (l.recognizedSymbols ? l.recognizedSymbols.push(s) : l.recognizedSymbols = [s], u = n.EventType.RENDERED), void 0 !== s.exports && (l.rawResults.exports = s, l.exports = s.exports, u = n.EventType.EXPORTED), void 0 === s.canUndo && void 0 === s.canRedo || (u = n.EventType.CHANGED), "supportedImportMimeTypes" === s.type && (u = n.EventType.SUPPORTED_IMPORT_MIMETYPES), "partChanged" === s.type && (u = n.EventType.LOADED), "idle" === s.type && (u = n.EventType.IDLE), "close" === s.type && (u = n.EventType.CHANGED), handleSuccess(c.editor, i, u);
  }
  return handleError(c.editor, a);
};
function init$2(n, i) {
  return _init.apply(this, arguments);
}
function _init() {
  return (_init = Y(G.mark(function _callee2(n, i) {
    var a, s, c, l, u, p, h, f, g, m, v, y, b;
    return G.wrap(function _callee2$(x) {
      for (;;) switch (x.prev = x.next) {
        case 0:
          return a = destructurePromise(), s = destructurePromise(), c = destructurePromise(), u = null, "MATH" === n.editor.innerConfiguration.recognitionParams.type || "DIAGRAM" === n.editor.innerConfiguration.recognitionParams.type ? l = setRecognitionContext(n, {
            model: updateModelSentPosition(i, i.lastPositions.lastReceivedPosition),
            partChange: s,
            initPromise: c,
            patch: function patch(n, a) {
              return Ae(i, n, a, l);
            },
            error: function error(n, a) {
              return Ae(i, n, a, l);
            }
          }) : (l = setRecognitionContext(n, {
            model: updateModelSentPosition(i, i.lastPositions.lastReceivedPosition),
            contentChange: a,
            partChange: s,
            response: function response(n, a) {
              return Ae(i, n, a, l);
            },
            initPromise: c,
            patch: function patch(n, a) {
              return Ae(i, n, a, l);
            },
            error: function error(n, a) {
              return Ae(i, n, a, l);
            }
          }), u = l.recognitionContexts[0].contentChange.promise), init$1("/api/v4.0/iink/document", l, buildWebSocketCallback, init$2).catch(function () {
            var a = Y(G.mark(function _callee(a) {
              return G.wrap(function _callee$(s) {
                for (;;) switch (s.prev = s.next) {
                  case 0:
                    if (!shouldAttemptImmediateReconnect(n) || !n.reconnect) {
                      s.next = 6;
                      break;
                    }
                    return d.info("Attempting a reconnect", n.currentReconnectionCount), s.next = 4, n.reconnect(n, i);
                  case 4:
                    s.next = 8;
                    break;
                  case 6:
                    d.error("Unable to reconnect", a), Ae(i, a, void 0, n);
                  case 8:
                  case "end":
                    return s.stop();
                }
              }, _callee);
            }));
            return function (n) {
              return a.apply(this, arguments);
            };
          }()), x.next = 8, l.recognitionContexts[0].partChange.promise;
        case 8:
          if (p = x.sent, h = Te(p, 2), f = h[0], !(g = h[1])) {
            x.next = 23;
            break;
          }
          if (Ae(i, f, g, n), null === u) {
            x.next = 22;
            break;
          }
          return x.next = 17, u;
        case 17:
          m = x.sent, v = Te(m, 2), y = v[0], (b = v[1]) && Ae(i, y, b, n);
        case 22:
          l.recognitionContexts[0].initPromise.resolve(!0);
        case 23:
          return x.abrupt("return", l.recognitionContexts[0].initPromise);
        case 24:
        case "end":
          return x.stop();
      }
    }, _callee2);
  }))).apply(this, arguments);
}
function _prepareMessage(n, i, a) {
  return _prepareMessage2.apply(this, arguments);
}
function _prepareMessage2() {
  return (_prepareMessage2 = Y(G.mark(function _callee3(i, a, s) {
    var c,
      l,
      u,
      p,
      h,
      f,
      g = arguments;
    return G.wrap(function _callee3$(m) {
      for (;;) switch (m.prev = m.next) {
        case 0:
          for (c = g.length, l = new Array(c > 3 ? c - 3 : 0), u = 3; u < c; u++) l[u - 3] = g[u];
          return d.info("-- Prepare message for ".concat(s.name, " --")), p = destructurePromise(), h = setRecognitionContext(i, {
            model: a,
            response: function response(c, l) {
              var u = i.editor.configuration.triggers.exportContent === n.Trigger.DEMAND;
              (!u || u && "buildExport" === s.name) && Ae(a, c, l, h);
            },
            contentChange: p,
            patch: function patch(n, i) {
              return Ae(a, n, i, h);
            },
            error: function error(n, i) {
              return Ae(a, n, i, h);
            }
          }), sendMessage.apply(Re, [h, s].concat(l)).catch(function (n) {
            d.error(n), retry.apply(Re, [_prepareMessage, i, a, s].concat(l));
          }), m.next = 7, h.recognitionContexts[0].contentChange.promise;
        case 7:
          if (!(f = m.sent)) {
            m.next = 11;
            break;
          }
          return Ae(a, f[0], f[1], h), m.abrupt("return", {
            res: a,
            types: []
          });
        case 11:
          return m.abrupt("return", null);
        case 12:
        case "end":
          return m.stop();
      }
    }, _callee3);
  }))).apply(this, arguments);
}
function clear$2(n, i) {
  return _clear.apply(this, arguments);
}
function _clear() {
  return (_clear = Y(G.mark(function _callee5(i, a) {
    var s, c, l;
    return G.wrap(function _callee5$(u) {
      for (;;) switch (u.prev = u.next) {
        case 0:
          return s = destructurePromise(), sendMessage(c = setRecognitionContext(i, {
            model: a,
            response: function response(s, l) {
              i.editor.configuration.triggers.exportContent !== n.Trigger.DEMAND && Ae(a, s, l, c);
            },
            contentChange: s,
            patch: function () {
              var n = Y(G.mark(function _callee4(n, s) {
                var l, u, d;
                return G.wrap(function _callee4$(n) {
                  for (;;) switch (n.prev = n.next) {
                    case 0:
                      return n.next = 2, clear(i, a);
                    case 2:
                      l = n.sent, u = l.err, d = l.res, Ae(d, u, s, c);
                    case 6:
                    case "end":
                      return n.stop();
                  }
                }, _callee4);
              }));
              return function patch(i, a) {
                return n.apply(this, arguments);
              };
            }()
          }), buildClear).catch(function (n) {
            return retry(clear$2, i, a);
          }), u.next = 5, c.recognitionContexts[0].contentChange.promise;
        case 5:
          if (!(l = u.sent)) {
            u.next = 9;
            break;
          }
          return Ae(a, l[0], l[1], c), u.abrupt("return", {
            err: void 0,
            res: c.recognitionContexts[0].model,
            events: []
          });
        case 9:
          return u.abrupt("return", null);
        case 10:
        case "end":
          return u.stop();
      }
    }, _callee5);
  }))).apply(this, arguments);
}
function setPenStyle$1(n, i, a) {
  return _prepareMessage(n, i, buildSetPenStyle, a);
}
function setPenStyleClasses$1(n, i, a) {
  return _prepareMessage(n, i, buildSetPenStyleClasses, a);
}
function setTheme$1(n, i, a) {
  return _prepareMessage(n, i, buildSetTheme, a);
}
var De = Object.freeze({
  __proto__: null,
  IinkWsConfiguration: Le,
  getInfo: function getInfo$5() {
    return Le;
  },
  buildNewContentPackageInput: buildNewContentPackageInput,
  buildRestoreIInkSessionInput: buildRestoreIInkSessionInput,
  buildNewContentPart: buildNewContentPart,
  buildOpenContentPart: buildOpenContentPart,
  buildConfiguration: buildConfiguration,
  buildSetPenStyle: buildSetPenStyle,
  buildSetPenStyleClasses: buildSetPenStyleClasses,
  buildSetTheme: buildSetTheme,
  responseCallback: Ae,
  init: init$2,
  newContentPart: function newContentPart(n, i) {
    return _prepareMessage(n, i, buildNewContentPart, n.editor.configuration);
  },
  openContentPart: function openContentPart(n, i) {
    return _prepareMessage(n, i, buildOpenContentPart, [n.editor.configuration, n.currentPartId]);
  },
  sendConfiguration: function sendConfiguration(n, i) {
    return _prepareMessage(n, i, buildConfiguration, n.editor.configuration);
  },
  pointerEvents: function pointerEvents(n, i, a) {
    return _prepareMessage(n, i, buildPointerEvents, a);
  },
  addStrokes: function addStrokes$1(n, i) {
    var a = [n, i];
    return _prepareMessage.apply(void 0, [n, i, buildAddStrokes].concat(a));
  },
  undo: function undo$1(n, i) {
    return _prepareMessage(n, i, buildUndo);
  },
  redo: function redo$1(n, i) {
    return _prepareMessage(n, i, buildRedo);
  },
  clear: clear$2,
  convert: function convert$1(n, i, a) {
    return _prepareMessage(n, i, buildConvert, a);
  },
  export_: function export_$1(n, i, a) {
    var s = [n.editor.configuration, n.currentPartId, a];
    return _prepareMessage.apply(void 0, [n, i, buildExport].concat(s));
  },
  import_: function import_(n, i, a) {
    for (var s = {
        model: i,
        response: function response(a, s) {
          return Ae(i, a, s, n);
        },
        importFileId: Me.create(4).toString()
      }, c = setRecognitionContext(n, s), l = n.editor.configuration.recognitionParams.server.websocket.fileChunkSize, u = [], d = function _loop(n) {
        0 === n && u.push(_prepareMessage(c, i, buildImportFile, s.importFileId, a.type)), function readBlob(n) {
          var i = this,
            a = new FileReader();
          return new Promise(function (s, c) {
            a.onload = function (n) {
              return s(n.target.result);
            }, a.onerror = function () {
              return c(new Error(i));
            }, a.readAsText(n);
          });
        }(a.slice(n, l, a.type)).then(function (d) {
          var p = [s.importFileId, d, n + l > a.size];
          u.push(_prepareMessage.apply(void 0, [c, i, buildImportChunk].concat(p)));
        });
      }, p = 0; p < a.size; p += l) d(p);
    return Promise.all(u);
  },
  getSupportedImportMimeTypes: function getSupportedImportMimeTypes(n, i) {
    return _prepareMessage(n, i, buildGetSupportedImportMimeTypes);
  },
  waitForIdle: function waitForIdle(n, i) {
    return _prepareMessage(n, i, buildWaitForIdle);
  },
  resize: function resize$4(n, i, a) {
    var s = [a, n.editor.configuration.renderingParams.minHeight, n.editor.configuration.renderingParams.minWidth];
    return _prepareMessage.apply(void 0, [n, i, buildResize].concat(s));
  },
  zoom: function zoom(n, i) {
    var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10;
    return _prepareMessage(n, i, buildZoom, a);
  },
  setPenStyle: setPenStyle$1,
  setPenStyleClasses: setPenStyleClasses$1,
  setTheme: setTheme$1,
  close: close$2
});
var je = {
  grabber: C,
  strokerList: [O, B],
  rendererList: [U, H],
  recognizerList: [ke, De],
  events: function emit(n, i) {
    p.info("emitting ".concat(n, " event"), i), this.dispatchEvent(new CustomEvent(n, Object.assign({
      bubbles: !0,
      composed: !0
    }, i ? {
      detail: i
    } : void 0)));
  },
  getBehaviorFromConfiguration: function getBehaviorFromConfiguration(n, i) {
    var a = {};
    return a.grabber = n.grabber, i && ("REST" === i.recognitionParams.protocol ? (a.stroker = O, a.renderer = U, a.recognizer = ke) : (a.stroker = B, a.renderer = H, a.recognizer = De)), a.events = n.events, a;
  }
};
function register(n, i, a, c, l) {
  return s.debug("Registering a new editor"), new _e(n, i, a, c, l);
}
function getAvailableLanguageList(n) {
  return _getAvailableLanguageList.apply(this, arguments);
}
function _getAvailableLanguageList() {
  return (_getAvailableLanguageList = Y(G.mark(function _callee(n) {
    var i, a;
    return G.wrap(function _callee$(s) {
      for (;;) switch (s.prev = s.next) {
        case 0:
          if (s.prev = 0, !(n && n.recognitionParams && n.recognitionParams.server && n.recognitionParams.server.host)) {
            s.next = 10;
            break;
          }
          return i = n.recognitionParams.server, s.next = 5, fetch("".concat(i.scheme, "://").concat(i.host, "/api/v4.0/iink/availableLanguageList"));
        case 5:
          if (!(a = s.sent) || !a.ok) {
            s.next = 8;
            break;
          }
          return s.abrupt("return", a.json());
        case 8:
          s.next = 11;
          break;
        case 10:
          console.error("Cannot get languages ! Please check your configuration!");
        case 11:
          s.next = 16;
          break;
        case 13:
          s.prev = 13, s.t0 = s.catch(0), console.error(s.t0);
        case 16:
        case "end":
          return s.stop();
      }
    }, _callee, null, [[0, 13]]);
  }))).apply(this, arguments);
}
var Ue = {
  Constants: n,
  DefaultConfiguration: g,
  DefaultBehaviors: je,
  DefaultPenStyle: undefined,
  DefaultTheme: w,
  register: register,
  getAvailableLanguageList: getAvailableLanguageList,
  LoggerConfig: a,
  Editor: _e,
  InkModel: j,
  RecognizerContext: q
};
export default Ue;
export { n as Constants, je as DefaultBehaviors, g as DefaultConfiguration, b as DefaultPenStyle, w as DefaultTheme, _e as Editor, j as InkModel, a as LoggerConfig, q as RecognizerContext, getAvailableLanguageList, register };
